// Constants
const CONSTANTS = {
    FONTS: {
        // BOREL: 'Borel, serif',
        BAKERIE: 'Bakerie, serif',
    },
    MAX_INPUTS: 3,
    DEFAULT_FONT_COLOR: '#000000',
    DEFAULT_BG_COLOR: '#f2f2f2',
    HEART_LENGTH: 3,
    MAX_CHARS: 9,
};

function showLoading(message = "Chargement en cours...") {
    const screen = document.getElementById('loading-screen');
    const msg = document.getElementById('loading-message');
    msg.textContent = message;
    screen.style.display = 'flex';
  }

function hideLoading() {
const screen = document.getElementById('loading-screen');
screen.style.display = 'none';
}

function showModal(message = "Ceci est un message important.") {
const modal = document.getElementById('info-modal');
const msg = document.getElementById('modal-message');
msg.textContent = message;
modal.style.display = 'flex';
}

function hideModal() {
const modal = document.getElementById('info-modal');
modal.style.display = 'none';
}

document.getElementById('close-modal-btn').addEventListener('click', hideModal);


svgCopieDoubleLeft = `
    <svg
        style="height: 700px; margin-left: 75px; margin-right: 20px;"
        id="svg-left"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
    >
        <defs>
            <style>
                .st00, .st11, .st22, .st33 {
                fill: none;
            }

                .st44 {
                fill: #fff;
                stroke: #c7c7c6;
            }

                .st44, .st11, .st22, .st33 {
                stroke-miterlimit: 10;
            }

                .st55 {
                fill: #829ac0;
            }

                .st11 {
                stroke: #29265b;
                stroke-width: .2px;
            }

                .st22 {
                stroke: #829ac0;
                stroke-width: .5px;
            }

                .st33 {
                stroke: #e40d7e;
                stroke-width: .6px;
            }

                .st66 {
                clip-path: url(#clippath);
            }
            </style>
            <clipPath id="clippath">
                <rect class="st00" x="1.6" y="29.2" width="105.9" height="502.6" transform="translate(109.1 561) rotate(-180)"/>
            </clipPath>
        </defs>
        <g class="st66">
            <g>
                <rect class="st44" x="-125.7" y="29.3" width="235.8" height="503.8"/>
                <path class="st22" d="M-84.3,59.6"/>
                <line class="st22" x1="98.8" y1="29.2" x2="98.8" y2="532.6"/>
                <line class="st22" x1="82.8" y1="29.2" x2="82.8" y2="532.6"/>
                <line class="st22" x1="66.8" y1="29.2" x2="66.8" y2="532.6"/>
                <line class="st22" x1="50.9" y1="29.2" x2="50.9" y2="532.6"/>
                <line class="st22" x1="34.8" y1="29.2" x2="34.8" y2="532.6"/>
                <line class="st22" x1="18.8" y1="29.2" x2="18.8" y2="532.6"/>
                <line class="st22" x1="2.8" y1="29.2" x2="2.8" y2="532.6"/>
                <line class="st22" x1="-13.3" y1="29.2" x2="-13.3" y2="532.6"/>
                <line class="st22" x1="-29.2" y1="29.2" x2="-29.2" y2="532.6"/>
                <line class="st22" x1="-45.3" y1="29.2" x2="-45.3" y2="532.6"/>
                <line class="st22" x1="-61.4" y1="29.2" x2="-61.4" y2="532.6"/>
                <line class="st22" x1="-77.4" y1="29.2" x2="-77.4" y2="532.6"/>
                <line class="st22" x1="-125" y1="48.8" x2="109.8" y2="48.8"/>
                <line class="st22" x1="-125" y1="64.9" x2="109.8" y2="64.9"/>
                <line class="st22" x1="-125" y1="80.9" x2="109.8" y2="80.9"/>
                <line class="st22" x1="-125" y1="96.9" x2="109.8" y2="96.9"/>
                <line class="st22" x1="-125" y1="113" x2="109.8" y2="113"/>
                <line class="st22" x1="-125" y1="128.9" x2="109.8" y2="128.9"/>
                <line class="st22" x1="-125" y1="145" x2="109.8" y2="145"/>
                <line class="st22" x1="-125" y1="161.1" x2="109.8" y2="161.1"/>
                <line class="st22" x1="-125" y1="177" x2="109.8" y2="177"/>
                <line class="st22" x1="-125" y1="193.1" x2="109.8" y2="193.1"/>
                <line class="st22" x1="-125" y1="209.2" x2="109.8" y2="209.2"/>
                <line class="st22" x1="-125" y1="225.1" x2="109.8" y2="225.1"/>
                <line class="st22" x1="109.8" y1="52.7" x2="-125.2" y2="53.1"/>
                <line class="st22" x1="109.8" y1="56.7" x2="-125.2" y2="57.1"/>
                <line class="st22" x1="109.8" y1="60.7" x2="-125.2" y2="61.1"/>
                <line class="st22" x1="109.8" y1="68.7" x2="-125.2" y2="69.1"/>
                <line class="st22" x1="109.8" y1="72.7" x2="-125.2" y2="73.1"/>
                <line class="st22" x1="109.8" y1="76.7" x2="-125.2" y2="77.1"/>
                <line class="st22" x1="109.8" y1="84.7" x2="-125.2" y2="85.1"/>
                <line class="st22" x1="109.8" y1="88.7" x2="-125.2" y2="89.1"/>
                <line class="st22" x1="109.8" y1="92.7" x2="-125.2" y2="93.1"/>
                <line class="st22" x1="109.8" y1="100.7" x2="-125.2" y2="101.1"/>
                <line class="st22" x1="109.8" y1="104.7" x2="-125.2" y2="105.1"/>
                <line class="st22" x1="109.8" y1="108.7" x2="-125.2" y2="109.1"/>
                <line class="st22" x1="109.8" y1="116.7" x2="-125.2" y2="117.1"/>
                <line class="st22" x1="109.8" y1="120.7" x2="-125.2" y2="121.1"/>
                <line class="st22" x1="109.8" y1="124.7" x2="-125.2" y2="125.1"/>
                <line class="st22" x1="109.8" y1="132.8" x2="-125.2" y2="133.2"/>
                <line class="st22" x1="109.8" y1="136.7" x2="-125.2" y2="137.1"/>
                <line class="st22" x1="109.8" y1="140.7" x2="-125.2" y2="141.1"/>
                <line class="st22" x1="109.8" y1="148.7" x2="-125.2" y2="149.1"/>
                <line class="st22" x1="109.8" y1="152.7" x2="-125.2" y2="153.1"/>
                <line class="st22" x1="109.8" y1="156.7" x2="-125.2" y2="157.1"/>
                <line class="st22" x1="109.8" y1="164.7" x2="-125.2" y2="165.1"/>
                <line class="st22" x1="109.8" y1="168.7" x2="-125.2" y2="169.1"/>
                <line class="st22" x1="109.8" y1="172.7" x2="-125.2" y2="173.1"/>
                <line class="st22" x1="109.8" y1="180.8" x2="-125.2" y2="181.2"/>
                <line class="st22" x1="109.8" y1="184.7" x2="-125.2" y2="185.1"/>
                <line class="st22" x1="109.8" y1="188.7" x2="-125.2" y2="189.1"/>
                <line class="st22" x1="109.8" y1="196.8" x2="-125.2" y2="197.2"/>
                <line class="st22" x1="109.8" y1="200.7" x2="-125.2" y2="201.1"/>
                <line class="st22" x1="109.8" y1="204.7" x2="-125.2" y2="205.1"/>
                <line class="st22" x1="109.8" y1="212.8" x2="-125.2" y2="213.2"/>
                <line class="st22" x1="109.8" y1="216.7" x2="-125.2" y2="217.1"/>
                <line class="st22" x1="109.8" y1="220.7" x2="-125.2" y2="221.1"/>
                <line class="st22" x1="109.8" y1="228.8" x2="-125.2" y2="229.2"/>
                <line class="st22" x1="-125" y1="241.1" x2="109.8" y2="241.1"/>
                <line class="st22" x1="-125" y1="257.1" x2="109.8" y2="257.1"/>
                <line class="st22" x1="-125" y1="273.2" x2="109.8" y2="273.2"/>
                <line class="st22" x1="-125" y1="289.2" x2="109.8" y2="289.2"/>
                <line class="st22" x1="-125" y1="305.2" x2="109.8" y2="305.2"/>
                <line class="st22" x1="-125" y1="321.2" x2="109.8" y2="321.2"/>
                <line class="st22" x1="-125" y1="337.3" x2="109.8" y2="337.3"/>
                <line class="st22" x1="-125" y1="353.2" x2="109.8" y2="353.2"/>
                <line class="st22" x1="-125" y1="369.3" x2="109.8" y2="369.3"/>
                <line class="st22" x1="-125" y1="385.4" x2="109.8" y2="385.4"/>
                <line class="st22" x1="-125" y1="401.3" x2="109.8" y2="401.3"/>
                <line class="st22" x1="109.8" y1="232.9" x2="-125.2" y2="233.3"/>
                <line class="st22" x1="109.8" y1="236.9" x2="-125.2" y2="237.3"/>
                <line class="st22" x1="109.8" y1="244.9" x2="-125.2" y2="245.3"/>
                <line class="st22" x1="109.8" y1="248.9" x2="-125.2" y2="249.3"/>
                <line class="st22" x1="109.8" y1="252.9" x2="-125.2" y2="253.3"/>
                <line class="st22" x1="109.8" y1="260.9" x2="-125.2" y2="261.3"/>
                <line class="st22" x1="109.8" y1="264.9" x2="-125.2" y2="265.3"/>
                <line class="st22" x1="109.8" y1="268.9" x2="-125.2" y2="269.3"/>
                <line class="st22" x1="109.8" y1="277" x2="-125.2" y2="277.4"/>
                <line class="st22" x1="109.8" y1="280.9" x2="-125.2" y2="281.3"/>
                <line class="st22" x1="109.8" y1="284.9" x2="-125.2" y2="285.3"/>
                <line class="st22" x1="109.8" y1="292.9" x2="-125.2" y2="293.3"/>
                <line class="st22" x1="109.8" y1="296.9" x2="-125.2" y2="297.3"/>
                <line class="st22" x1="109.8" y1="300.9" x2="-125.2" y2="301.3"/>
                <line class="st22" x1="109.8" y1="309" x2="-125.2" y2="309.4"/>
                <line class="st22" x1="109.8" y1="312.9" x2="-125.2" y2="313.3"/>
                <line class="st22" x1="109.8" y1="316.9" x2="-125.2" y2="317.3"/>
                <line class="st22" x1="109.8" y1="325" x2="-125.2" y2="325.3"/>
                <line class="st22" x1="109.8" y1="328.9" x2="-125.2" y2="329.3"/>
                <line class="st22" x1="109.8" y1="332.9" x2="-125.2" y2="333.3"/>
                <line class="st22" x1="109.8" y1="341" x2="-125.2" y2="341.4"/>
                <line class="st22" x1="109.8" y1="344.9" x2="-125.2" y2="345.3"/>
                <line class="st22" x1="109.8" y1="348.9" x2="-125.2" y2="349.3"/>
                <line class="st22" x1="109.8" y1="357" x2="-125.2" y2="357.4"/>
                <line class="st22" x1="109.8" y1="360.9" x2="-125.2" y2="361.3"/>
                <line class="st22" x1="109.8" y1="364.9" x2="-125.2" y2="365.3"/>
                <line class="st22" x1="109.8" y1="373" x2="-125.2" y2="373.4"/>
                <line class="st22" x1="109.8" y1="377" x2="-125.2" y2="377.4"/>
                <line class="st22" x1="109.8" y1="380.9" x2="-125.2" y2="381.3"/>
                <line class="st22" x1="109.8" y1="389" x2="-125.2" y2="389.4"/>
                <line class="st22" x1="109.8" y1="393" x2="-125.2" y2="393.4"/>
                <line class="st22" x1="109.8" y1="396.9" x2="-125.2" y2="397.3"/>
                <line class="st22" x1="109.8" y1="405" x2="-125.2" y2="405.4"/>
                <line class="st22" x1="109.8" y1="409" x2="-125.2" y2="409.4"/>
                <line class="st22" x1="109.8" y1="412.9" x2="-125.2" y2="413.3"/>
                <line class="st22" x1="-77.4" y1="532.7" x2="-77.4" y2="29.3"/>
                <line class="st22" x1="-93.5" y1="29.2" x2="-93.1" y2="532.6"/>
                <line class="st22" x1="-109.5" y1="29.2" x2="-109.2" y2="532.7"/>
                <line class="st22" x1="-125" y1="417.3" x2="109.8" y2="417.3"/>
                <line class="st22" x1="-125" y1="433.3" x2="109.8" y2="433.3"/>
                <line class="st22" x1="-125" y1="449.3" x2="109.8" y2="449.3"/>
                <line class="st22" x1="-125" y1="465.4" x2="109.8" y2="465.4"/>
                <line class="st22" x1="-125" y1="481.4" x2="109.8" y2="481.4"/>
                <line class="st22" x1="-125" y1="497.4" x2="109.8" y2="497.4"/>
                <line class="st22" x1="-125" y1="513.5" x2="109.8" y2="513.5"/>
                <line class="st22" x1="109.8" y1="421.1" x2="-125.2" y2="421.5"/>
                <line class="st22" x1="109.8" y1="425.1" x2="-125.2" y2="425.5"/>
                <line class="st22" x1="109.8" y1="429.1" x2="-125.2" y2="429.5"/>
                <line class="st22" x1="109.8" y1="437.1" x2="-125.2" y2="437.5"/>
                <line class="st22" x1="109.8" y1="441.1" x2="-125.2" y2="441.5"/>
                <line class="st22" x1="109.8" y1="445.1" x2="-125.2" y2="445.5"/>
                <line class="st22" x1="109.8" y1="453.2" x2="-125.2" y2="453.6"/>
                <line class="st22" x1="109.8" y1="457.1" x2="-125.2" y2="457.5"/>
                <line class="st22" x1="109.8" y1="461.1" x2="-125.2" y2="461.5"/>
                <line class="st22" x1="109.8" y1="469.1" x2="-125.2" y2="469.5"/>
                <line class="st22" x1="109.8" y1="473.1" x2="-125.2" y2="473.5"/>
                <line class="st22" x1="109.8" y1="477.1" x2="-125.2" y2="477.5"/>
                <line class="st22" x1="109.8" y1="485.2" x2="-125.2" y2="485.6"/>
                <line class="st22" x1="109.8" y1="489.1" x2="-125.2" y2="489.5"/>
                <line class="st22" x1="109.8" y1="493.1" x2="-125.2" y2="493.5"/>
                <line class="st22" x1="109.8" y1="501.1" x2="-125.2" y2="501.5"/>
                <line class="st22" x1="109.8" y1="505.1" x2="-125.2" y2="505.5"/>
                <line class="st22" x1="109.8" y1="509.1" x2="-125.2" y2="509.5"/>
                <line class="st11" x1="109.8" y1="533.2" x2="-125.2" y2="533.6"/>
            </g>
        </g>
        <polygon class="st55" points="101.8 29.2 84.8 29.2 67.8 29.2 50.8 29.2 33.8 29.2 16.8 29.2 1.3 29.2 1.3 31.5 .3 31.5 3 .5 105.7 .5 107.5 29.2 101.8 29.2 101.8 29.2"/>
        <path class="st55" d="M33.2,531.8h17.4s17.4,0,17.4,0h17.4s1,0,1,0h17.4s4.4,0,4.4,0c-5.2,8.1-22.8,30.9-56.3,30.9-33.3,0-46.6-22.7-50.3-30.9h14.3s17.4,0,17.4,0Z"/>
        <path class="st55" d="M60.9,337l46.1,44.2s30.2-48.6,0-92.3l-46.1,48.1Z"/>
        <foreignObject x="7.8" y="105.8" width="100" height="200" id="left-group">
            
        </foreignObject>
    </svg>
    `;

svgCopieDoubleRight = `
    <svg
        style="height: 700px; margin-left: 20px; margin-right: 75px;transform: scaleX(-1); transform-origin: center"
        id="svg-right"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
    >
        <defs>
            <style>
                .st00, .st11, .st22, .st33 {
                fill: none;
            }

                .st44 {
                fill: #fff;
                stroke: #c7c7c6;
            }

                .st44, .st11, .st22, .st33 {
                stroke-miterlimit: 10;
            }

                .st55 {
                fill: #829ac0;
            }

                .st11 {
                stroke: #29265b;
                stroke-width: .2px;
            }

                .st22 {
                stroke: #829ac0;
                stroke-width: .5px;
            }

                .st33 {
                stroke: #e40d7e;
                stroke-width: .6px;
            }

                .st66 {
                clip-path: url(#clippath);
            }
            </style>
            <clipPath id="clippath">
                <rect class="st00" x="1.6" y="29.2" width="105.9" height="502.6" transform="translate(109.1 561) rotate(-180)"/>
            </clipPath>
        </defs>
        <g class="st66">
            <g>
                <rect class="st44" x="-125.7" y="29.3" width="235.8" height="503.8"/>
                <path class="st22" d="M-84.3,59.6"/>
                <line class="st33" x1="66.8" y1="29.2" x2="66.8" y2="532.6"/>
                <line class="st22" x1="50.9" y1="29.2" x2="50.9" y2="532.6"/>
                <line class="st22" x1="34.8" y1="29.2" x2="34.8" y2="532.6"/>
                <line class="st22" x1="18.8" y1="29.2" x2="18.8" y2="532.6"/>
                <line class="st22" x1="2.8" y1="29.2" x2="2.8" y2="532.6"/>
                <line class="st22" x1="-13.3" y1="29.2" x2="-13.3" y2="532.6"/>
                <line class="st22" x1="-29.2" y1="29.2" x2="-29.2" y2="532.6"/>
                <line class="st22" x1="-45.3" y1="29.2" x2="-45.3" y2="532.6"/>
                <line class="st22" x1="-61.4" y1="29.2" x2="-61.4" y2="532.6"/>
                <line class="st22" x1="-77.4" y1="29.2" x2="-77.4" y2="532.6"/>
                <line class="st22" x1="-125" y1="48.8" x2="109.8" y2="48.8"/>
                <line class="st22" x1="-125" y1="64.9" x2="109.8" y2="64.9"/>
                <line class="st22" x1="-125" y1="80.9" x2="109.8" y2="80.9"/>
                <line class="st22" x1="-125" y1="96.9" x2="109.8" y2="96.9"/>
                <line class="st22" x1="-125" y1="113" x2="109.8" y2="113"/>
                <line class="st22" x1="-125" y1="128.9" x2="109.8" y2="128.9"/>
                <line class="st22" x1="-125" y1="145" x2="109.8" y2="145"/>
                <line class="st22" x1="-125" y1="161.1" x2="109.8" y2="161.1"/>
                <line class="st22" x1="-125" y1="177" x2="109.8" y2="177"/>
                <line class="st22" x1="-125" y1="193.1" x2="109.8" y2="193.1"/>
                <line class="st22" x1="-125" y1="209.2" x2="109.8" y2="209.2"/>
                <line class="st22" x1="-125" y1="225.1" x2="109.8" y2="225.1"/>
                <line class="st22" x1="109.8" y1="52.7" x2="-125.2" y2="53.1"/>
                <line class="st22" x1="109.8" y1="56.7" x2="-125.2" y2="57.1"/>
                <line class="st22" x1="109.8" y1="60.7" x2="-125.2" y2="61.1"/>
                <line class="st22" x1="109.8" y1="68.7" x2="-125.2" y2="69.1"/>
                <line class="st22" x1="109.8" y1="72.7" x2="-125.2" y2="73.1"/>
                <line class="st22" x1="109.8" y1="76.7" x2="-125.2" y2="77.1"/>
                <line class="st22" x1="109.8" y1="84.7" x2="-125.2" y2="85.1"/>
                <line class="st22" x1="109.8" y1="88.7" x2="-125.2" y2="89.1"/>
                <line class="st22" x1="109.8" y1="92.7" x2="-125.2" y2="93.1"/>
                <line class="st22" x1="109.8" y1="100.7" x2="-125.2" y2="101.1"/>
                <line class="st22" x1="109.8" y1="104.7" x2="-125.2" y2="105.1"/>
                <line class="st22" x1="109.8" y1="108.7" x2="-125.2" y2="109.1"/>
                <line class="st22" x1="109.8" y1="116.7" x2="-125.2" y2="117.1"/>
                <line class="st22" x1="109.8" y1="120.7" x2="-125.2" y2="121.1"/>
                <line class="st22" x1="109.8" y1="124.7" x2="-125.2" y2="125.1"/>
                <line class="st22" x1="109.8" y1="132.8" x2="-125.2" y2="133.2"/>
                <line class="st22" x1="109.8" y1="136.7" x2="-125.2" y2="137.1"/>
                <line class="st22" x1="109.8" y1="140.7" x2="-125.2" y2="141.1"/>
                <line class="st22" x1="109.8" y1="148.7" x2="-125.2" y2="149.1"/>
                <line class="st22" x1="109.8" y1="152.7" x2="-125.2" y2="153.1"/>
                <line class="st22" x1="109.8" y1="156.7" x2="-125.2" y2="157.1"/>
                <line class="st22" x1="109.8" y1="164.7" x2="-125.2" y2="165.1"/>
                <line class="st22" x1="109.8" y1="168.7" x2="-125.2" y2="169.1"/>
                <line class="st22" x1="109.8" y1="172.7" x2="-125.2" y2="173.1"/>
                <line class="st22" x1="109.8" y1="180.8" x2="-125.2" y2="181.2"/>
                <line class="st22" x1="109.8" y1="184.7" x2="-125.2" y2="185.1"/>
                <line class="st22" x1="109.8" y1="188.7" x2="-125.2" y2="189.1"/>
                <line class="st22" x1="109.8" y1="196.8" x2="-125.2" y2="197.2"/>
                <line class="st22" x1="109.8" y1="200.7" x2="-125.2" y2="201.1"/>
                <line class="st22" x1="109.8" y1="204.7" x2="-125.2" y2="205.1"/>
                <line class="st22" x1="109.8" y1="212.8" x2="-125.2" y2="213.2"/>
                <line class="st22" x1="109.8" y1="216.7" x2="-125.2" y2="217.1"/>
                <line class="st22" x1="109.8" y1="220.7" x2="-125.2" y2="221.1"/>
                <line class="st22" x1="109.8" y1="228.8" x2="-125.2" y2="229.2"/>
                <line class="st22" x1="-125" y1="241.1" x2="109.8" y2="241.1"/>
                <line class="st22" x1="-125" y1="257.1" x2="109.8" y2="257.1"/>
                <line class="st22" x1="-125" y1="273.2" x2="109.8" y2="273.2"/>
                <line class="st22" x1="-125" y1="289.2" x2="109.8" y2="289.2"/>
                <line class="st22" x1="-125" y1="305.2" x2="109.8" y2="305.2"/>
                <line class="st22" x1="-125" y1="321.2" x2="109.8" y2="321.2"/>
                <line class="st22" x1="-125" y1="337.3" x2="109.8" y2="337.3"/>
                <line class="st22" x1="-125" y1="353.2" x2="109.8" y2="353.2"/>
                <line class="st22" x1="-125" y1="369.3" x2="109.8" y2="369.3"/>
                <line class="st22" x1="-125" y1="385.4" x2="109.8" y2="385.4"/>
                <line class="st22" x1="-125" y1="401.3" x2="109.8" y2="401.3"/>
                <line class="st22" x1="109.8" y1="232.9" x2="-125.2" y2="233.3"/>
                <line class="st22" x1="109.8" y1="236.9" x2="-125.2" y2="237.3"/>
                <line class="st22" x1="109.8" y1="244.9" x2="-125.2" y2="245.3"/>
                <line class="st22" x1="109.8" y1="248.9" x2="-125.2" y2="249.3"/>
                <line class="st22" x1="109.8" y1="252.9" x2="-125.2" y2="253.3"/>
                <line class="st22" x1="109.8" y1="260.9" x2="-125.2" y2="261.3"/>
                <line class="st22" x1="109.8" y1="264.9" x2="-125.2" y2="265.3"/>
                <line class="st22" x1="109.8" y1="268.9" x2="-125.2" y2="269.3"/>
                <line class="st22" x1="109.8" y1="277" x2="-125.2" y2="277.4"/>
                <line class="st22" x1="109.8" y1="280.9" x2="-125.2" y2="281.3"/>
                <line class="st22" x1="109.8" y1="284.9" x2="-125.2" y2="285.3"/>
                <line class="st22" x1="109.8" y1="292.9" x2="-125.2" y2="293.3"/>
                <line class="st22" x1="109.8" y1="296.9" x2="-125.2" y2="297.3"/>
                <line class="st22" x1="109.8" y1="300.9" x2="-125.2" y2="301.3"/>
                <line class="st22" x1="109.8" y1="309" x2="-125.2" y2="309.4"/>
                <line class="st22" x1="109.8" y1="312.9" x2="-125.2" y2="313.3"/>
                <line class="st22" x1="109.8" y1="316.9" x2="-125.2" y2="317.3"/>
                <line class="st22" x1="109.8" y1="325" x2="-125.2" y2="325.3"/>
                <line class="st22" x1="109.8" y1="328.9" x2="-125.2" y2="329.3"/>
                <line class="st22" x1="109.8" y1="332.9" x2="-125.2" y2="333.3"/>
                <line class="st22" x1="109.8" y1="341" x2="-125.2" y2="341.4"/>
                <line class="st22" x1="109.8" y1="344.9" x2="-125.2" y2="345.3"/>
                <line class="st22" x1="109.8" y1="348.9" x2="-125.2" y2="349.3"/>
                <line class="st22" x1="109.8" y1="357" x2="-125.2" y2="357.4"/>
                <line class="st22" x1="109.8" y1="360.9" x2="-125.2" y2="361.3"/>
                <line class="st22" x1="109.8" y1="364.9" x2="-125.2" y2="365.3"/>
                <line class="st22" x1="109.8" y1="373" x2="-125.2" y2="373.4"/>
                <line class="st22" x1="109.8" y1="377" x2="-125.2" y2="377.4"/>
                <line class="st22" x1="109.8" y1="380.9" x2="-125.2" y2="381.3"/>
                <line class="st22" x1="109.8" y1="389" x2="-125.2" y2="389.4"/>
                <line class="st22" x1="109.8" y1="393" x2="-125.2" y2="393.4"/>
                <line class="st22" x1="109.8" y1="396.9" x2="-125.2" y2="397.3"/>
                <line class="st22" x1="109.8" y1="405" x2="-125.2" y2="405.4"/>
                <line class="st22" x1="109.8" y1="409" x2="-125.2" y2="409.4"/>
                <line class="st22" x1="109.8" y1="412.9" x2="-125.2" y2="413.3"/>
                <line class="st22" x1="-77.4" y1="532.7" x2="-77.4" y2="29.3"/>
                <line class="st22" x1="-93.5" y1="29.2" x2="-93.1" y2="532.6"/>
                <line class="st22" x1="-109.5" y1="29.2" x2="-109.2" y2="532.7"/>
                <line class="st22" x1="-125" y1="417.3" x2="109.8" y2="417.3"/>
                <line class="st22" x1="-125" y1="433.3" x2="109.8" y2="433.3"/>
                <line class="st22" x1="-125" y1="449.3" x2="109.8" y2="449.3"/>
                <line class="st22" x1="-125" y1="465.4" x2="109.8" y2="465.4"/>
                <line class="st22" x1="-125" y1="481.4" x2="109.8" y2="481.4"/>
                <line class="st22" x1="-125" y1="497.4" x2="109.8" y2="497.4"/>
                <line class="st22" x1="-125" y1="513.5" x2="109.8" y2="513.5"/>
                <line class="st22" x1="109.8" y1="421.1" x2="-125.2" y2="421.5"/>
                <line class="st22" x1="109.8" y1="425.1" x2="-125.2" y2="425.5"/>
                <line class="st22" x1="109.8" y1="429.1" x2="-125.2" y2="429.5"/>
                <line class="st22" x1="109.8" y1="437.1" x2="-125.2" y2="437.5"/>
                <line class="st22" x1="109.8" y1="441.1" x2="-125.2" y2="441.5"/>
                <line class="st22" x1="109.8" y1="445.1" x2="-125.2" y2="445.5"/>
                <line class="st22" x1="109.8" y1="453.2" x2="-125.2" y2="453.6"/>
                <line class="st22" x1="109.8" y1="457.1" x2="-125.2" y2="457.5"/>
                <line class="st22" x1="109.8" y1="461.1" x2="-125.2" y2="461.5"/>
                <line class="st22" x1="109.8" y1="469.1" x2="-125.2" y2="469.5"/>
                <line class="st22" x1="109.8" y1="473.1" x2="-125.2" y2="473.5"/>
                <line class="st22" x1="109.8" y1="477.1" x2="-125.2" y2="477.5"/>
                <line class="st22" x1="109.8" y1="485.2" x2="-125.2" y2="485.6"/>
                <line class="st22" x1="109.8" y1="489.1" x2="-125.2" y2="489.5"/>
                <line class="st22" x1="109.8" y1="493.1" x2="-125.2" y2="493.5"/>
                <line class="st22" x1="109.8" y1="501.1" x2="-125.2" y2="501.5"/>
                <line class="st22" x1="109.8" y1="505.1" x2="-125.2" y2="505.5"/>
                <line class="st22" x1="109.8" y1="509.1" x2="-125.2" y2="509.5"/>
                <line class="st11" x1="109.8" y1="533.2" x2="-125.2" y2="533.6"/>
            </g>
        </g>
        <polygon class="st55" points="101.8 29.2 84.8 29.2 67.8 29.2 50.8 29.2 33.8 29.2 16.8 29.2 1.3 29.2 1.3 31.5 .3 31.5 3 .5 105.7 .5 107.5 29.2 101.8 29.2 101.8 29.2"/>
        <path class="st55" d="M33.2,531.8h17.4s17.4,0,17.4,0h17.4s1,0,1,0h17.4s4.4,0,4.4,0c-5.2,8.1-22.8,30.9-56.3,30.9-33.3,0-46.6-22.7-50.3-30.9h14.3s17.4,0,17.4,0Z"/>
        <path class="st55" d="M60.9,337l46.1,44.2s30.2-48.6,0-92.3l-46.1,48.1Z"/>
        <foreignObject x="24" y="105.8" width="100" height="200" id="right-group" style="transform:scaleX(-1);transform-origin:center;">
            
        </foreignObject>
    </svg>
    `;

svgUnieLeft = `
    <svg
        style="height: 700px; margin-left: 75px; margin-right: 20px;"
        id="svg-left"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
        onmouseover="displayAddNewLine('left')"
    >
        <g>
            <path id="orteils" class="st2"
                  d="M111.9,537.1v.2s-23.4,30.8-56.7,30.6c-32.3-.2-50.2-30.6-50.2-30.6v-.2h106.9Z"/>
            <polygon id="bord-cote" class="st2"
                     points="111.8 32.1 5.2 32.1 7 4 110.3 4.7 111.8 32.1"/>
            <polygon id="fond" class="st1"
                     points="111.9 33.5 111.9 291.6 66.9 338 111.9 381.7 111.9 537.1 5 537.1 5 33.5 5.1 33.5 5.2 32.1 111.8 32.1 111.9 33.5 111.9 33.5"/>
            <path id="Talon" class="st1"
                  d="M111.7,382.5l-.8-.8-45-43.7,45-46.4,1.4-1.4c29.9,43.9-.6,92.3-.6,92.3Z"/>
            <foreignObject x="7.8" y="105.8" width="100" height="200" id="left-group">
                <div
                                                style="width: 100%; height: 100%;margin-top: 15px; display: flex; flex-direction: column; justify-content: start">
                                            <div
                                                    style="height: 75px;display: flex; flex-direction: column; align-items: center; justify-content: center">
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-firstLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >Votre</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-secondLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >blabla</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-thirdLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9);"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this); "
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >ici</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                            </div>
                                            <div class="add-line-button" id="add-heart-left"
                                                 onclick="addHeart('left-group')"
                                                 style="display: block;">
                                                Ajouter un coeur
                                            </div>
                                            <div class="add-line-button" id="add-line-left-group"
                                                 onclick="addInput('left-group')"
                                                 style="display: none;">
                                                Ajouter une ligne
                                            </div>
                                        </div>
            </foreignObject>
        </g>
    </svg>
    `;

svgUnieRight = `
    <svg
        style="height: 700px; margin-left: 20px; margin-right: 75px;"
        id="svg-right"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
    >
        <g>
            <path id="orteils-right" class="st2"
                  d="M18.5,537.1v.2s23.4,30.8,56.7,30.6c32.3-.2,50.2-30.6,50.2-30.6v-.2s-106.9,0-106.9,0Z"/>
            <polygon id="bord-cote-right" class="st2"
                     points="18.7 32.1 125.3 32.1 123.5 4 20.2 4.7 18.7 32.1"/>
            <polygon id="fond-right" class="st1"
                     points="18.5 33.5 18.5 291.6 63.5 338 18.5 381.7 18.5 537.1 125.5 537.1 125.5 33.5 125.4 33.5 125.3 32.1 18.7 32.1 18.6 33.5 18.5 33.5"/>
            <path id="Talon-right" class="st1"
                  d="M18.7,382.5l.8-.8,45-43.7-45-46.4-1.4-1.4c-29.9,43.9.6,92.3.6,92.3Z"/>
            <foreignObject x="21" y="105.8" width="100" height="200" id="right-group">
                <div
                                                style="width: 100%; height: 100%;margin-top: 15px; display: flex; flex-direction: column; justify-content: start">
                                            <div
                                                    style="height: 75px;display: flex; flex-direction: column; align-items: center; justify-content: center">
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-firstLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >Votre</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-secondLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >blablabla</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-thirdLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="ceNormalizeAfterInput(this, 9); adjustFontSize(this)"
                                                            onchange="ceNormalizeAfterInput(this, 9); adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >ici</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                            </div>
                                            <div class="add-line-button" id="add-heart-right"
                                                 onclick="addHeart('right-group')"
                                                 style="display: block;">
                                                Ajouter un coeur
                                            </div>
                                            <div class="add-line-button" id="add-line-right-group"
                                                 onclick="addInput('right-group')"
                                                 style="display: none;">
                                                Ajouter une ligne
                                            </div>
                                        </div>
            </foreignObject>
        </g>
    </svg>
    `;

svgNuageLeft = `
    <svg
        style="height: 700px; margin-left: 75px; margin-right: 20px;"
        id="svg-left"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
    >
        <defs>
            <style>
                .st0, .st1, .st2 {
                fill: none;
            }

                .st3 {
                fill: #be1622;
            }

                .st4 {
                fill: #fff;
            }

                .st1 {
                stroke: #003973;
                stroke-width: .7px;
            }

                .st1, .st2 {
                stroke-miterlimit: 10;
            }

                .st5 {
                fill: #f3cbe2;
            }

                .st6 {
                clip-path: url(#clippath);
            }

                .st2 {
                stroke: #2e509f;
                stroke-width: .5px;
            }
            </style>
            <clipPath id="clippath">
                <rect class="st0" x=".5" y="31" width="106.9" height="499.3" transform="translate(108 561.3) rotate(-180)"/>
            </clipPath>
        </defs>
        <g class="st6">
            <g>
                <rect class="st5" x="-1" y="0" width="118.6" height="561.6"/>
                <path class="st2" d="M51.9,128.5"/>
                <path class="st1" d="M51.9,128.9"/>
                <path class="st2" d="M64.6,128.5"/>
                <path class="st1" d="M61,128.9"/>
                <path class="st2" d="M51.9,375.7"/>
                <path class="st1" d="M51.9,376.1"/>
                <path class="st2" d="M64.6,375.7"/>
                <path class="st1" d="M61,376.1"/>
                <path class="st2" d="M51.9,252.1"/>
                <path class="st1" d="M51.9,252.5"/>
                <path class="st2" d="M64.6,252.1"/>
                <path class="st1" d="M61,252.5"/>
                <path class="st2" d="M51.9,375.7"/>
                <path class="st1" d="M51.9,376.1"/>
                <path class="st2" d="M64.6,375.7"/>
                <path class="st1" d="M61,376.1"/>
                <path class="st2" d="M51.9,499.3"/>
                <path class="st1" d="M51.9,499.7"/>
                <path class="st2" d="M64.6,499.3"/>
                <path class="st1" d="M61,499.7"/>
                <path class="st4" d="M-42-1c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,0c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M24,55.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,241.8"/>
                <path class="st1" d="M51.9,242.2"/>
                <path class="st2" d="M64.6,241.8"/>
                <path class="st1" d="M61,242.2"/>
                <path class="st4" d="M-42,115.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,116.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M23,190c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,355.1"/>
                <path class="st1" d="M51.9,355.5"/>
                <path class="st2" d="M64.6,355.1"/>
                <path class="st1" d="M61,355.5"/>
                <path class="st4" d="M-42,239.5c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,240.5c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M27,302.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,468.4"/>
                <path class="st1" d="M51.9,468.8"/>
                <path class="st2" d="M64.6,468.4"/>
                <path class="st1" d="M61,468.8"/>
                <path class="st4" d="M-41,362.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M92.1,363.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M-41,488.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M92.1,489.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M28,425.6c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
            </g>
        </g>
        <polygon class="st3" points="101.3 30 84.3 30 67.3 30 50.3 30 33.3 30 16.3 30 .8 30 .8 32.3 -.3 32.3 2.5 1.3 105.1 1.3 107 30 101.3 30 101.3 30"/>
        <path class="st3" d="M31.7,529.3h17.4s17.4,0,17.4,0h17.4s1,0,1,0h17.4s4.4,0,4.4,0c-5.2,8.1-22.8,30.9-56.3,30.9-33.3,0-46.6-22.7-50.3-30.9h14.3s17.4,0,17.4,0Z"/>
        <path class="st3" d="M61.2,334.9l46.1,44.2s30.2-48.6,0-92.3l-46.1,48.1Z"/>
        <foreignObject x="0.8" y="70.8" width="100" height="200" id="left-group">
            <div
                                                style="width: 100%; height: 100%;margin-top: 15px; display: flex; flex-direction: column; justify-content: start">
                                            <div
                                                    style="height: 75px;display: flex; flex-direction: column; align-items: center; justify-content: center">
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-firstLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >VOTRE</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-secondLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >blablabla</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-left-group"
                                                            id="left-thirdLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9);"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this); "
                                                            onfocus="handlePlaceholder(this, 'left-group')"
                                                            onblur="restorePlaceholder(this, 'left-group')"
                                                    >ICI</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                            </div>
                                            <div class="add-line-button" id="add-heart-left"
                                                 onclick="addHeart('left-group')"
                                                 style="display: block;">
                                                Ajouter un coeur
                                            </div>
                                            <div class="add-line-button" id="add-line-left-group"
                                                 onclick="addInput('left-group')"
                                                 style="display: none;">
                                                Ajouter une ligne
                                            </div>
                                        </div>
        </foreignObject>
    </svg>
    `;

svgNuageRight = `
    <svg
        style="height: 700px; margin-left: 20px; margin-right: 75px;transform: scaleX(-1); transform-origin: center"
        id="svg-right"
        xmlns="http://www.w3.org/2000/svg"
        version="1.1"
        viewBox="0 0 129.9 572.3"
    >
        <defs>
            <style>
                .st0, .st1, .st2 {
                fill: none;
            }

                .st3 {
                fill: #be1622;
            }

                .st4 {
                fill: #fff;
            }

                .st1 {
                stroke: #003973;
                stroke-width: .7px;
            }

                .st1, .st2 {
                stroke-miterlimit: 10;
            }

                .st5 {
                fill: #f3cbe2;
            }

                .st6 {
                clip-path: url(#clippath);
            }

                .st2 {
                stroke: #2e509f;
                stroke-width: .5px;
            }
            </style>
            <clipPath id="clippath">
                <rect class="st0" x=".5" y="31" width="106.9" height="499.3" transform="translate(108 561.3) rotate(-180)"/>
            </clipPath>
        </defs>
        <g class="st6">
            <g>
                <rect class="st5" x="-1" y="0" width="118.6" height="561.6"/>
                <path class="st2" d="M51.9,128.5"/>
                <path class="st1" d="M51.9,128.9"/>
                <path class="st2" d="M64.6,128.5"/>
                <path class="st1" d="M61,128.9"/>
                <path class="st2" d="M51.9,375.7"/>
                <path class="st1" d="M51.9,376.1"/>
                <path class="st2" d="M64.6,375.7"/>
                <path class="st1" d="M61,376.1"/>
                <path class="st2" d="M51.9,252.1"/>
                <path class="st1" d="M51.9,252.5"/>
                <path class="st2" d="M64.6,252.1"/>
                <path class="st1" d="M61,252.5"/>
                <path class="st2" d="M51.9,375.7"/>
                <path class="st1" d="M51.9,376.1"/>
                <path class="st2" d="M64.6,375.7"/>
                <path class="st1" d="M61,376.1"/>
                <path class="st2" d="M51.9,499.3"/>
                <path class="st1" d="M51.9,499.7"/>
                <path class="st2" d="M64.6,499.3"/>
                <path class="st1" d="M61,499.7"/>
                <path class="st4" d="M-42-1c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,0c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M24,55.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,241.8"/>
                <path class="st1" d="M51.9,242.2"/>
                <path class="st2" d="M64.6,241.8"/>
                <path class="st1" d="M61,242.2"/>
                <path class="st4" d="M-42,115.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,116.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M23,190c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,355.1"/>
                <path class="st1" d="M51.9,355.5"/>
                <path class="st2" d="M64.6,355.1"/>
                <path class="st1" d="M61,355.5"/>
                <path class="st4" d="M-42,239.5c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M91.1,240.5c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M27,302.3c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st2" d="M51.9,468.4"/>
                <path class="st1" d="M51.9,468.8"/>
                <path class="st2" d="M64.6,468.4"/>
                <path class="st1" d="M61,468.8"/>
                <path class="st4" d="M-41,362.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M92.1,363.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M-41,488.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M92.1,489.8c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
                <path class="st4" d="M28,425.6c0,3.7,1.3,6.8,4.1,9.3,3,2.6,6.9,3,10.4,1.2.6-.3.7-.2,1.1.4,1.9,2.9,4.6,4.7,8.1,5.2,3.6.5,6.7-.6,9.3-3,.6-.6.6-.6,1.3-.1,3.3,2,6.9,2.7,10.7,2.4,3.2-.3,6.1-1.2,8.6-3.3.8-.7,1.3-.7,2.2-.3,5.9,2.4,12.4-1,13.5-7,1-5.2-2.6-10.3-8-11.1-1.3-.2-2.6-.2-3.9,0-.7.1-.8,0-1-.6-1.4-6.1-7.3-10.3-13.6-9.5-1.1.1-2.2.5-3.3.8-.9.3-.9.3-1.3-.6-1.6-3.9-4.3-6.8-8.2-8.4-5.8-2.4-12.4-.8-16.5,4.1-2,2.4-3.2,5.2-3.7,8.3,0,.4-.2.6-.6.7-4.3.5-7,3-8.6,6.8-.7,1.5-.9,3.1-.9,4.8Z"/>
            </g>
        </g>
        <polygon class="st3" points="101.3 30 84.3 30 67.3 30 50.3 30 33.3 30 16.3 30 .8 30 .8 32.3 -.3 32.3 2.5 1.3 105.1 1.3 107 30 101.3 30 101.3 30"/>
        <path class="st3" d="M31.7,529.3h17.4s17.4,0,17.4,0h17.4s1,0,1,0h17.4s4.4,0,4.4,0c-5.2,8.1-22.8,30.9-56.3,30.9-33.3,0-46.6-22.7-50.3-30.9h14.3s17.4,0,17.4,0Z"/>
        <path class="st3" d="M61.2,334.9l46.1,44.2s30.2-48.6,0-92.3l-46.1,48.1Z"/>
        <foreignObject x="24" y="70.8" width="100" height="200" id="right-group" style="transform:scaleX(-1);transform-origin:center;">
            <div
                                                style="width: 100%; height: 100%;margin-top: 15px; display: flex; flex-direction: column; justify-content: start">
                                            <div
                                                    style="height: 75px;display: flex; flex-direction: column; align-items: center; justify-content: center">
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-firstLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >VOTRE</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-secondLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="adjustFontSize(this)"
                                                            onchange="adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >BLABLABLA</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                                <div class="input-container">
                                                    <div
                                                            class="input-text-div-editcontent div-input-content-right-group"
                                                            id="right-thirdLine"
                                                            contenteditable="true"
                                                            data-is-modified="false"
                                                            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
                                                            oninput="ceNormalizeAfterInput(this, 9); adjustFontSize(this)"
                                                            onchange="ceNormalizeAfterInput(this, 9); adjustFontSize(this)"
                                                            onfocus="handlePlaceholder(this, 'right-group')"
                                                            onblur="restorePlaceholder(this, 'right-group')"
                                                    >ICI</div>
                                                    <span class="delete-button" onclick="deleteInput(this)">×</span>
                                                </div>
                                            </div>
                                            <div class="add-line-button" id="add-heart-right"
                                                 onclick="addHeart('right-group')"
                                                 style="display: block;">
                                                Ajouter un coeur
                                            </div>
                                            <div class="add-line-button" id="add-line-right-group"
                                                 onclick="addInput('right-group')"
                                                 style="display: none;">
                                                Ajouter une ligne
                                            </div>
                                        </div>
        </foreignObject>
    </svg>
    `;

    svgComplementTimbreLeft = `
    <svg
                                    style="height: 700px; margin-left: 75px; margin-right: 20px;"
                                    id="svg-left"
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    viewBox="0 0 129.9 572.3"
                                    onmouseover="displayAddNewLine('left')"
                            >
                                <defs>
                                </defs>
                                <g>
                                    <g>
                                        <rect x="1.64" y="30.31" width="108.72" height="503.76" fill="#f4eddb"/>
                                        <g>
                                            <polygon points="65.08 53.5 54.1 46.53 41.03 46.53 52.02 53.5 65.08 53.5" fill="#009fe3"/>
                                            <polygon points="91.41 53.5 80.42 46.53 67.36 46.53 78.35 53.5 91.41 53.5" fill="#e30613"/>
                                            <polygon points="93.56 46.53 104.55 53.5 110.36 53.5 110.36 48.9 106.62 46.53 93.56 46.53" fill="#009fe3"/>
                                            <polygon points="1.64 46.53 1.64 53.5 12.75 53.5 1.76 46.53 1.64 46.53" fill="#009fe3"/>
                                            <polygon points="39.07 53.5 28.08 46.53 15.02 46.53 26.01 53.5 39.07 53.5" fill="#e30613"/>
                                        </g>
                                        <g>
                                            <polygon points="65.08 233.51 54.1 226.54 41.03 226.54 52.02 233.51 65.08 233.51" fill="#009fe3"/>
                                            <polygon points="91.41 233.51 80.42 226.54 67.36 226.54 78.35 233.51 91.41 233.51" fill="#e30613"/>
                                            <polygon points="110.36 228.91 106.62 226.54 93.56 226.54 104.55 233.51 110.36 233.51 110.36 228.91" fill="#009fe3"/>
                                            <polygon points="1.64 226.54 1.76 226.54 12.75 233.51 1.64 233.51 1.64 226.54" fill="#009fe3"/>
                                            <polygon points="39.07 233.51 28.08 226.54 15.02 226.54 26.01 233.51 39.07 233.51" fill="#e30613"/>
                                        </g>
                                        <g>
                                            <path d="M80.23,77.97s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,82.38s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,91.2s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,95.61s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,100.02s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,104.43s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M80.23,86.79s8.54-2.38,13.37-1.83,9.66,2.38,12.63,2.38c.98,0,2.45-.1,4.13-.26" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                        </g>
                                        <line x1="102.73" y1="107.56" x2="102.73" y2="208.98" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width="1.56"/>
                                    </g>
                                </g>
                                <polygon points="104.57 28.71 87.35 28.71 70.13 28.71 52.9 28.71 35.68 28.71 18.46 28.71 2.68 28.71 2.68 31 1.64 31 4.44 0 108.5 0 110.36 28.71 104.57 28.71 104.57 28.71" fill="#1d1d1b"/>
                                <path d="M34.04,528.02h35.26s17.63,0,17.63,0h23.09c-5.27,8.07-23.14,30.88-57.06,30.88s-47.22-22.65-51.01-30.88h32.09Z" fill="#1d1d1b"/>
                                <rect x="1.47" y="288.44" width="107.57" height="11.81" fill="#e30613"/>
                                <rect x="1.47" y="312.34" width="107.57" height="11.81" fill="#009fe3"/>
                                <rect x="1.47" y="336.37" width="107.57" height="11.81" fill="#e30613"/>
                                <rect x="1.47" y="360.41" width="107.57" height="11.81" fill="#009fe3"/>
                                <rect x="1.47" y="384.45" width="108.16" height="11.81" fill="#e30613"/>
                                <rect x="1.47" y="408.48" width="108.16" height="11.81" fill="#009fe3"/>
                                <rect x="1.47" y="432.52" width="107.57" height="11.81" fill="#e30613"/>
                                <rect x="1.47" y="456.56" width="108.16" height="11.81" fill="#009fe3"/>
                                <rect x="1.47" y="480.34" width="107.57" height="11.81" fill="#e30613"/>
                                <rect x="1.47" y="504.23" width="107.57" height="11.81" fill="#009fe3"/>
                                <path d="M61.26,336.02l46.72,44.19s30.58-48.56,0-92.31c0,0-46.72,48.12-46.72,48.12Z" fill="#1d1d1b"/>
                                <foreignObject x="7.8" y="105.8" width="100" height="200" id="left-group">
                                    
                                </foreignObject>

                            </svg>
    `;

svgCompletementTimbreRight = `
    <svg
                                    style="height: 700px; margin-left: 20px; margin-right: 75px;"
                                    id="svg-right"
                                    xmlns="http://www.w3.org/2000/svg"
                                    version="1.1"
                                    viewBox="0 0 129.9 572.3"
                            >

                                <g>
                                    <g>
                                        <rect x="12.56" y="30.31" width="108.72" height="503.76" fill="#f4eddb"/>
                                        <g>
                                            <polygon points="70.9 53.5 81.89 46.53 68.82 46.53 57.84 53.5 70.9 53.5" fill="#009fe3"/>
                                            <polygon points="44.57 53.5 55.56 46.53 42.5 46.53 31.51 53.5 44.57 53.5" fill="#e30613"/>
                                            <polygon points="29.36 46.53 18.37 53.5 12.56 53.5 12.56 48.9 16.3 46.53 29.36 46.53" fill="#009fe3"/>
                                            <polygon points="121.28 46.53 121.28 53.5 110.17 53.5 121.16 46.53 121.28 46.53" fill="#009fe3"/>
                                            <polygon points="96.91 53.5 107.9 46.53 94.84 46.53 83.85 53.5 96.91 53.5" fill="#e30613"/>
                                        </g>
                                        <g>
                                            <polygon points="70.9 233.51 81.89 226.54 68.82 226.54 57.84 233.51 70.9 233.51" fill="#009fe3"/>
                                            <polygon points="44.57 233.51 55.56 226.54 42.5 226.54 31.51 233.51 44.57 233.51" fill="#e30613"/>
                                            <polygon points="12.56 233.51 18.37 233.51 29.36 226.54 16.3 226.54 12.56 228.91 12.56 233.51" fill="#009fe3"/>
                                            <polygon points="121.28 233.51 110.17 233.51 121.16 226.54 121.28 226.54 121.28 233.51" fill="#009fe3"/>
                                            <polygon points="96.91 233.51 107.9 226.54 94.84 226.54 83.85 233.51 96.91 233.51" fill="#e30613"/>
                                        </g>
                                        <g>
                                            <path d="M12.56,78.26c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,82.67c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,91.49c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,95.9c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,100.31c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,104.72c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                            <path d="M12.56,87.08c1.68.16,3.15.26,4.13.26,2.97,0,7.8-1.83,12.63-2.38s13.37,1.83,13.37,1.83" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width=".55"/>
                                        </g>
                                        <line x1="20.19" y1="208.98" x2="20.19" y2="107.56" fill="none" stroke="#1d1d1b" stroke-miterlimit="10" stroke-width="1.56"/>
                                    </g>
                                </g>
                                <polygon points="18.35 28.71 12.56 28.71 14.42 0 118.48 0 121.28 31 120.24 31 120.24 28.71 104.46 28.71 87.24 28.71 70.02 28.71 52.79 28.71 35.57 28.71 18.35 28.71 18.35 28.71" fill="#1d1d1b"/>
                                <path d="M88.89,528.02h17.63s14.45,0,14.45,0c-3.79,8.23-17.09,30.88-51.01,30.88s-51.79-22.81-57.06-30.88h4.42s17.63,0,17.63,0h1.04s17.63,0,17.63,0h17.63s17.63,0,17.63,0h.01Z" fill="#1d1d1b"/>
                                <rect x="13.88" y="288.44" width="107.57" height="11.81" transform="translate(135.33 588.69) rotate(-180)" fill="#e30613"/>
                                <rect x="13.88" y="312.34" width="107.57" height="11.81" transform="translate(135.33 636.49) rotate(-180)" fill="#009fe3"/>
                                <rect x="13.88" y="336.37" width="107.57" height="11.81" transform="translate(135.33 684.55) rotate(-180)" fill="#e30613"/>
                                <rect x="13.88" y="360.41" width="107.57" height="11.81" transform="translate(135.33 732.63) rotate(-180)" fill="#009fe3"/>
                                <rect x="13.29" y="384.45" width="108.16" height="11.81" transform="translate(134.74 780.71) rotate(-180)" fill="#e30613"/>
                                <rect x="13.29" y="408.48" width="108.16" height="11.81" transform="translate(134.74 828.77) rotate(-180)" fill="#009fe3"/>
                                <rect x="13.88" y="432.52" width="107.57" height="11.81" transform="translate(135.33 876.85) rotate(-180)" fill="#e30613"/>
                                <rect x="13.29" y="456.56" width="108.16" height="11.81" transform="translate(134.74 924.93) rotate(-180)" fill="#009fe3"/>
                                <rect x="13.88" y="480.34" width="107.57" height="11.81" transform="translate(135.33 972.49) rotate(-180)" fill="#e30613"/>
                                <rect x="13.88" y="504.23" width="107.57" height="11.81" transform="translate(135.33 1020.27) rotate(-180)" fill="#009fe3"/>
                                <path d="M14.94,287.9c-30.58,43.75,0,92.31,0,92.31l46.72-44.19s-46.72-48.12-46.72-48.12Z" fill="#1d1d1b"/>
                                <foreignObject x="21" y="105.8" width="100" height="200" id="right-group">
                                   
                                </foreignObject>

                            </svg>
    `;

    svgEnTransitLeft = `
    <svg
        style="height: 700px; margin-left: 75px; margin-right: 20px;"
        id="svg-left"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="116.8 0 120.2 558.9"
        onmouseover="displayAddNewLine('left')"
    >
  <!-- Generator: Adobe Illustrator 30.6.0, SVG Export Plug-In . SVG Version: 2.1.4 Build 109)  -->
  <defs>
    <clipPath id="clippath-etl">
      <rect x="117" y="27.6" width="106.9" height="502.9" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-1-etl">
      <path d="M66.6,60.7c0-13.4-10.9-24.3-24.3-24.3s-24.3,10.9-24.3,24.3" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-2-etl">
      <rect x="6.9" y="158.5" width="37" height="37" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-3-etl">
      <path d="M8,179.2c1,8.7,8.5,15.5,17.5,15.5s16.5-6.8,17.5-15.5c0,0-35.1-.7-35,0" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-4-etl">
      <path d="M47.6,448.5c-11.6,4.2-17.5,16.9-13.4,28.5,4.2,11.6,16.9,17.5,28.5,13.4,11.6-4.2,17.5-16.9,13.4-28.5-4.2-11.6-16.9-17.5-28.5-13.4" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-5-etl">
      <path d="M170.1,475.4c8.8,0,16,7.2,16,16v6.8c0,8.8-7.2,16-16,16h-49.3c-1.3,0-2.6-.2-3.9-.5v-37.9c1.2-.3,2.5-.5,3.9-.5h49.3Z" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-6-etl">
      <rect x="117" y="27.6" width="106.9" height="502.9" style="fill: none;"/>
    </clipPath>
  </defs>
  <rect x="117" y="27.6" width="106.9" height="501.3" style="fill: #7f8560;"/>
  <g style="clip-path: url(#clippath-etl);">
    <path d="M72.5,159.4l18.3-5.4c1.7-.5,2.7-2.3,2.2-4.1l-15.2-51.9c-.5-1.7-2.3-2.7-4.1-2.2l-18.3,5.4c-1.7.5-2.7,2.3-2.2,4.1l15.2,51.9c.5,1.7,2.3,2.7,4.1,2.2" style="fill: #f5eddb;"/>
    <path d="M72.1,158.1l18-5.3c1.2-.3,1.8-1.6,1.5-2.7l-15-51.3c-.3-1.2-1.6-1.8-2.7-1.5l-18.1,5.3c-.9.3-1.5,1.2-1.2,2.2l15.2,52c.3,1,1.3,1.5,2.2,1.2Z" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="77.8" y1="102.1" x2="55.9" y2="108.5" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="90.8" y1="146.6" x2="68.9" y2="153" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <rect x="76.4" y="102.5" width="7.7" height="46.1" transform="translate(-32 27.6) rotate(-16.3)" style="fill: #765a54;"/>
    <rect x="62.2" y="106.7" width="7.7" height="46.1" transform="translate(-33.8 23.8) rotate(-16.3)" style="fill: #df7a50;"/>
    <path d="M74.4,151.3s-.3-.5.4-2.8c.7-2.3,3.5-2.6,3.5-2.6,0,0,2.6-1.2,4.4.3,1.9,1.5,1.9,2.1,1.9,2.1l3.9-1.1s-5.9-4.1-10.3-10.9c-4.3-6.8-7.2-18.2-7.2-18.2l.6-.2-.4-1.4h-.5c0,.1-.3-.7-.3-.7l-.6.2-.8-2.7-.6.2.8,2.7-.6.2.3.9h-.5c0,.1.4,1.6.4,1.6l.6-.2s3.6,11.1,3.7,19.2c0,8.1-2.8,14.7-2.8,14.7l3.9-1.2ZM75,143c0-1.3-.4-5-.4-5l1.4-.4,1.4-.4s1.6,3.4,2.3,4.4l-2.4.7h0s-2.3.7-2.3.7Z" style="fill: #765a54;"/>
    <path d="M68.7,61c0-14.6-11.8-26.4-26.4-26.4s-26.4,11.8-26.4,26.4" style="fill: #f5eddb;"/>
    <rect x="15.8" y="60.7" width="52.9" height="9.9" style="fill: #df7a50;"/>
    <rect x="15.8" y="60.7" width="2" height="9.9" style="fill: #f5eddb;"/>
    <rect x="66.7" y="60.7" width="2" height="9.9" style="fill: #f5eddb;"/>
    <rect x="15.8" y="68.7" width="52.9" height="2" style="fill: #f5eddb;"/>
    <polygon points="42.2 66.3 44.2 67.3 43.8 65.2 45.4 63.7 43.2 63.4 42.2 61.4 41.3 63.4 39.1 63.7 40.7 65.2 40.3 67.3 42.2 66.3" style="fill: #fdc853;"/>
    <polygon points="31.9 66.3 33.8 67.3 33.5 65.2 35 63.7 32.9 63.4 31.9 61.4 30.9 63.4 28.8 63.7 30.3 65.2 30 67.3 31.9 66.3" style="fill: #fdc853;"/>
    <polygon points="21.5 66.3 23.5 67.3 23.1 65.2 24.7 63.7 22.5 63.4 21.5 61.4 20.6 63.4 18.4 63.7 20 65.2 19.6 67.3 21.5 66.3" style="fill: #fdc853;"/>
    <polygon points="52.6 66.3 54.5 67.3 54.2 65.2 55.7 63.7 53.6 63.4 52.6 61.4 51.6 63.4 49.5 63.7 51 65.2 50.7 67.3 52.6 66.3" style="fill: #fdc853;"/>
    <polygon points="63 66.3 64.9 67.3 64.5 65.2 66.1 63.7 63.9 63.4 63 61.4 62 63.4 59.8 63.7 61.4 65.2 61 67.3 63 66.3" style="fill: #fdc853;"/>
    <path d="M66.6,60.7c0-13.4-10.9-24.3-24.3-24.3s-24.3,10.9-24.3,24.3" style="fill: #7f8560;"/>
    <g style="clip-path: url(#clippath-1-etl);">
      <line x1="53.5" y1="38" x2="30.7" y2="38" style="fill: #0f406c;"/>
      <line x1="53.5" y1="38" x2="30.7" y2="38" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="63.4" y1="40" x2="19.6" y2="40" style="fill: #0f406c;"/>
      <line x1="63.4" y1="40" x2="19.6" y2="40" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="63.4" y1="42" x2="19.6" y2="42" style="fill: #0f406c;"/>
      <line x1="63.4" y1="42" x2="19.6" y2="42" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="63.4" y1="44" x2="19.6" y2="44" style="fill: #0f406c;"/>
      <line x1="63.4" y1="44" x2="19.6" y2="44" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="63.4" y1="46" x2="19.6" y2="46" style="fill: #0f406c;"/>
      <line x1="63.4" y1="46" x2="19.6" y2="46" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="63.4" y1="48" x2="19.6" y2="48" style="fill: #0f406c;"/>
      <line x1="63.4" y1="48" x2="19.6" y2="48" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="50" x2="19.6" y2="50" style="fill: #0f406c;"/>
      <line x1="68.4" y1="50" x2="19.6" y2="50" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="52" x2="16.6" y2="52" style="fill: #0f406c;"/>
      <line x1="68.4" y1="52" x2="16.6" y2="52" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="54" x2="16.6" y2="54" style="fill: #0f406c;"/>
      <line x1="68.4" y1="54" x2="16.6" y2="54" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="56" x2="16.6" y2="56" style="fill: #0f406c;"/>
      <line x1="68.4" y1="56" x2="16.6" y2="56" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="58" x2="16.6" y2="58" style="fill: #0f406c;"/>
      <line x1="68.4" y1="58" x2="16.6" y2="58" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="68.4" y1="60" x2="16.6" y2="60" style="fill: #0f406c;"/>
      <line x1="68.4" y1="60" x2="16.6" y2="60" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
    </g>
    <path d="M36.1,60.6s3.9-2.2,4.2-2.8c.3-.6.2-4,.1-4.6,0-.5,2.6-1.1,4.3-5.1,0,0,0-.8,2.7-.2,2.7.7,3.7,1.2,6,.5,2.3-.7,3.6-4.4,3.6-4.4,0,0-1.5,2.2-2.9,2.6-1.4.4-2.6.8-5.3-.2-2.7-1-5.6-2.4-7.8-2.4-2.1,0-3.9,1-5,2.7-1.2,1.7-.8,2.2-1.9,2.3-1,0-2.8-3.2-3.2-3.2-.4,0-.2.5,0,1.2s.4.7,0,1.3c-.3.6-1.3,1.5-1.3,2s1.3,0,1.9,0c.6,0,1.3.2,1.6.6.2.4,1.3,1.2,2.9,1.3h.9c0,.1-.2,1,1.8,2.1,0,0,.4.3.3,1.5-.1,1.2-1.4,2.4-1.9,2.7-.5.2-1.5,1-1.5,1,0,0-.8.5.3.8" style="fill: #fdc853;"/>
    <path d="M72,234.2l49,5.2c8.8.9,16.7-5.5,17.6-14.2l.7-6.8c.9-8.8-5.5-16.7-14.2-17.6l-49-5.2c-8.8-.9-16.7,5.5-17.6,14.2l-.7,6.8c-.9,8.8,5.5,16.7,14.2,17.6" style="fill: #f5eddb;"/>
    <path d="M72,234.2l49,5.2c8.8.9,16.7-5.5,17.6-14.2l.7-6.8c.9-8.8-5.5-16.7-14.2-17.6l-49-5.2c-8.8-.9-16.7,5.5-17.6,14.2l-.7,6.8c-.9,8.8,5.5,16.7,14.2,17.6Z" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: 2.1px;"/>
    <polygon points="112.9 224.7 123.2 225.8 119 216.3 114.8 206.8 108.6 215.2 102.5 223.6 112.9 224.7" style="fill: #df7a50;"/>
    <polygon points="114.8 206.8 96.7 222.9 102.5 223.6 114.8 206.8" style="fill: #765a54;"/>
    <polygon points="76.7 220.9 87.1 222 82.9 212.5 78.6 203 72.5 211.4 66.4 219.8 76.7 220.9" style="fill: #df7a50;"/>
    <polygon points="78.6 203 60.6 219.1 66.4 219.8 78.6 203" style="fill: #765a54;"/>
    <polygon points="127.9 226.5 135.1 227.3 132.1 220.7 129.2 214.1 124.9 219.9 120.7 225.8 127.9 226.5" style="fill: #df7a50;"/>
    <polygon points="129.2 214.1 116.7 225.3 120.7 225.8 129.2 214.1" style="fill: #765a54;"/>
    <path d="M98.4,219.4l-.8-.6c-.2-.1-.3-.2-.5-.2h-.5c-.1,0-.2-.1-.3-.2l-.9-1-.7-.7c-.2-.2-.5-.3-.8-.4h-.4c0,0-.1,0-.2,0l-1.6.6c0,0-.1,0-.2,0l-1.6.3s0,0,0,0l-.8.3c-.3.1-.5.3-.6.5l-.4.6c-.2.3-.4.5-.6.6h0c-.3.2-.5.2-.8.2h0c-.2,0-.3-.2-.4-.4l-.2-.9c0-.2,0-.4,0-.6v-.7c.1-.2,0-.4,0-.6l-.6-1c0-.1-.2-.2-.3-.2h-.5c-.1,0-.2,0-.3,0l-.6.5c-.1.1-.3.1-.4,0l-1.3-.5c0,0-.2,0-.3,0h-.3c-.2.2-.4.4-.3.7l.2.5c0,.2.2.3.4.3h.6c0,0,.1.1.2.2l.7.5c.1,0,.2.2.2.4v1.1c0,0,0,.1,0,.2l.8,1.8c0,0,.1.2.2.2l1.2.6s.1,0,.2,0l1.8.2c.2,0,.3.2.4.3l.2.8c0,0,0,.2,0,.3l-.4,1s0,0,0,.1l-.2,1.5c0,0,0,.1,0,.2l-.8,1.4s0,0,0,0l-1.9,2.6c-.2.3,0,.7.3.7h.5c0,0,.6.1.6.1.2,0,.5-.1.5-.4l.4-1.8c0,0,0-.1,0-.2l1-1.5s0,0,0-.1l.7-1.9s0,0,0,0l.6-1.3c0-.2.3-.3.5-.3h.2c.2,0,.3.1.4.3l.5,1.1.7,1.7s0,.1,0,.2v.9c0,.1.1.3.2.4l.5.3c.1,0,.2.2.2.3l.2,1.3s0,0,0,0v.7c0,.1,0,.2-.2.3-.3.3-.2.7.2.8h.2s.5,0,.5,0c.3,0,.6-.2.5-.5l-.2-.9-.2-1.6s0,0,0,0v-1.9c-.1,0-.1-.2-.2-.2l-.9-1.4c0,0,0-.2,0-.3l.2-1.5c0-.3.3-.5.6-.4l.9.3s0,0,.1,0h1.6c0,0,.1,0,.2,0l.4.2c.2,0,.3.3.3.5v.6c-.1.1,0,.3,0,.4l.5.6c0,0,.1.2.1.3v1.3c0,0,0,.1,0,.2l-1.9,4.3c-.1.2,0,.5.2.6l.7.3c.2.1.5,0,.6-.2l1.7-3.5c0,0,0-.1,0-.2v-1.3c0-.5.5-.6.8-.3l.5.7c0,0,0,.2,0,.3l-.2,1.3c0,0,0,.1,0,.2l.3.8s0,0,0,0l.2,1.2c0,.1,0,.3-.1.4l-.4.4c-.2.3,0,.7.3.8h0s.5,0,.5,0c.2,0,.5-.1.5-.4v-.9c.1,0,.1-.1,0-.2l-.4-1.2s0-.1,0-.2v-1.7c0,0,0,0,0-.1l.4-1.3c0-.2,0-.4-.2-.5l-.9-.8s0,0,0-.1l-.9-1.3c0,0,0-.2,0-.3v-1.5c0-.3,0-.6,0-.9l-.2-2.5c0-.1,0-.3-.2-.3" style="fill: #765a54;"/>
    <path d="M85.3,215.3c-.1.4-.4.7-.6.6-.2,0-.2-.5,0-.9.2-.4.4-.7.6-.6.2,0,.2.4,0,.9" style="fill: #765a54;"/>
    <path d="M98.3,219.4l.6,1c0,.2.2.3.2.5v.3c0,.4,0,.7-.3,1h0c0,0-.4-2.8-.4-2.8Z" style="fill: #765a54;"/>
    <rect x="4.6" y="156.3" width="41.8" height="41.8" style="fill: #f5eddb;"/>
    <rect x="6.9" y="158.5" width="37" height="37" style="fill: #f5eddb;"/>
    <g style="clip-path: url(#clippath-2-etl);">
      <rect x="0" y="156.4" width="71.2" height="23.8" style="fill: #df7a50;"/>
      <path d="M7.9,177.1c0,9.7,7.9,17.6,17.6,17.6s17.6-7.9,17.6-17.6c0-9.7-7.9-17.6-17.6-17.6s-17.6,7.9-17.6,17.6" style="fill: #fdc853;"/>
      <path d="M20.7,176.1s-5.7,1.4-12.5.9v1.1c0,0,8,1.1,11.3.4,0,0,1.2-2.1,1.2-2.5" style="fill: #df7a50;"/>
      <polygon points="17.7 176.6 16.7 176.1 14.6 176.2 14.6 177 17.3 177.5 17.7 176.6" style="fill: #df7a50;"/>
      <path d="M14.6,168.3s1.7,2.8-.3,6.3c0,0,3.6-.2,4.6.3,0,0-2.6-5.4-4.3-6.6" style="fill: #df7a50;"/>
      <path d="M14.6,167.3s-3.3,2.5-3.4,3.2c0,0-2,1.8-1.2,5.6h4.5c0,0-1.7-2.3,0-8.7" style="fill: #df7a50;"/>
      <path d="M14.6,165.9v.8s-.2.2-.6,0c-.4-.2-.6-.4-.8-.4-.2,0-.4,0-.4,0,0,0,.1-.2.5-.2,0,0,.6.1.7,0,.1,0,.6-.1.6-.3" style="fill: #df7a50;"/>
      <rect x="0" y="179.2" width="71.2" height="18.5" style="fill: #fdc853;"/>
      <path d="M8,179.2c1,8.7,8.5,15.5,17.5,15.5s16.5-6.8,17.5-15.5c0,0-35.1-.7-35,0" style="fill: #fdc853;"/>
      <g style="clip-path: url(#clippath-3-etl);">
        <line x1="45.2" y1="179.8" x2="5.7" y2="179.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="181.8" x2="5.7" y2="181.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="183.8" x2="5.7" y2="183.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="185.8" x2="5.7" y2="185.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="187.8" x2="5.7" y2="187.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="189.8" x2="5.7" y2="189.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="191.8" x2="5.7" y2="191.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="45.2" y1="193.8" x2="5.7" y2="193.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
      </g>
    </g>
    <rect x="124.3" y="109.9" width="91.6" height="85.1" style="fill: #f5eddb;"/>
    <path d="M124.3,103.4v13.5s91.7,0,91.7,0v-13.5s-38-12.3-38-12.3h-14.9s-38.8,12.3-38.8,12.3ZM170.6,106.9c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9,4.9,2.2,4.9,4.9-2.2,4.9-4.9,4.9" style="fill: #f5eddb;"/>
    <path d="M165.7,97.7c-2.4,2.7-2.2,6.8.5,9.2,2.7,2.4,6.8,2.2,9.2-.5,2.4-2.7,2.2-6.8-.5-9.2-2.7-2.4-6.8-2.2-9.2.5M174.2,105.3c-1.8,2-4.9,2.2-6.9.4-2-1.8-2.2-4.9-.4-6.9,1.8-2,4.9-2.2,6.9-.4,2,1.8,2.2,4.9.4,6.9" style="fill: #fdc853;"/>
    <path d="M173.1,96.6c.6-2.1,3.1-4,5.1-4.8,8.9-3.5,21.5,1.6,28.7-6.1,10.2-10.9-2.5-21.2-7.8-30.4-5.2-9-4.6-20.2-3.7-30.2" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <path d="M93.8,80.4c0,15.2,12.4,27.6,27.6,27.6s27.6-12.4,27.6-27.6-12.4-27.6-27.6-27.6-27.6,12.4-27.6,27.6" style="fill: #f5eddb;"/>
    <path d="M99.1,80.4c0,12.3,10,22.2,22.2,22.2,12.3,0,22.2-10,22.2-22.2s-10-22.2-22.2-22.2c-12.3,0-22.2,10-22.2,22.2" style="fill: #765a54;"/>
    <path d="M121.4,55c-14,0-25.4,11.4-25.4,25.4s11.4,25.4,25.4,25.4,25.4-11.4,25.4-25.4-11.4-25.4-25.4-25.4M121.4,104.5c-13.3,0-24.1-10.8-24.1-24.1,0-13.3,10.8-24.1,24.1-24.1s24.1,10.8,24.1,24.1c0,13.3-10.8,24.1-24.1,24.1" style="fill: #765a54;"/>
    <path d="M112.5,94c.2,0,.2-.1.2-.2.2-1.1.6-2.1,1.3-3,1.5-1.8,3.8-2.4,5.9-1.5,1.4.6,2.3,1.6,2.9,3,.1.3.1.3.5.2.4-.1.8-.2,1.2-.3,2.3-.3,4.4,1.2,4.9,3.4,0,.2.1.3.3.2.5,0,.9-.1,1.4,0,1.5.3,2.7,1.5,2.9,3-3.6,2.5-7.9,3.9-12.6,3.9s-8.7-1.3-12.2-3.6c0-.3,0-.6,0-.9,0-.6,0-1.2.3-1.7.6-1.4,1.5-2.3,3.1-2.5" style="fill: #f5eddb;"/>
    <polygon points="121.3 102.7 143.7 78.5 143.4 72.3 140.5 67 121.3 102.7" style="fill: #f5eddb;"/>
    <polygon points="121.3 102.7 133.9 60.7 126.9 57.8 121.3 102.7" style="fill: #f5eddb;"/>
    <polygon points="121 102.7 98.6 78.5 99 72.3 101.9 67 121 102.7" style="fill: #f5eddb;"/>
    <polygon points="121 102.7 108.4 60.7 115.4 57.8 121 102.7" style="fill: #f5eddb;"/>
    <path d="M119.5,71.2l6.8-9.5,3.2,1.9s-1.8,7.8-5.4,11.1l-4.7-3.4Z" style="fill: #df7a50;"/>
    <path d="M116.6,75.4l-6.5,9.7,2.9,2.3s6.6-4.4,8.5-8.9l-4.8-3.2Z" style="fill: #df7a50;"/>
    <path d="M130.9,82.5l3.8-6.2-1.4-1.3s-3.5,2.1-4.5,4.4l2.1,3Z" style="fill: #df7a50;"/>
    <path d="M130.9,82.5l-5,5.5-1.6-1s1.1-3.9,3-5.5l3.6,1.1Z" style="fill: #df7a50;"/>
    <path d="M130.9,82.5s0,0,0,0h0c-9-1.4-15-7.8-16.5-9-1.5-1.2.1-2.7.1-2.7h0c0-.1,1-1.9,2.5-1,1.6,1,9.6,4.6,13.8,12.6h0s0,0,0,0" style="fill: #df7a50;"/>
    <path d="M111.7,68.7s3-.5,3.2.4c.2.9-1.5,2.7-1.7,2.7-.2,0-1.3-.3-1.4-3.1" style="fill: #df7a50;"/>
    <path d="M113.3,68.4s1.7-3.7,2.4-4.2c.7-.5,1.5.7,1.5.7,0,0,.1,1.2-4,3.5" style="fill: #df7a50;"/>
    <path d="M111.8,70.8s-3,2.8-3.3,3.6c-.3.8,1.2,1.2,1.2,1.2,0,0,1.2-.2,2.1-4.9" style="fill: #df7a50;"/>
    <path d="M45.7,443.5c-14.3,5.2-21.7,21-16.6,35.3,5.2,14.3,21,21.7,35.3,16.6,14.3-5.2,21.7-21,16.6-35.3-5.2-14.3-21-21.7-35.3-16.6" style="fill: #f5eddb;"/>
    <path d="M47.6,448.5c-11.6,4.2-17.5,16.9-13.4,28.5,4.2,11.6,16.9,17.5,28.5,13.4,11.6-4.2,17.5-16.9,13.4-28.5-4.2-11.6-16.9-17.5-28.5-13.4" style="fill: #fdc853;"/>
    <g style="clip-path: url(#clippath-4-etl);">
      <path d="M34,488.6c-.2,0-.3-.1-.3-.3v-8.9s-5-.8-5-.8c-.1,0-.2-.1-.2-.3v-1.8c0,0,0-.2,0-.2,0,0,.1,0,.2,0s0,0,0,0l4.9.7v-8.5c-.1.3-.3.5-.4.8-.5.8-.9,1.4-1.3,2-.6.8-1.2,1.3-1.8,1.6-.4.2-.8.4-1.2.4,0,0-.2,0-.2,0,0,0-.1,0-.2,0,0,0,0-.1,0-.2,0-.2.1-.3.3-.3h.1c.3,0,.6-.2,1-.3.5-.3,1.1-.8,1.6-1.5.4-.5.8-1.1,1.3-1.9.3-.6.6-1.2.9-1.9v-6.3c0,.3-.2.5-.3.8-.4,1.3-.9,2.5-1.4,3.6-.6,1.3-1.1,2.5-1.7,3.6-.2.3-.3.5-.5.8,0,.1-.2.3-.3.4h0c0,.2-.1.3-.2.4,0,0-.2.3-.3.4,0,0-.1,0-.2,0s0,0-.1,0c-.1,0-.2-.2-.2-.3s0-.1,0-.2c0,0,.3-.4.3-.4,0,0,.1-.2.2-.2h.1c0-.3.2-.4.3-.5.2-.2.3-.5.4-.7h0c.6-1.1,1.1-2.2,1.7-3.6.5-1.1.9-2.4,1.3-3.6.3-1,.6-1.9.8-2.7v-1.3c0,0,0-.2,0-.2,0,0,.1,0,.2,0s.6,0,.6,0c.1,0,.2.1.2.3v.3s1.7.2,1.7.2v-.3c0,0,0-.2,0-.2,0,0,.1,0,.2,0s.6,0,.6,0c.1,0,.2.1.2.3v1.3c.7,2.2,1.4,4.1,2.1,5.9,1,2.6,2,4.7,3,6.6.7,1.2,1.3,2.2,1.9,3.1.8,1.1,1.6,2,2.4,2.7.5.4,1,.7,1.4,1,0,0,.1,0,.2,0,.5-.2.9-.4,1.4-.7.9-.6,1.7-1.3,2.6-2.4.7-.8,1.4-1.8,2-2.9,1.1-1.8,2.1-3.9,3.2-6.5.9-2.1,1.7-4.3,2.5-6.8.4-1.2.7-2.3,1.1-3.5.3-.9.5-1.7.7-2.6v-1.1c0,0,0-.2.1-.2,0,0,.1,0,.2,0s0,0,0,0l.9.2c.1,0,.2.1.2.3v.6s2.8.5,2.8.5v-.5c0,0,0-.2.1-.2,0,0,.1,0,.2,0s0,0,0,0h.8c.1.2.2.3.2.4v1.2s.4,1.4.4,1.4c.1.4.2.8.4,1.2l.5,1.6c0,.3.2.5.3.8l.8,2.4.8,2.4.9,2.3.6,1.6c.1.3.2.5.3.7.9,2,2.3,3.6,3.5,5.3.4.6,1.4,1.5,1.5,2.3-1.1.3-1.4-.7-2-1.4-.7-.7-1.2-1.6-1.7-2.4-.8-1.1-1.5-2.2-2.1-3.5-.1-.3-.2-.5-.3-.8l-.6-1.6-.9-2.4-.8-2.4-.8-2.4c0-.3-.2-.5-.3-.8l-.5-1.5v8.7s.1.3.1.3c.1.3.3.7.4,1l.3.6c.1.3.3.7.5,1l.2.5c.2.4.3.7.5,1v.3c.3.4.6.9.8,1.3l.4.8.4.8c.2.3.4.7.6,1,0,0,.3.4.3.5.9,1.5,2.2,2.8,3.2,4.3.2.3.7,1.4-.2,1.1-.3,0-.8-.7-1-1-.6-.7-1.1-1.4-1.6-2.2l-.5-.6-.7-1.1-.3-.5c-.2-.3-.4-.7-.6-1l-.4-.8-.4-.8c-.2-.4-.4-.9-.7-1.3v-.3c-.3-.4-.5-.7-.6-1.1l-.2-.5c-.2-.3-.3-.7-.5-1.1,0,0,0,14,0,14l5.9.9c.1,0,.2.1.2.3v2.4c0,0,0,.2-.1.2,0,0-.1,0-.2,0s0,0,0,0l-5.8-.9v6.5c0,.2-.1.3-.3.3h-5.1c-.2,0-.3-.1-.3-.3v-7.4s-24.3-3.9-24.3-3.9v8.3c0,.2-.1.3-.3.3h-.5c-.2,0-.3-.1-.3-.3v-.2s-1.7.2-1.7.2c0,.2-.1.3-.3.3h-.6ZM36,487.2l-.3-.3-.3.4h.6ZM35.1,486.2l-.3-.3v.7s.3-.4.3-.4ZM36.5,485.9l-.2.2.2.2v-.4ZM36,485.1h-.6c0,0,.3.4.3.4l.3-.4ZM36,484.2l-.3-.3-.3.4h.6ZM35.1,483.2l-.3-.3v.7s.3-.4.3-.4ZM36.5,482.9l-.2.2.2.2v-.4ZM36,482.1h-.6s.3.3.3.3l.3-.3ZM66.2,473.6h-2.8c0,0,0,7.7,0,7.7l2.8.4v-8.2ZM62,468c-1,2.2-2,4-3.1,5.6-.8,1.2-1.5,2.1-2.3,2.9-1,1.1-1.9,1.8-2.9,2.4-.3.2-.6.3-.9.4-.3.1-.6.2-.9.3h0s10.2,1.5,10.2,1.5v-13.1ZM36,481.1l-.3-.3-.3.3h.6ZM35.1,480.1l-.3-.3v.7s.3-.4.3-.4ZM62,466.1v-10c-.3,1.1-.7,2.2-1,3.3-.8,2.5-1.7,4.7-2.5,6.9-1.1,2.6-2.1,4.7-3.3,6.6-.7,1.2-1.4,2.2-2.1,3-.9,1.1-1.8,1.9-2.7,2.5-.3.2-.5.3-.8.4.2,0,.3,0,.5.1.3,0,.5,0,.8,0s.6,0,.9,0c.3,0,.6-.1.8-.2.3-.1.5-.2.8-.4.9-.5,1.8-1.2,2.7-2.2.7-.8,1.5-1.7,2.2-2.9,1.2-1.8,2.3-3.8,3.4-6.4l.3-.7ZM47.5,478.7c-.3-.2-.7-.5-1-.7-.9-.7-1.7-1.7-2.5-2.8-.6-.9-1.2-1.9-1.9-3.2-1-2-2-4.1-3-6.7-.5-1.3-1-2.6-1.4-4v5.8c.6,1.6,1.3,3,1.9,4.3.6,1.2,1.2,2.2,1.8,3.1.7,1.1,1.5,2,2.3,2.7.5.4,1,.8,1.4,1,.3.1.5.3.8.3.3,0,.6.2.8.2.2,0,.4,0,.5,0s.2,0,.2,0M37.6,477.5l6.8,1c-.4-.2-.8-.6-1.2-.9-.8-.8-1.6-1.7-2.4-2.8-.6-.9-1.2-1.9-1.8-3.2-.5-.9-.9-1.9-1.3-2.9v8.9ZM36.5,471.8h-1.7s0,5.3,0,5.3l1.7.3v-5.6ZM66.2,467.6l-2.8-.2v3.7s2.8,0,2.8,0v-3.6ZM36.5,467.8h-1.7c0,0,0,2.2,0,2.2h1.7s0-2.2,0-2.2ZM36.5,463.8h-1.7c0-.1,0,2.2,0,2.2h1.7c0,0,0-2.2,0-2.2ZM66.1,461.7l-2.8-.3v3.7s2.9.2,2.9.2v-3.6ZM34.8,459.6v2.2s1.6,0,1.6,0v-2.1s-1.6-.2-1.6-.2ZM66.2,455.7l-2.8-.4v3.7s2.8.4,2.8.4v-3.6Z" style="fill: #df7a50;"/>
    </g>
    <path d="M79,460.8c-4.8-13.2-19.3-20-32.5-15.3-13.2,4.8-20,19.3-15.3,32.5,4.8,13.2,19.3,20,32.5,15.3,13.2-4.8,20-19.3,15.3-32.5M32.5,477.6c-4.5-12.5,2-26.3,14.5-30.9,12.5-4.5,26.3,2,30.9,14.5,4.5,12.5-2,26.3-14.5,30.9-12.5,4.5-26.3-2-30.9-14.5" style="fill: #765a54;"/>
    <path d="M175,203.8c-4.4,9.4-.3,20.5,9.1,24.9,9.4,4.4,20.5.3,24.9-9.1,4.4-9.4.3-20.5-9.1-24.9-9.4-4.4-20.5-.3-24.9,9.1" style="fill: #df7a50;"/>
    <path d="M205.2,210.1s1.9-3.1-4.1-4.2c0,0,1.6-2.7,3.6-1.6,0,0-1.7-3.7-5.6.2,0,0-1-4.2-4.5-3.1,0,0,2.2,1.5,2.4,3.1,0,0-3.9-2.9-5.5-.3,0,0,1.8-.6,3.3,1.4,0,0-5.1,0-3.2,3.5,0,0,.2-1.8,3.1-2.1,0,0-2.4,2.5-1,3.9,0,0,1.7-3.4,2.6-2.7,0,0,.1.1.2.2l-1.3,1.8-3.2,4.6-2.8,4.2-1.4,2.4,2,.9.4-2.3.8-1.6,2.1-3.3,2.8-4.1,1.1-1.6c.6,1.4,1,3.5-.1,4.3,0,0,3.4.8,2.3-4.1,0,0,3.5,3.4,1.9,4.9,0,0,4.6-2.3-.4-5.6,0,0,2.8-.8,4.4,1.2" style="fill: #fdc853;"/>
    <path d="M179.5,206.2s.2-2.6,4.1-.8c0,0,.1-2.2-1.5-2.4,0,0,2.5-1.4,3.2,2.4,0,0,2.3-2,3.9,0,0,0-1.9,0-2.7.8,0,0,3.4-.1,3.4,2.1,0,0-.8-1.1-2.5-.5,0,0,3,2,.4,3.4,0,0,.6-1.1-1-2.5,0,0,.4,2.4-1,2.7,0,0,.4-2.7-.4-2.7,0,0-.1,0-.2,0v1.6s0,4,0,4v3.6c-.1,0-.3,1.9-.3,1.9l-1.5-.3.7-1.5.2-1.3v-2.8c.1,0,.2-3.6.2-3.6v-1.4c-.9.5-2,1.7-1.7,2.6,0,0-2.4-.9.3-3.3,0,0-3.5.6-3.1,2.1,0,0-1.8-3.2,2.5-3.1,0,0-1.4-1.6-3.1-1" style="fill: #fdc853;"/>
    <path d="M187.8,220.3s1.4.8,4.8,3.2c3.4,2.5,4.6,6.1,4.6,6.1l-2.8,1.6-10-.5-8.3-6.5-2.2-4.2s2.1-5.9,13.8.3" style="fill: #fdc853;"/>
    <path d="M201.1,191.8c-11-5.1-24-.3-29.1,10.7-5.1,11-.3,24,10.7,29.1,11,5.1,24,.3,29.1-10.7,5.1-11,.3-24-10.7-29.1M184,228.7c-9.4-4.4-13.5-15.5-9.1-24.9,4.4-9.4,15.5-13.5,24.9-9.1,9.4,4.4,13.5,15.5,9.1,24.9-4.4,9.4-15.5,13.5-24.9,9.1" style="fill: #f5eddb;"/>
    <path d="M26.2,266.2l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8l5.4-1.3c.8-.2,1.6.3,1.8,1.1.2.9.3,2.1.7,3,.5,1,1.6.8,2.6.6.8-.2,1.3-1,1.1-1.8l-.6-2.7c-.2-.8.3-1.6,1.1-1.8l5.4-1.3c.8-.2,1.6.3,1.8,1.1l.6,2.7c.2.8,1,1.3,1.8,1.1h.4c.8-.3,1.3-1.1,1.1-1.9l-.6-2.7c-.2-.8.3-1.6,1.1-1.8l5.4-1.3c.8-.2,1.6.3,1.8,1.1l.6,2.7c.2.8,1,1.3,1.8,1.1h.6c.8-.3,1.3-1.2,1.1-2l-.6-2.7c-.2-.8.3-1.6,1.1-1.8l5.4-1.3c.8-.2,1.6.3,1.8,1.1l.6,2.7c.2.8,1,1.3,1.8,1.1,1-.2,1.8-.7,1.7-1.8-.1-.9-.4-1.9-.6-2.8-.2-.8.3-1.6,1.1-1.8l5.4-1.3c.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-2.7.6c-.8.2-1.3,1-1.1,1.8.2.8,1,1.3,1.8,1.1l2.7-.6c.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-2.7.6c-.8.2-1.3,1-1.1,1.8v.4c.3.8,1.1,1.3,1.9,1.1l2.7-.6c.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-2.7.6c-.8.2-1.3,1-1.1,1.8v.4c.3.8,1.1,1.3,1.9,1.1l2.7-.6c.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-2.7.6c-.8.2-1.3,1-1.1,1.8v.4c.3.8,1.1,1.3,1.9,1.1l2.7-.6c.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-2.7.6c-.8.2-1.3,1-1.1,1.8.6,2.4,2.9,1.2,4.6.8.8-.2,1.6.3,1.8,1.1l1.3,5.4c.2.8-.3,1.6-1.1,1.8l-5.4,1.3c-.8.2-1.6-.3-1.8-1.1-.2-1-.3-2.7-1.2-3.4-1.1-.8-3.4,0-3,1.6l.6,2.7c.2.8-.3,1.6-1.1,1.8l-5.4,1.3c-.8.2-1.6-.3-1.8-1.1l-.6-2.7c-.2-.8-1-1.3-1.8-1.1h-.6c-.8.3-1.3,1.2-1.1,2l.6,2.7c.2.8-.3,1.6-1.1,1.8l-5.4,1.3c-.8.2-1.6-.3-1.8-1.1l-.6-2.7c-.2-.8-1-1.3-1.8-1.1h-.4c-.8.3-1.3,1.1-1.1,1.9l.6,2.7c.2.8-.3,1.6-1.1,1.8l-5.4,1.3c-.8.2-1.6-.3-1.8-1.1l-.6-2.7c-.2-.8-1-1.3-1.8-1.1-2.4.6-1.7,2.9-1.3,4.7.2.8-.3,1.6-1.1,1.8l-5.4,1.3c-.8.2-1.6-.3-1.8-1.1l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8,1.3-.3,3.3-.3,3.6-1.9.3-1.1-.5-2.4-1.8-2.1,0,0-2.7.6-2.7.6-.8.2-1.6-.3-1.8-1.1l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8l2.7-.6c.8-.2,1.3-1,1.1-1.8v-.4c-.3-.8-1.1-1.3-1.9-1.1l-2.7.6c-.8.2-1.6-.3-1.8-1.1l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8l2.7-.6c.8-.2,1.3-1,1.1-1.8v-.4c-.3-.8-1.1-1.3-1.9-1.1l-2.7.6c-.8.2-1.6-.3-1.8-1.1l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8l2.7-.6c.8-.2,1.3-1,1.1-1.8v-.4c-.3-.8-1.1-1.3-1.9-1.1l-2.7.6c-.8.2-1.6-.3-1.8-1.1l-1.3-5.4c-.2-.8.3-1.6,1.1-1.8l2.7-.6c.8-.2,1.3-1,1.1-1.8-.2-.8-1-1.3-1.8-1.1l-2.7.6c-.8.2-1.6-.3-1.8-1.1" style="fill: #f5eddb;"/>
    <rect x="40.3" y="260.2" width="40.3" height="51" transform="translate(-65.5 22.3) rotate(-13.6)" style="fill: #df7a50;"/>
    <rect x="44.8" y="297.3" width="40.3" height="13.4" transform="translate(-69.7 23.8) rotate(-13.6)" style="fill: #7f8560;"/>
    <rect x="42.8" y="296.2" width="31.4" height="2.6" transform="translate(-68.4 22.1) rotate(-13.6)" style="fill: #f5eddb;"/>
    <rect x="42.2" y="294" width="29.1" height="2.6" transform="translate(-67.9 21.6) rotate(-13.6)" style="fill: #f5eddb;"/>
    <rect x="41.9" y="291.8" width="26.5" height="2.6" transform="translate(-67.4 21.2) rotate(-13.6)" style="fill: #f5eddb;"/>
    <path d="M52.6,277.7l-1.5-6.1c-8.8,4-11.7,10.3-10.2,18.3l1.1,5,4.7-1.1,5.9-16.1Z" style="fill: #f5eddb;"/>
    <path d="M52.1,278.6l-1.4-5.6c-7.1,5.2-7.6,13.1-6.9,21.5l9.2-2.2-.9-13.7Z" style="fill: #7f8560;"/>
    <path d="M67.7,288.7l.3-8c-2.9.8-5.4,2.2-7.5,4.3l.6,5.3,6.6-1.6Z" style="fill: #f5eddb;"/>
    <polygon points="68 280.7 64.3 289.6 67.7 288.7 68 280.7" style="fill: #7f8560;"/>
    <path d="M58.3,279.7l-2-4.6c-8.8,5-10.7,12-11.7,19.2l6.5-1.6,7.2-13Z" style="fill: #f5eddb;"/>
    <path d="M57.7,280.3l-1.8-4.1c-4.7,3.1-7.3,9.9-8,17.2l10.6-2.5-.8-10.6Z" style="fill: #7f8560;"/>
    <path d="M64.3,289.6l-2.5-11.2c-7.7,1.7-11.9,6.8-12.1,14.7l14.7-3.5Z" style="fill: #f5eddb;"/>
    <path d="M63.3,289.8l-2.3-9.7c-3.1,1.9-6.4,5-7.1,11.9l9.4-2.3Z" style="fill: #7f8560;"/>
    <rect x="103.8" y="474.4" width="83.4" height="40.9" rx="17.1" ry="17.1" style="fill: #f5eddb;"/>
    <path d="M170.1,475.4c8.8,0,16,7.2,16,16v6.8c0,8.8-7.2,16-16,16h-49.3c-8.8,0-16-7.2-16-16v-6.8c0-8.8,7.2-16,16-16h49.3ZM120.8,473.3c-10,0-18.1,8.1-18.1,18.1v6.8c0,10,8.1,18.1,18.1,18.1h49.3c10,0,18.1-8.1,18.1-18.1v-6.8c0-10-8.1-18.1-18.1-18.1h-49.3" style="fill: #fdc853;"/>
    <path d="M120.8,514.3h49.3c8.8,0,16-7.2,16-16v-6.8c0-8.8-7.2-16-16-16h-49.3c-8.8,0-16,7.2-16,16v6.8c0,8.8,7.2,16,16,16" style="fill: #f5eddb;"/>
  </g>
  <g style="clip-path: url(#clippath-5-etl);">
    <polygon points="189.2 503 95.9 503 100.3 517.9 167.4 518.4 193.6 514.3 189.2 503" style="fill: #765a54;"/>
    <path d="M120.7,502h34.8c2.8,0,5.1-2.3,5.1-5.1v-10.2c0-2.8-2.3-6.1-5.1-6.1h-34.8c-2.8,0-5.1,3.3-5.1,6.1v10.2c0,2.8,2.3,5.1,5.1,5.1" style="fill: #df7a50;"/>
    <path d="M146.6,501.6c0,1.7,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-1.4-3.2-3.2-3.2-3.2,1.4-3.2,3.2" style="fill: #765a54;"/>
    <path d="M123.4,500.8c0,1.7,1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2-1.4-3.2-3.2-3.2-3.2,1.4-3.2,3.2" style="fill: #765a54;"/>
    <line x1="160.6" y1="488.8" x2="115.6" y2="488.8" style="fill: none; stroke: #765a54; stroke-miterlimit: 10;"/>
    <polygon points="160.3 495.8 186.1 484.3 187.3 490.5 187.3 502.4 160.3 498.2 160.3 495.8" style="fill: #fdc853;"/>
    <path d="M160.8,490.2h-2.3c-.7,0-1.2.5-1.2,1.2v4.3c0,.7.5,1.2,1.2,1.2h2.3s0-6.7,0-6.7Z" style="fill: #f5eddb;"/>
    <path d="M149,497.1h3.2c.8,0,1.4-.6,1.4-1.4v-3.8c0-.8-.6-1.4-1.4-1.4h-3.2c-.8,0-1.4.6-1.4,1.4v3.8c0,.8.6,1.4,1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M141,497.1h3.2c.8,0,1.4-.6,1.4-1.4v-3.8c0-.8-.6-1.4-1.4-1.4h-3.2c-.8,0-1.4.6-1.4,1.4v3.8c0,.8.6,1.4,1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M133,497.1h3.2c.8,0,1.4-.6,1.4-1.4v-3.8c0-.8-.6-1.4-1.4-1.4h-3.2c-.8,0-1.4.6-1.4,1.4v3.8c0,.8.6,1.4,1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M125,497.1h3.2c.8,0,1.4-.6,1.4-1.4v-3.8c0-.8-.6-1.4-1.4-1.4h-3.2c-.8,0-1.4.6-1.4,1.4v3.8c0,.8.6,1.4,1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M148.8,487.1h3.6c.6,0,1.2-.5,1.2-1.2v-1.5c0-.6-.5-1.2-1.2-1.2h-3.6c-.6,0-1.2.5-1.2,1.2v1.5c0,.6.5,1.2,1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M140.8,487.1h3.6c.6,0,1.2-.5,1.2-1.2v-1.5c0-.6-.5-1.2-1.2-1.2h-3.6c-.6,0-1.2.5-1.2,1.2v1.5c0,.6.5,1.2,1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M132.8,487.1h3.6c.6,0,1.2-.5,1.2-1.2v-1.5c0-.6-.5-1.2-1.2-1.2h-3.6c-.6,0-1.2.5-1.2,1.2v1.5c0,.6.5,1.2,1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M124.8,487.1h3.6c.6,0,1.2-.5,1.2-1.2v-1.5c0-.6-.5-1.2-1.2-1.2h-3.6c-.6,0-1.2.5-1.2,1.2v1.5c0,.6.5,1.2,1.2,1.2" style="fill: #f5eddb;"/>
  </g>
  <g style="clip-path: url(#clippath-6-etl);">
    <path d="M160,437l18.5,4.7c1.7.4,3.5-.6,4-2.4l13.3-52.4c.4-1.7-.6-3.5-2.4-4l-18.5-4.7c-1.7-.4-3.5.6-4,2.4l-13.3,52.4c-.4,1.7.6,3.5,2.4,4" style="fill: #f5eddb;"/>
    <path d="M160.3,435.7l18.2,4.6c1.2.3,2.4-.4,2.7-1.6l13.2-51.8c.3-1.2-.4-2.4-1.6-2.7l-18.3-4.6c-.9-.2-1.9.3-2.1,1.3l-13.4,52.6c-.2,1,.3,2,1.3,2.2Z" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="193.7" y1="390.4" x2="171.6" y2="384.8" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="182.3" y1="435.3" x2="160.2" y2="429.7" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <rect x="160.9" y="408" width="46.1" height="7.7" transform="translate(-260.5 488.6) rotate(-75.7)" style="fill: #7f8560;"/>
    <rect x="146.6" y="404.3" width="46.1" height="7.7" transform="translate(-267.8 471.9) rotate(-75.7)" style="fill: #df7a50;"/>
    <polygon points="165.1 430.8 178.7 434.3 182.3 400.3 168.5 398.9 165.1 430.8" style="fill: #f5eddb;"/>
    <rect x="173" y="391.7" width="5.3" height="10.6" transform="translate(-237.6 529.8) rotate(-83.9)" style="fill: #f5eddb;"/>
    <path d="M179,396.1h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M175.8,395.7h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M172.6,395.4h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M180,402.1h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M176.8,401.7h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M173.6,401.4h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M170.4,401h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M179.4,408h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M176.2,407.7h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M173,407.3h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M169.7,407h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M178.7,414h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M175.5,413.7h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M172.3,413.3h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M169.1,413h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M178.1,420h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M174.9,419.6h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M171.7,419.3h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M168.5,418.9h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M177.5,425.9h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M174.3,425.6h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M171.1,425.2h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M167.9,424.9h0c.5,0,.8.5.8.9l-.3,3-1.7-.2.3-3c0-.5.5-.8.9-.8" style="fill: #7f8560;"/>
    <path d="M20.2,400.6c2,10.2,11.9,16.8,22,14.8,10.2-2,16.8-11.9,14.8-22-2-10.2-11.9-16.8-22-14.8-10.2,2-16.8,11.9-14.8,22" style="fill: #fdc853;"/>
    <path d="M40.3,406.4s1.6-.2,5.8-.2c4.2,0,7.3,2.3,7.3,2.3l-1.3,2.9-8.4,5.5-10.6-.4-4.2-2.2s-1.7-6,11.3-7.9" style="fill: #7f8560;"/>
    <path d="M35,398c1,.2,1.4.8,1.9,1.8,1,2.3,1.3,4.9,2.3,7.2.4.9,1,2.3,2,2.7,1.7.5,3.1-1.1,3.2-2.7,0-.9-.5-1.8-.4-2.6,0-.8.8-1.1,1.4-1.6,1.2-.9,2.1-1.9,2.3-3.4.1-1.2,0-2.6-.7-3.6-.7-1-1.8-1.1-2.2.3-.3,1.1.4,3-1.3,3.2-1.3.2-1.3-1.2-1.5-2.1-.5-2.3-1-4.8-1.7-7-.5-1.6-1.1-3.1-1.9-4.5-.5-.8-.9-2.1-1.8-2.6-2.7-1.7-3.2,2.3-2.9,4.1.2,1.9,1,3.6,1.3,5.4.3,1.8-1.8,1.6-2.6.7-.9-1-1.2-2.5-1.7-3.8-.5-1.3-2.8-5.9-4.2-3-.9,1.8.8,4.1,1.6,5.6.8,1.6,1.3,3.4,2.6,4.6,1,.9,2.5,1.2,3.8,1.2.2,0,.4,0,.5,0" style="fill: #7f8560;"/>
    <path d="M34.3,375.5c-11.9,2.3-19.6,13.8-17.3,25.7,2.3,11.9,13.8,19.6,25.7,17.3,11.9-2.3,19.6-13.8,17.3-25.7-2.3-11.9-13.8-19.6-25.7-17.3M42.1,415.4c-10.2,2-20-4.6-22-14.8-2-10.2,4.6-20,14.8-22,10.2-2,20,4.6,22,14.8s-4.6,20-14.8,22" style="fill: #f5eddb;"/>
    <path d="M54,383.8l89.8,9.5c3.6.4,6.9-2.2,7.3-5.9l3.9-36.3c.4-3.6-2.2-6.9-5.9-7.3l-89.8-9.5c-3.6-.4-6.9,2.2-7.3,5.9l-3.9,36.3c-.4,3.6,2.2,6.9,5.9,7.3Z" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M112,389.9l32.2,3.4c3.4.4,6.5-2.1,6.9-5.6l3.9-37c.4-3.4-2.1-6.5-5.6-6.9l-32.2-3.4-5.2,49.4Z" style="fill: #f5eddb;"/>
    <text transform="translate(109.5 355) rotate(-173.9) scale(1 -1)" style="fill: #f5eddb; font-family: RalewayRoman-ExtraBold, &apos;RalewayRoman ExtraBold&apos;; font-size: 12px; font-weight: 700;"><tspan x="0" y="0" style="letter-spacing: .1em;">T</tspan><tspan x="7.2" y="0" style="letter-spacing: .1em;">R</tspan><tspan x="14.9" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="22.8" y="0" style="letter-spacing: .1em;">VE</tspan><tspan x="37.8" y="0">L</tspan></text>
    <text transform="translate(104.8 373) rotate(-173.9) scale(1 -1)" style="fill: #f5eddb; font-family: RalewayRoman-SemiBold, &apos;RalewayRoman SemiBold&apos;; font-size: 10px; font-weight: 600;"><tspan x="0" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="7.1" y="0" style="letter-spacing: .1em;">RR</tspan><tspan x="19.9" y="0" style="letter-spacing: 0em;">I</tspan><tspan x="23.2" y="0" style="letter-spacing: 0em;">V</tspan><tspan x="29.3" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="36.4" y="0" style="letter-spacing: 0em;">L</tspan></text>
    <line x1="112" y1="360.7" x2="54" y2="354.4" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10;"/>
    <line x1="110" y1="378.7" x2="51.9" y2="372.7" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10;"/>
    <polygon points="102.6 382.4 99.9 382.1 101.9 383.9 100.8 386.3 103.1 385 105.1 386.8 104.6 384.2 106.9 382.8 104.2 382.5 103.7 379.9 102.6 382.4" style="fill: #f5eddb;"/>
    <polygon points="56.6 377.5 54 377.2 55.9 379 54.9 381.4 57.2 380.1 59.2 381.9 58.6 379.2 60.9 377.9 58.3 377.6 57.7 375 56.6 377.5" style="fill: #f5eddb;"/>
    <path d="M132.3,381.1l.5.2c.7,0,1.4-.5,1.5-1.2l3.4-26.1c.1-1.1-.7-2.2-1.9-2.3-1.1-.1-2.2.7-2.3,1.9l-2.4,26.1c0,.7.5,1.4,1.2,1.5" style="fill: #7f8560;"/>
    <path d="M148.6,372.9v-.8c.1-.5-.2-.5-.7-.9l-11.2-8.2-4.2-.4-12.7,5.6c-.5.3-.9.3-1,.8v.4c-.1.8.2,1.2.8,1.3l12.4-3.9,4.2.4,11.4,6.5c.5,0,.9-.3.9-.7" style="fill: #7f8560;"/>
    <path d="M140.7,384v-.4c0-.3-.1-.3-.4-.5l-6.2-4.5-2.3-.2-7,3.1c-.3.2-.5.2-.5.4v.2c0,.4.1.7.4.7l6.8-1.3,2.3.2,6.4,2.7c.3,0,.5-.2.5-.4" style="fill: #7f8560;"/>
    <path d="M190.5,264c-11.5,0-11.5,8-23,8s-11.5-8-23-8-11.5,8-23,8-11.5-8-23-8c-11.5,0-11.5,8-23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M190.5,273c-11.5,0-11.5,8-23,8s-11.5-8-23-8-11.5,8-23,8c-11.5,0-11.5-8-23-8-11.5,0-11.5,8-23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M190.5,283c-11.5,0-11.5,8-23,8s-11.5-8-23-8-11.5,8-23,8c-11.5,0-11.5-8-23-8s-11.5,8-23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M190.5,292c-11.5,0-11.5,8-23,8s-11.5-8-23-8-11.5,8-23,8c-11.5,0-11.5-8-23-8s-11.5,8-23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M190.5,301c-11.5,0-11.5,8-23,8s-11.5-8-23-8-11.5,8-23,8c-11.5,0-11.5-8-23-8s-11.5,8-23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
  </g>
  <polygon points="218.3 28.7 201.4 28.7 184.4 28.7 167.4 28.7 150.4 28.7 133.4 28.7 117.8 28.7 117.8 31 116.8 31 119.6 0 222.2 0 224.1 28.7 218.3 28.7" style="fill: #fdc853;"/>
  <g>
    <path d="M148.8,528h17.4s17.4,0,17.4,0h17.4s1,0,1,0h17.4s4.4,0,4.4,0c-5.2,8.1-22.8,30.9-56.3,30.9-33.3,0-46.6-22.7-50.3-30.9h14.3s17.4,0,17.4,0Z" style="fill: #df7a50;"/>
    <path d="M177.5,336.6l46.1,44.2s30.2-48.6,0-92.3l-46.1,48.1Z" style="fill: #765a54;"/>
  </g>
  <foreignObject x="119.3" y="100.8" width="100" height="200" id="left-group">
  </foreignObject>
</svg>
    `;


    svgEnTransitRight = `
    <svg
        style="height: 700px; margin-left: 20px; margin-right: 75px;"
        id="svg-right"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 120.2 558.9"
    >
  <!-- Generator: Adobe Illustrator 30.6.0, SVG Export Plug-In . SVG Version: 2.1.4 Build 109)  -->
  <defs>
    <clipPath id="clippath-etr">
      <rect x="13.1" y="27.6" width="106.9" height="502.9" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-1-etr">
      <path d="M170.4,60.7c0-13.4,10.9-24.3,24.3-24.3s24.3,10.9,24.3,24.3" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-2-etr">
      <rect x="193" y="158.5" width="37" height="37" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-3-etr">
      <path d="M229,179.2c-1,8.7-8.5,15.5-17.5,15.5s-16.5-6.8-17.5-15.5c0,0,35.1-.7,35,0" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-4-etr">
      <path d="M189.4,448.5c11.6,4.2,17.5,16.9,13.4,28.5-4.2,11.6-16.9,17.5-28.5,13.4-11.6-4.2-17.5-16.9-13.4-28.5,4.2-11.6,16.9-17.5,28.5-13.4" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-5-etr">
      <path d="M66.9,475.4c-8.8,0-16,7.2-16,16v6.8c0,8.8,7.2,16,16,16h49.3c1.3,0,2.6-.2,3.9-.5v-37.9c-1.2-.3-2.5-.5-3.9-.5h-49.3Z" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-6-etr">
      <rect x="13.1" y="27.6" width="106.9" height="502.9" style="fill: none;"/>
    </clipPath>
  </defs>
  <rect x="13.1" y="27.6" width="106.9" height="501.3" style="fill: #7f8560;"/>
  <g style="clip-path: url(#clippath-etr);">
    <path d="M164.5,159.4l-18.3-5.4c-1.7-.5-2.7-2.3-2.2-4.1l15.2-51.9c.5-1.7,2.3-2.7,4.1-2.2l18.3,5.4c1.7.5,2.7,2.3,2.2,4.1l-15.2,51.9c-.5,1.7-2.3,2.7-4.1,2.2" style="fill: #f5eddb;"/>
    <path d="M164.9,158.1l-18-5.3c-1.2-.3-1.8-1.6-1.5-2.7l15-51.3c.3-1.2,1.6-1.8,2.7-1.5l18.1,5.3c.9.3,1.5,1.2,1.2,2.2l-15.2,52c-.3,1-1.3,1.5-2.2,1.2Z" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="159.2" y1="102.1" x2="181.1" y2="108.5" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="146.2" y1="146.6" x2="168.1" y2="153" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <rect x="133.6" y="121.7" width="46.1" height="7.7" transform="translate(-7.8 240.7) rotate(-73.7)" style="fill: #765a54;"/>
    <rect x="147.8" y="125.8" width="46.1" height="7.7" transform="translate(-1.6 257.3) rotate(-73.7)" style="fill: #df7a50;"/>
    <path d="M166.4,152.5s-2.8-6.7-2.8-14.7c0-8.1,3.7-19.2,3.7-19.2l.6.2.4-1.4h-.5c0-.1.3-1,.3-1l-.6-.2.8-2.7-.6-.2-.8,2.7-.6-.2-.3.9h-.5c0-.1-.4,1.3-.4,1.3l.6.2s-2.9,11.3-7.2,18.2c-4.3,6.8-10.3,10.9-10.3,10.9l3.9,1.1s0-.6,1.9-2.1c1.8-1.5,4.4-.3,4.4-.3,0,0,2.8.3,3.5,2.6.7,2.3.4,2.8.4,2.8l3.9,1.2ZM159.7,142.4h0s-2.4-.7-2.4-.7c.7-1.1,2.3-4.4,2.3-4.4l1.4.4,1.4.4s-.4,3.7-.4,5l-2.3-.7Z" style="fill: #765a54;"/>
    <path d="M168.3,61c0-14.6,11.8-26.4,26.4-26.4s26.4,11.8,26.4,26.4" style="fill: #f5eddb;"/>
    <rect x="168.2" y="60.7" width="52.9" height="9.9" style="fill: #df7a50;"/>
    <rect x="219.2" y="60.7" width="2" height="9.9" style="fill: #f5eddb;"/>
    <rect x="168.3" y="60.7" width="2" height="9.9" style="fill: #f5eddb;"/>
    <rect x="168.2" y="68.7" width="52.9" height="2" style="fill: #f5eddb;"/>
    <polygon points="194.7 66.3 192.8 67.3 193.2 65.2 191.6 63.7 193.7 63.4 194.7 61.4 195.7 63.4 197.8 63.7 196.3 65.2 196.6 67.3 194.7 66.3" style="fill: #fdc853;"/>
    <polygon points="205.1 66.3 203.1 67.3 203.5 65.2 202 63.7 204.1 63.4 205.1 61.4 206 63.4 208.2 63.7 206.6 65.2 207 67.3 205.1 66.3" style="fill: #fdc853;"/>
    <polygon points="215.4 66.3 213.5 67.3 213.9 65.2 212.3 63.7 214.5 63.4 215.4 61.4 216.4 63.4 218.5 63.7 217 65.2 217.4 67.3 215.4 66.3" style="fill: #fdc853;"/>
    <polygon points="184.4 66.3 182.4 67.3 182.8 65.2 181.2 63.7 183.4 63.4 184.4 61.4 185.3 63.4 187.5 63.7 185.9 65.2 186.3 67.3 184.4 66.3" style="fill: #fdc853;"/>
    <polygon points="174 66.3 172.1 67.3 172.4 65.2 170.9 63.7 173 63.4 174 61.4 175 63.4 177.1 63.7 175.6 65.2 175.9 67.3 174 66.3" style="fill: #fdc853;"/>
    <path d="M170.4,60.7c0-13.4,10.9-24.3,24.3-24.3s24.3,10.9,24.3,24.3" style="fill: #7f8560;"/>
    <g style="clip-path: url(#clippath-1-etr);">
      <line x1="183.4" y1="38" x2="206.2" y2="38" style="fill: #0f406c;"/>
      <line x1="183.4" y1="38" x2="206.2" y2="38" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="173.5" y1="40" x2="217.4" y2="40" style="fill: #0f406c;"/>
      <line x1="173.5" y1="40" x2="217.4" y2="40" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="173.5" y1="42" x2="217.4" y2="42" style="fill: #0f406c;"/>
      <line x1="173.5" y1="42" x2="217.4" y2="42" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="173.5" y1="44" x2="217.4" y2="44" style="fill: #0f406c;"/>
      <line x1="173.5" y1="44" x2="217.4" y2="44" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="173.5" y1="46" x2="217.4" y2="46" style="fill: #0f406c;"/>
      <line x1="173.5" y1="46" x2="217.4" y2="46" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="173.5" y1="48" x2="217.4" y2="48" style="fill: #0f406c;"/>
      <line x1="173.5" y1="48" x2="217.4" y2="48" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="50" x2="217.4" y2="50" style="fill: #0f406c;"/>
      <line x1="168.5" y1="50" x2="217.4" y2="50" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="52" x2="220.4" y2="52" style="fill: #0f406c;"/>
      <line x1="168.5" y1="52" x2="220.4" y2="52" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="54" x2="220.4" y2="54" style="fill: #0f406c;"/>
      <line x1="168.5" y1="54" x2="220.4" y2="54" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="56" x2="220.4" y2="56" style="fill: #0f406c;"/>
      <line x1="168.5" y1="56" x2="220.4" y2="56" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="58" x2="220.4" y2="58" style="fill: #0f406c;"/>
      <line x1="168.5" y1="58" x2="220.4" y2="58" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
      <line x1="168.5" y1="60" x2="220.4" y2="60" style="fill: #0f406c;"/>
      <line x1="168.5" y1="60" x2="220.4" y2="60" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: .5px;"/>
    </g>
    <path d="M200.9,60.6s-3.9-2.2-4.2-2.8c-.3-.6-.2-4-.1-4.6,0-.5-2.6-1.1-4.3-5.1,0,0,0-.8-2.7-.2-2.7.7-3.7,1.2-6,.5-2.3-.7-3.6-4.4-3.6-4.4,0,0,1.5,2.2,2.9,2.6,1.4.4,2.6.8,5.3-.2,2.7-1,5.6-2.4,7.8-2.4,2.1,0,3.9,1,5,2.7,1.2,1.7.8,2.2,1.9,2.3,1,0,2.8-3.2,3.2-3.2.4,0,.2.5,0,1.2s-.4.7,0,1.3c.3.6,1.3,1.5,1.3,2s-1.3,0-1.9,0c-.6,0-1.3.2-1.6.6-.2.4-1.3,1.2-2.9,1.3h-.9c0,.1.2,1-1.8,2.1,0,0-.4.3-.3,1.5.1,1.2,1.4,2.4,1.9,2.7.5.2,1.5,1,1.5,1,0,0,.8.5-.3.8" style="fill: #fdc853;"/>
    <path d="M165,234.2l-49,5.2c-8.8.9-16.7-5.5-17.6-14.2l-.7-6.8c-.9-8.8,5.5-16.7,14.2-17.6l49-5.2c8.8-.9,16.7,5.5,17.6,14.2l.7,6.8c.9,8.8-5.5,16.7-14.2,17.6" style="fill: #f5eddb;"/>
    <path d="M165,234.2l-49,5.2c-8.8.9-16.7-5.5-17.6-14.2l-.7-6.8c-.9-8.8,5.5-16.7,14.2-17.6l49-5.2c8.8-.9,16.7,5.5,17.6,14.2l.7,6.8c.9,8.8-5.5,16.7-14.2,17.6Z" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: 2.1px;"/>
    <polygon points="124.1 224.7 113.7 225.8 118 216.3 122.2 206.8 128.3 215.2 134.5 223.6 124.1 224.7" style="fill: #df7a50;"/>
    <polygon points="122.2 206.8 140.2 222.9 134.5 223.6 122.2 206.8" style="fill: #765a54;"/>
    <polygon points="160.2 220.9 149.9 222 154.1 212.5 158.3 203 164.4 211.4 170.6 219.8 160.2 220.9" style="fill: #df7a50;"/>
    <polygon points="158.3 203 176.3 219.1 170.6 219.8 158.3 203" style="fill: #765a54;"/>
    <polygon points="109.1 226.5 101.9 227.3 104.8 220.7 107.8 214.1 112 219.9 116.3 225.8 109.1 226.5" style="fill: #df7a50;"/>
    <polygon points="107.8 214.1 120.3 225.3 116.3 225.8 107.8 214.1" style="fill: #765a54;"/>
    <path d="M138.6,219.4l.8-.6c.2-.1.3-.2.5-.2h.5c.1,0,.2-.1.3-.2l.9-1,.7-.7c.2-.2.5-.3.8-.4h.4c0,0,.1,0,.2,0l1.6.6c0,0,.1,0,.2,0l1.6.3s0,0,0,0l.8.3c.3.1.5.3.6.5l.4.6c.2.3.4.5.6.6h0c.3.2.5.2.8.2h0c.2,0,.3-.2.4-.4l.2-.9c0-.2,0-.4,0-.6v-.7c-.1-.2,0-.4,0-.6l.6-1c0-.1.2-.2.3-.2h.5c.1,0,.2,0,.3,0l.6.5c.1.1.3.1.4,0l1.3-.5c0,0,.2,0,.3,0h.3c.2.2.4.4.3.7l-.2.5c0,.2-.2.3-.4.3h-.6c0,0-.1.1-.2.2l-.7.5c-.1,0-.2.2-.2.4v1.1c0,0,0,.1,0,.2l-.8,1.8c0,0-.1.2-.2.2l-1.2.6s-.1,0-.2,0l-1.8.2c-.2,0-.3.2-.4.3l-.2.8c0,0,0,.2,0,.3l.4,1s0,0,0,.1l.2,1.5c0,0,0,.1,0,.2l.8,1.4s0,0,0,0l1.9,2.6c.2.3,0,.7-.3.7h-.5c0,0-.6.1-.6.1-.2,0-.5-.1-.5-.4l-.4-1.8c0,0,0-.1,0-.2l-1-1.5s0,0,0-.1l-.7-1.9s0,0,0,0l-.6-1.3c0-.2-.3-.3-.5-.3h-.2c-.2,0-.3.1-.4.3l-.5,1.1-.7,1.7s0,.1,0,.2v.9c0,.1-.1.3-.2.4l-.5.3c-.1,0-.2.2-.2.3l-.2,1.3s0,0,0,0v.7c0,.1,0,.2.2.3.3.3.2.7-.2.8h-.2s-.5,0-.5,0c-.3,0-.6-.2-.5-.5l.2-.9.2-1.6s0,0,0,0v-1.9c.1,0,.1-.2.2-.2l.9-1.4c0,0,0-.2,0-.3l-.2-1.5c0-.3-.3-.5-.6-.4l-.9.3s0,0-.1,0h-1.6c0,0-.1,0-.2,0l-.4.2c-.2,0-.3.3-.3.5v.6c.1.1,0,.3,0,.4l-.5.6c0,0-.1.2-.1.3v1.3c0,0,0,.1,0,.2l1.9,4.3c.1.2,0,.5-.2.6l-.7.3c-.2.1-.5,0-.6-.2l-1.7-3.5c0,0,0-.1,0-.2v-1.3c0-.5-.5-.6-.8-.3l-.5.7c0,0,0,.2,0,.3l.2,1.3c0,0,0,.1,0,.2l-.3.8s0,0,0,0l-.2,1.2c0,.1,0,.3.1.4l.4.4c.2.3,0,.7-.3.8h0s-.5,0-.5,0c-.2,0-.5-.1-.5-.4v-.9c-.1,0-.1-.1,0-.2l.4-1.2s0-.1,0-.2v-1.7c0,0,0,0,0-.1l-.4-1.3c0-.2,0-.4.2-.5l.9-.8s0,0,0-.1l.9-1.3c0,0,0-.2,0-.3v-1.5c0-.3,0-.6,0-.9l.2-2.5c0-.1,0-.3.2-.3" style="fill: #765a54;"/>
    <path d="M151.7,215.3c.1.4.4.7.6.6.2,0,.2-.5,0-.9-.2-.4-.4-.7-.6-.6-.2,0-.2.4,0,.9" style="fill: #765a54;"/>
    <path d="M138.6,219.4l-.6,1c0,.2-.2.3-.2.5v.3c0,.4,0,.8.3,1h0c0,0,.4-2.8.4-2.8Z" style="fill: #765a54;"/>
    <rect x="190.6" y="156.3" width="41.8" height="41.8" style="fill: #f5eddb;"/>
    <rect x="193" y="158.5" width="37" height="37" style="fill: #f5eddb;"/>
    <g style="clip-path: url(#clippath-2-etr);">
      <rect x="165.7" y="156.4" width="71.2" height="23.8" style="fill: #df7a50;"/>
      <path d="M229.1,177.1c0,9.7-7.9,17.6-17.6,17.6s-17.6-7.9-17.6-17.6,7.9-17.6,17.6-17.6,17.6,7.9,17.6,17.6" style="fill: #fdc853;"/>
      <path d="M216.3,176.1s5.7,1.4,12.5.9v1.1c0,0-8,1.1-11.3.4,0,0-1.2-2.1-1.2-2.5" style="fill: #df7a50;"/>
      <polygon points="219.3 176.6 220.3 176.1 222.3 176.2 222.4 177 219.6 177.5 219.3 176.6" style="fill: #df7a50;"/>
      <path d="M222.3,168.3s-1.7,2.8.3,6.3c0,0-3.6-.2-4.6.3,0,0,2.6-5.4,4.3-6.6" style="fill: #df7a50;"/>
      <path d="M222.3,167.3s3.3,2.5,3.4,3.2c0,0,2,1.8,1.2,5.6h-4.5c0,0,1.7-2.3,0-8.7" style="fill: #df7a50;"/>
      <path d="M222.4,165.9v.8s.2.2.6,0c.4-.2.6-.4.8-.4.2,0,.4,0,.4,0,0,0-.1-.2-.5-.2,0,0-.6.1-.7,0-.1,0-.6-.1-.6-.3" style="fill: #df7a50;"/>
      <rect x="165.7" y="179.2" width="71.2" height="18.5" style="fill: #fdc853;"/>
      <path d="M229,179.2c-1,8.7-8.5,15.5-17.5,15.5s-16.5-6.8-17.5-15.5c0,0,35.1-.7,35,0" style="fill: #fdc853;"/>
      <g style="clip-path: url(#clippath-3-etr);">
        <line x1="191.7" y1="179.8" x2="231.3" y2="179.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="181.8" x2="231.3" y2="181.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="183.8" x2="231.3" y2="183.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="185.8" x2="231.3" y2="185.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="187.8" x2="231.3" y2="187.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="189.8" x2="231.3" y2="189.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="191.8" x2="231.3" y2="191.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
        <line x1="191.7" y1="193.8" x2="231.3" y2="193.8" style="fill: none; stroke: #df7a50; stroke-miterlimit: 10; stroke-width: .5px;"/>
      </g>
    </g>
    <rect x="21" y="109.9" width="91.6" height="85.1" style="fill: #f5eddb;"/>
    <path d="M73.8,91h-14.9l-38,12.3v13.5h91.7v-13.5l-38.8-12.3ZM66.4,106.9c-2.7,0-4.9-2.2-4.9-4.9s2.2-4.9,4.9-4.9,4.9,2.2,4.9,4.9-2.2,4.9-4.9,4.9" style="fill: #f5eddb;"/>
    <path d="M71.3,97.7c-2.4-2.7-6.5-2.9-9.2-.5-2.7,2.4-2.9,6.5-.5,9.2,2.4,2.7,6.5,2.9,9.2.5,2.7-2.4,2.9-6.5.5-9.2M62.7,105.3c-1.8-2-1.6-5.1.4-6.9,2-1.8,5.1-1.6,6.9.4,1.8,2,1.6,5.1-.4,6.9-2,1.8-5.1,1.6-6.9-.4" style="fill: #fdc853;"/>
    <path d="M63.9,96.6c-.6-2.1-3.1-4-5.1-4.8-8.9-3.5-21.5,1.6-28.7-6.1-10.2-10.9,2.5-21.2,7.8-30.4,5.2-9,4.6-20.2,3.7-30.2" style="fill: none; stroke: #fdc853; stroke-miterlimit: 10; stroke-width: 3px;"/>
    <path d="M143.2,80.4c0,15.2-12.4,27.6-27.6,27.6s-27.6-12.4-27.6-27.6,12.4-27.6,27.6-27.6,27.6,12.4,27.6,27.6" style="fill: #f5eddb;"/>
    <path d="M137.8,80.4c0,12.3-10,22.2-22.2,22.2s-22.2-10-22.2-22.2,10-22.2,22.2-22.2,22.2,10,22.2,22.2" style="fill: #765a54;"/>
    <path d="M115.6,55c-14,0-25.4,11.4-25.4,25.4s11.4,25.4,25.4,25.4,25.4-11.4,25.4-25.4-11.4-25.4-25.4-25.4M115.6,104.5c-13.3,0-24.1-10.8-24.1-24.1s10.8-24.1,24.1-24.1,24.1,10.8,24.1,24.1-10.8,24.1-24.1,24.1" style="fill: #765a54;"/>
    <path d="M124.5,94c-.2,0-.2-.1-.2-.2-.2-1.1-.6-2.1-1.3-3-1.5-1.8-3.8-2.4-5.9-1.5-1.4.6-2.3,1.6-2.9,3-.1.3-.1.3-.5.2-.4-.1-.8-.2-1.2-.3-2.3-.3-4.4,1.2-4.9,3.4,0,.2-.1.3-.3.2-.5,0-.9-.1-1.4,0-1.5.3-2.7,1.5-2.9,3,3.6,2.5,7.9,3.9,12.6,3.9s8.7-1.3,12.2-3.6c0-.3,0-.6,0-.9,0-.6,0-1.2-.3-1.7-.6-1.4-1.5-2.3-3.1-2.5" style="fill: #f5eddb;"/>
    <polygon points="115.6 102.7 93.2 78.5 93.6 72.3 96.5 67 115.6 102.7" style="fill: #f5eddb;"/>
    <polygon points="115.6 102.7 103 60.7 110 57.8 115.6 102.7" style="fill: #f5eddb;"/>
    <polygon points="115.9 102.7 138.3 78.5 138 72.3 135.1 67 115.9 102.7" style="fill: #f5eddb;"/>
    <polygon points="115.9 102.7 128.5 60.7 121.5 57.8 115.9 102.7" style="fill: #f5eddb;"/>
    <path d="M117.5,71.2l-6.8-9.5-3.2,1.9s1.8,7.8,5.4,11.1l4.7-3.4Z" style="fill: #df7a50;"/>
    <path d="M120.4,75.4l6.5,9.7-2.9,2.3s-6.6-4.4-8.5-8.9l4.8-3.2Z" style="fill: #df7a50;"/>
    <path d="M106.1,82.5l-3.8-6.2,1.4-1.3s3.5,2.1,4.5,4.4l-2.1,3Z" style="fill: #df7a50;"/>
    <path d="M106.1,82.5l5,5.5,1.6-1s-1.1-3.9-3-5.5l-3.6,1.1Z" style="fill: #df7a50;"/>
    <path d="M106,82.5s0,0,0,0h0c9-1.4,15-7.8,16.5-9,1.5-1.2-.1-2.7-.1-2.7h0c0-.1-1-1.9-2.5-1-1.6,1-9.6,4.6-13.8,12.6h0s0,0,0,0" style="fill: #df7a50;"/>
    <path d="M125.2,68.7s-3-.5-3.2.4c-.2.9,1.5,2.7,1.7,2.7.2,0,1.3-.3,1.4-3.1" style="fill: #df7a50;"/>
    <path d="M123.6,68.4s-1.7-3.7-2.4-4.2c-.7-.5-1.5.7-1.5.7,0,0-.1,1.2,4,3.5" style="fill: #df7a50;"/>
    <path d="M125.1,70.8s3,2.8,3.3,3.6c.3.8-1.2,1.2-1.2,1.2,0,0-1.2-.2-2.1-4.9" style="fill: #df7a50;"/>
    <path d="M191.2,443.5c14.3,5.2,21.7,21,16.6,35.3-5.2,14.3-21,21.7-35.3,16.6-14.3-5.2-21.7-21-16.6-35.3,5.2-14.3,21-21.7,35.3-16.6" style="fill: #f5eddb;"/>
    <path d="M189.4,448.5c11.6,4.2,17.5,16.9,13.4,28.5-4.2,11.6-16.9,17.5-28.5,13.4-11.6-4.2-17.5-16.9-13.4-28.5,4.2-11.6,16.9-17.5,28.5-13.4" style="fill: #fdc853;"/>
    <g style="clip-path: url(#clippath-4-etr);">
      <path d="M202.4,488.6c-.2,0-.3-.1-.3-.3l-1.7-.2v.2c0,.2-.1.3-.3.3h-.5c-.2,0-.3-.1-.3-.3v-8.3l-24.3,3.9v7.4c0,.2-.1.3-.3.3h-5.1c-.2,0-.3-.1-.3-.3v-6.5l-5.8.9s0,0,0,0c0,0-.1,0-.2,0,0,0-.1-.1-.1-.2v-2.4c0-.1.1-.3.2-.3l5.9-.9s0-14,0-14c-.1.4-.3.7-.5,1.1l-.2.5c-.2.4-.3.7-.5,1.1v.3c-.4.4-.6.9-.8,1.3l-.4.8-.4.8c-.2.3-.4.7-.6,1l-.3.5-.7,1.1-.5.6c-.5.7-1.1,1.5-1.6,2.2-.2.3-.7.9-1,1-.9.2-.4-.8-.2-1.1,1-1.5,2.3-2.7,3.2-4.3,0,0,.3-.5.3-.5.2-.3.4-.7.6-1l.4-.8.4-.8c.2-.4.4-.9.7-1.3v-.3c.3-.3.5-.7.6-1l.2-.5c.2-.3.3-.7.5-1l.3-.6c.2-.3.3-.7.4-1v-.3c.1,0,.1-8.7.1-8.7l-.5,1.5c0,.3-.2.5-.3.8l-.8,2.4-.8,2.4-.9,2.4-.6,1.6c-.1.3-.2.5-.3.8-.6,1.3-1.3,2.4-2.1,3.5-.5.8-1.1,1.7-1.7,2.4-.6.6-1,1.7-2,1.4,0-.8,1.1-1.7,1.5-2.3,1.3-1.8,2.6-3.3,3.5-5.3.1-.2.2-.5.3-.7l.6-1.6.9-2.3.8-2.4.8-2.4c0-.3.2-.5.3-.8l.5-1.6c.1-.4.3-.8.4-1.2l.4-1.4v-1.2c0-.1,0-.3.2-.3h.8c0-.1,0-.1,0-.1,0,0,.1,0,.2,0,0,0,.1.1.1.2v.5l2.8-.5v-.6c0-.1,0-.3.2-.3l.9-.2s0,0,0,0c0,0,.1,0,.2,0,0,0,.1.1.1.2v1.1c.2.8.5,1.7.7,2.6.3,1.2.7,2.3,1.1,3.5.8,2.5,1.6,4.7,2.5,6.8,1.1,2.6,2.1,4.6,3.2,6.5.7,1.1,1.3,2.1,2,2.9.9,1.1,1.7,1.8,2.6,2.4.4.3.9.5,1.4.7,0,0,.1,0,.2,0,.5-.3.9-.6,1.4-1,.8-.7,1.6-1.6,2.4-2.7.6-.8,1.2-1.8,1.9-3.1,1-1.9,2-4.1,3-6.6.7-1.8,1.4-3.7,2.1-5.9v-1.3c0-.1,0-.3.2-.3,0,0,.6,0,.6,0,0,0,.1,0,.2,0,0,0,0,.1,0,.2v.3l1.7-.2v-.3c0-.1.1-.3.2-.3,0,0,.6,0,.6,0,0,0,.1,0,.2,0,0,0,0,.1,0,.2v1.3c.2.8.5,1.7.8,2.7.4,1.3.9,2.5,1.3,3.6.5,1.3,1.1,2.5,1.7,3.5h0c.1.3.3.6.4.8,0,.1.2.3.3.4h.1c0,.2.1.3.2.4,0,0,.2.3.3.4,0,0,0,.1,0,.2,0,.1,0,.2-.2.3,0,0,0,0-.1,0,0,0-.2,0-.2,0,0,0-.3-.4-.3-.4,0,0-.1-.2-.2-.3h0c0-.3-.2-.4-.3-.6-.2-.2-.3-.5-.5-.8-.6-1.1-1.2-2.2-1.7-3.6-.5-1.1-.9-2.4-1.4-3.6,0-.3-.2-.5-.3-.8v6.3c.3.7.6,1.3.9,1.9.4.8.8,1.4,1.3,1.9.6.7,1.1,1.2,1.6,1.5.3.2.7.3,1,.3h.1c.2,0,.3.1.3.3s0,.2,0,.2c0,0-.1,0-.2,0s-.1,0-.2,0c-.4,0-.8-.2-1.2-.4-.6-.3-1.2-.9-1.8-1.6-.4-.5-.9-1.2-1.3-2-.1-.3-.3-.5-.4-.8v8.5l4.9-.7s0,0,0,0c0,0,.1,0,.2,0,0,0,0,.1,0,.2v1.8c0,.1,0,.3-.2.3l-5,.8v8.9c0,.2-.1.3-.3.3h-.6ZM201.5,487.3l-.3-.4-.3.3h.6ZM202.2,486.6v-.7l-.3.3.3.4ZM200.4,486.3l.2-.2-.2-.2v.4ZM201.2,485.5l.3-.3h-.6c0,0,.3.3.3.3ZM201.5,484.2l-.3-.4-.3.3h.6ZM202.2,483.5v-.7l-.3.3.3.4ZM200.4,483.3l.2-.2-.2-.2v.4ZM201.2,482.4l.3-.3h-.6s.3.3.3.3ZM170.7,481.8l2.8-.4v-7.8h-2.8v8.2ZM175,481.1l10.2-1.5h0c-.3,0-.6-.2-.9-.3-.3-.1-.6-.2-.9-.4-1-.5-1.9-1.3-2.9-2.4-.8-.8-1.5-1.8-2.3-2.9-1.1-1.6-2.1-3.4-3.1-5.6v13.1ZM201.5,481.1l-.3-.3-.3.3h.6ZM202.2,480.4v-.7l-.3.3.3.4ZM175.3,466.8c1.2,2.6,2.2,4.6,3.4,6.4.7,1.1,1.5,2.1,2.2,2.9.9,1,1.8,1.7,2.7,2.2.3.1.5.3.8.4.3,0,.5.2.8.2.3,0,.6,0,.9,0s.5,0,.8,0c.2,0,.3,0,.5-.1-.3-.1-.5-.3-.8-.4-.9-.6-1.8-1.4-2.7-2.5-.7-.9-1.4-1.9-2.1-3-1.1-1.9-2.2-4-3.2-6.6-.9-2.1-1.7-4.4-2.5-6.9-.4-1.1-.7-2.2-1-3.3v10l.3.7ZM189.5,478.7c0,0,.2,0,.2,0,.2,0,.4,0,.5,0,.2,0,.5,0,.8-.2.2,0,.5-.2.8-.3.5-.2.9-.6,1.4-1,.8-.7,1.5-1.6,2.3-2.7.6-.9,1.2-1.9,1.8-3.1.7-1.3,1.3-2.7,1.9-4.3v-5.8c-.5,1.5-1,2.8-1.4,4-1,2.6-2,4.8-3,6.7-.7,1.3-1.3,2.3-1.9,3.2-.8,1.1-1.6,2.1-2.5,2.8-.3.3-.7.5-1,.7M199.3,468.7c-.4,1-.9,2-1.3,2.9-.6,1.3-1.2,2.3-1.8,3.2-.8,1.2-1.6,2.1-2.4,2.8-.4.4-.8.7-1.2.9l6.8-1v-8.9ZM200.4,477.4l1.7-.3v-5.4h-1.7v5.6ZM170.7,471.3h2.8v-3.8l-2.8.2v3.6ZM200.4,470h1.7v-2.3h-1.7v2.3ZM200.4,466h1.7c0,0,0-2.4,0-2.4h-1.7c0,.1,0,2.4,0,2.4ZM170.7,465.3l2.8-.2v-3.7s-2.7.3-2.7.3v3.6ZM200.6,459.7v2.1s1.6,0,1.6,0v-2.2s-1.6.2-1.6.2ZM170.7,459.3l2.8-.4v-3.7s-2.8.4-2.8.4v3.6Z" style="fill: #df7a50;"/>
    </g>
    <path d="M157.9,460.8c-4.8,13.2,2.1,27.8,15.3,32.5,13.2,4.8,27.8-2.1,32.5-15.3,4.8-13.2-2.1-27.8-15.3-32.5-13.2-4.8-27.8,2.1-32.5,15.3M204.5,477.6c-4.5,12.5-18.3,19-30.9,14.5-12.5-4.5-19-18.3-14.5-30.9,4.5-12.5,18.3-19,30.9-14.5,12.5,4.5,19,18.3,14.5,30.9" style="fill: #765a54;"/>
    <path d="M62,203.8c4.4,9.4.3,20.5-9.1,24.9-9.4,4.4-20.5.3-24.9-9.1-4.4-9.4-.3-20.5,9.1-24.9,9.4-4.4,20.5-.3,24.9,9.1" style="fill: #df7a50;"/>
    <path d="M31.8,210.1s-1.9-3.1,4.1-4.2c0,0-1.6-2.7-3.6-1.6,0,0,1.7-3.7,5.6.2,0,0,1-4.2,4.5-3.1,0,0-2.2,1.5-2.4,3.1,0,0,3.9-2.9,5.5-.3,0,0-1.8-.6-3.3,1.4,0,0,5.1,0,3.2,3.5,0,0-.2-1.8-3.1-2.1,0,0,2.4,2.5,1,3.9,0,0-1.7-3.4-2.6-2.7,0,0-.1.1-.2.2l1.3,1.8,3.2,4.6,2.8,4.2,1.4,2.4-2,.9-.4-2.3-.8-1.6-2.1-3.3-2.8-4.1-1.1-1.6c-.6,1.4-1,3.5.1,4.3,0,0-3.4.8-2.3-4.1,0,0-3.5,3.4-1.9,4.9,0,0-4.6-2.3.4-5.6,0,0-2.8-.8-4.4,1.2" style="fill: #fdc853;"/>
    <path d="M57.4,206.2s-.2-2.6-4.1-.8c0,0-.1-2.2,1.5-2.4,0,0-2.5-1.4-3.2,2.4,0,0-2.3-2-3.9,0,0,0,1.9,0,2.7.8,0,0-3.4-.1-3.4,2.1,0,0,.8-1.1,2.5-.5,0,0-3,2-.4,3.4,0,0-.6-1.1,1-2.5,0,0-.4,2.4,1,2.7,0,0-.4-2.7.4-2.7,0,0,.1,0,.2,0v1.6s0,4,0,4v3.6c.1,0,.3,1.9.3,1.9l1.5-.3-.7-1.5-.2-1.3v-2.8c-.1,0-.2-3.6-.2-3.6v-1.4c.9.5,2,1.7,1.7,2.6,0,0,2.4-.9-.3-3.3,0,0,3.5.6,3.1,2.1,0,0,1.8-3.2-2.5-3.1,0,0,1.4-1.6,3.1-1" style="fill: #fdc853;"/>
    <path d="M49.2,220.3s-1.4.8-4.8,3.2c-3.4,2.5-4.6,6.1-4.6,6.1l2.8,1.6,10-.5,8.3-6.5,2.2-4.2s-2.1-5.9-13.8.3" style="fill: #fdc853;"/>
    <path d="M35.8,191.8c-11,5.1-15.8,18.1-10.7,29.1,5.1,11,18.1,15.8,29.1,10.7,11-5.1,15.8-18.1,10.7-29.1-5.1-11-18.1-15.8-29.1-10.7M52.9,228.7c-9.4,4.4-20.5.3-24.9-9.1-4.4-9.4-.3-20.5,9.1-24.9,9.4-4.4,20.5-.3,24.9,9.1,4.4,9.4.3,20.5-9.1,24.9" style="fill: #f5eddb;"/>
    <path d="M210.8,266.2l1.3-5.4c.2-.8-.3-1.6-1.1-1.8l-5.4-1.3c-.8-.2-1.6.3-1.8,1.1-.2.9-.3,2.1-.7,3-.5,1-1.6.8-2.6.6-.8-.2-1.3-1-1.1-1.8l.6-2.7c.2-.8-.3-1.6-1.1-1.8l-5.4-1.3c-.8-.2-1.6.3-1.8,1.1l-.6,2.7c-.2.8-1,1.3-1.8,1.1h-.4c-.8-.3-1.3-1.1-1.1-1.9l.6-2.7c.2-.8-.3-1.6-1.1-1.8l-5.4-1.3c-.8-.2-1.6.3-1.8,1.1l-.6,2.7c-.2.8-1,1.3-1.8,1.1h-.6c-.8-.3-1.3-1.2-1.1-2l.6-2.7c.2-.8-.3-1.6-1.1-1.8l-5.4-1.3c-.8-.2-1.6.3-1.8,1.1l-.6,2.7c-.2.8-1,1.3-1.8,1.1-1-.2-1.8-.7-1.7-1.8.1-.9.4-1.9.6-2.8.2-.8-.3-1.6-1.1-1.8l-5.4-1.3c-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l2.7.6c.8.2,1.3,1,1.1,1.8-.2.8-1,1.3-1.8,1.1l-2.7-.6c-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l2.7.6c.8.2,1.3,1,1.1,1.8v.4c-.3.8-1.1,1.3-1.9,1.1l-2.7-.6c-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l2.7.6c.8.2,1.3,1,1.1,1.8v.4c-.3.8-1.1,1.3-1.9,1.1l-2.7-.6c-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l2.7.6c.8.2,1.3,1,1.1,1.8v.4c-.3.8-1.1,1.3-1.9,1.1l-2.7-.6c-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l2.7.6c.8.2,1.3,1,1.1,1.8-.6,2.4-2.9,1.2-4.6.8-.8-.2-1.6.3-1.8,1.1l-1.3,5.4c-.2.8.3,1.6,1.1,1.8l5.4,1.3c.8.2,1.6-.3,1.8-1.1.2-1,.3-2.7,1.2-3.4,1.1-.8,3.4,0,3,1.6l-.6,2.7c-.2.8.3,1.6,1.1,1.8l5.4,1.3c.8.2,1.6-.3,1.8-1.1l.6-2.7c.2-.8,1-1.3,1.8-1.1h.6c.8.3,1.3,1.2,1.1,2l-.6,2.7c-.2.8.3,1.6,1.1,1.8l5.4,1.3c.8.2,1.6-.3,1.8-1.1l.6-2.7c.2-.8,1-1.3,1.8-1.1h.4c.8.3,1.3,1.1,1.1,1.9l-.6,2.7c-.2.8.3,1.6,1.1,1.8l5.4,1.3c.8.2,1.6-.3,1.8-1.1l.6-2.7c.2-.8,1-1.3,1.8-1.1,2.4.6,1.7,2.9,1.3,4.7-.2.8.3,1.6,1.1,1.8l5.4,1.3c.8.2,1.6-.3,1.8-1.1l1.3-5.4c.2-.8-.3-1.6-1.1-1.8-1.3-.3-3.2-.3-3.6-1.9-.3-1.1.5-2.4,1.8-2.1,0,0,2.7.6,2.7.6.8.2,1.6-.3,1.8-1.1l1.3-5.4c.2-.8-.3-1.6-1.1-1.8l-2.7-.6c-.8-.2-1.3-1-1.1-1.8v-.4c.3-.8,1.1-1.3,1.9-1.1l2.7.6c.8.2,1.6-.3,1.8-1.1l1.3-5.4c.2-.8-.3-1.6-1.1-1.8l-2.7-.6c-.8-.2-1.3-1-1.1-1.8v-.4c.3-.8,1.1-1.3,1.9-1.1l2.7.6c.8.2,1.6-.3,1.8-1.1l1.3-5.4c.2-.8-.3-1.6-1.1-1.8l-2.7-.6c-.8-.2-1.3-1-1.1-1.8v-.4c.3-.8,1.1-1.3,1.9-1.1l2.7.6c.8.2,1.6-.3,1.8-1.1l1.3-5.4c.2-.8-.3-1.6-1.1-1.8l-2.7-.6c-.8-.2-1.3-1-1.1-1.8.2-.8,1-1.3,1.8-1.1l2.7.6c.8.2,1.6-.3,1.8-1.1" style="fill: #f5eddb;"/>
    <rect x="150.9" y="265.6" width="51" height="40.3" transform="translate(-142.8 390) rotate(-76.4)" style="fill: #df7a50;"/>
    <rect x="165.3" y="283.8" width="13.4" height="40.3" transform="translate(-163.9 399.7) rotate(-76.4)" style="fill: #7f8560;"/>
    <rect x="177.1" y="281.7" width="2.6" height="31.4" transform="translate(-152.7 400.9) rotate(-76.4)" style="fill: #f5eddb;"/>
    <rect x="178.9" y="280.7" width="2.6" height="29.1" transform="translate(-149.2 400.9) rotate(-76.4)" style="fill: #f5eddb;"/>
    <rect x="180.5" y="279.8" width="2.6" height="26.5" transform="translate(-145.8 400.9) rotate(-76.4)" style="fill: #f5eddb;"/>
    <path d="M184.4,277.7l1.5-6.1c8.8,4,11.7,10.3,10.2,18.3l-1.1,5-4.7-1.1-5.9-16.1Z" style="fill: #f5eddb;"/>
    <path d="M184.9,278.6l1.4-5.6c7.1,5.2,7.6,13.1,6.9,21.5l-9.2-2.2.9-13.7Z" style="fill: #7f8560;"/>
    <path d="M169.3,288.7l-.3-8c2.9.8,5.4,2.2,7.5,4.3l-.6,5.3-6.6-1.6Z" style="fill: #f5eddb;"/>
    <polygon points="169 280.7 172.7 289.6 169.3 288.7 169 280.7" style="fill: #7f8560;"/>
    <path d="M178.7,279.7l2-4.6c8.8,5,10.7,12,11.7,19.2l-6.5-1.6-7.2-13Z" style="fill: #f5eddb;"/>
    <path d="M179.2,280.3l1.8-4.1c4.7,3.1,7.3,9.9,8,17.2l-10.6-2.5.8-10.6Z" style="fill: #7f8560;"/>
    <path d="M172.7,289.6l2.5-11.2c7.7,1.7,11.9,6.8,12.1,14.7l-14.7-3.5Z" style="fill: #f5eddb;"/>
    <path d="M173.7,289.8l2.3-9.7c3.1,1.9,6.4,5,7.1,11.9l-9.4-2.3Z" style="fill: #7f8560;"/>
    <path d="M66.9,474.4h49.3c9.4,0,17.1,7.6,17.1,17.1v6.8c0,9.4-7.6,17.1-17.1,17.1h-49.3c-9.4,0-17.1-7.6-17.1-17.1v-6.8c0-9.4,7.6-17.1,17.1-17.1Z" style="fill: #f5eddb;"/>
    <path d="M116.1,475.4c8.8,0,16,7.2,16,16v6.8c0,8.8-7.2,16-16,16h-49.3c-8.8,0-16-7.2-16-16v-6.8c0-8.8,7.2-16,16-16h49.3ZM116.1,473.3h-49.3c-10,0-18.1,8.1-18.1,18.1v6.8c0,10,8.1,18.1,18.1,18.1h49.3c10,0,18.1-8.1,18.1-18.1v-6.8c0-10-8.1-18.1-18.1-18.1" style="fill: #fdc853;"/>
    <path d="M116.1,514.3h-49.3c-8.8,0-16-7.2-16-16v-6.8c0-8.8,7.2-16,16-16h49.3c8.8,0,16,7.2,16,16v6.8c0,8.8-7.2,16-16,16" style="fill: #f5eddb;"/>
  </g>
  <g style="clip-path: url(#clippath-5-etr);">
    <polygon points="47.7 503 141 503 136.7 517.9 69.6 518.4 43.3 514.3 47.7 503" style="fill: #765a54;"/>
    <path d="M116.3,502h-34.8c-2.8,0-5.1-2.3-5.1-5.1v-10.2c0-2.8,2.3-6.1,5.1-6.1h34.8c2.8,0,5.1,3.3,5.1,6.1v10.2c0,2.8-2.3,5.1-5.1,5.1" style="fill: #df7a50;"/>
    <path d="M90.3,501.6c0,1.7-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2,1.4-3.2,3.2-3.2,3.2,1.4,3.2,3.2" style="fill: #765a54;"/>
    <path d="M113.5,500.8c0,1.7-1.4,3.2-3.2,3.2s-3.2-1.4-3.2-3.2,1.4-3.2,3.2-3.2,3.2,1.4,3.2,3.2" style="fill: #765a54;"/>
    <line x1="76.4" y1="488.8" x2="121.3" y2="488.8" style="fill: none; stroke: #765a54; stroke-miterlimit: 10;"/>
    <polygon points="76.7 495.8 50.8 484.3 49.7 490.5 49.7 502.4 76.7 498.2 76.7 495.8" style="fill: #fdc853;"/>
    <path d="M76.2,490.2h2.3c.7,0,1.2.5,1.2,1.2v4.3c0,.7-.5,1.2-1.2,1.2h-2.3v-6.7Z" style="fill: #f5eddb;"/>
    <path d="M87.9,497.1h-3.2c-.8,0-1.4-.6-1.4-1.4v-3.8c0-.8.6-1.4,1.4-1.4h3.2c.8,0,1.4.6,1.4,1.4v3.8c0,.8-.6,1.4-1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M95.9,497.1h-3.2c-.8,0-1.4-.6-1.4-1.4v-3.8c0-.8.6-1.4,1.4-1.4h3.2c.8,0,1.4.6,1.4,1.4v3.8c0,.8-.6,1.4-1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M103.9,497.1h-3.2c-.8,0-1.4-.6-1.4-1.4v-3.8c0-.8.6-1.4,1.4-1.4h3.2c.8,0,1.4.6,1.4,1.4v3.8c0,.8-.6,1.4-1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M111.9,497.1h-3.2c-.8,0-1.4-.6-1.4-1.4v-3.8c0-.8.6-1.4,1.4-1.4h3.2c.8,0,1.4.6,1.4,1.4v3.8c0,.8-.6,1.4-1.4,1.4" style="fill: #f5eddb;"/>
    <path d="M88.2,487.1h-3.6c-.6,0-1.2-.5-1.2-1.2v-1.5c0-.6.5-1.2,1.2-1.2h3.6c.6,0,1.2.5,1.2,1.2v1.5c0,.6-.5,1.2-1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M96.2,487.1h-3.6c-.6,0-1.2-.5-1.2-1.2v-1.5c0-.6.5-1.2,1.2-1.2h3.6c.6,0,1.2.5,1.2,1.2v1.5c0,.6-.5,1.2-1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M104.2,487.1h-3.6c-.6,0-1.2-.5-1.2-1.2v-1.5c0-.6.5-1.2,1.2-1.2h3.6c.6,0,1.2.5,1.2,1.2v1.5c0,.6-.5,1.2-1.2,1.2" style="fill: #f5eddb;"/>
    <path d="M112.2,487.1h-3.6c-.6,0-1.2-.5-1.2-1.2v-1.5c0-.6.5-1.2,1.2-1.2h3.6c.6,0,1.2.5,1.2,1.2v1.5c0,.6-.5,1.2-1.2,1.2" style="fill: #f5eddb;"/>
  </g>
  <g style="clip-path: url(#clippath-6-etr);">
    <path d="M77,437l-18.5,4.7c-1.7.4-3.5-.6-4-2.4l-13.3-52.4c-.4-1.7.6-3.5,2.4-4l18.5-4.7c1.7-.4,3.5.6,4,2.4l13.3,52.4c.4,1.7-.6,3.5-2.4,4" style="fill: #f5eddb;"/>
    <path d="M76.6,435.7l-18.2,4.6c-1.2.3-2.4-.4-2.7-1.6l-13.2-51.8c-.3-1.2.4-2.4,1.6-2.7l18.3-4.6c.9-.2,1.9.3,2.1,1.3l13.4,52.6c.2,1-.3,2-1.3,2.2Z" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="43.3" y1="390.4" x2="65.4" y2="384.8" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="54.7" y1="435.3" x2="76.8" y2="429.7" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <rect x="49.2" y="388.8" width="7.7" height="46.1" transform="translate(-99.9 25.8) rotate(-14.3)" style="fill: #7f8560;"/>
    <rect x="63.5" y="385.1" width="7.7" height="46.1" transform="translate(-98.5 29.2) rotate(-14.3)" style="fill: #df7a50;"/>
    <polygon points="71.8 430.8 58.3 434.3 54.7 400.3 68.4 398.9 71.8 430.8" style="fill: #f5eddb;"/>
    <rect x="56" y="394.3" width="10.6" height="5.3" transform="translate(-41.5 8.7) rotate(-6.1)" style="fill: #f5eddb;"/>
    <path d="M58,396.1h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M61.2,395.7h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M64.4,395.4h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M57,402.1h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M60.2,401.7h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M63.4,401.4h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M66.6,401h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M57.6,408h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M60.8,407.7h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M64,407.3h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M67.2,407h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M58.2,414h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M61.4,413.7h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M64.6,413.3h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M67.8,413h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M58.9,420h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M62.1,419.6h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M65.3,419.3h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M68.5,418.9h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M59.5,425.9h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M62.7,425.6h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M65.9,425.2h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M69.1,424.9h0c-.5,0-.8.5-.8.9l.3,3,1.7-.2-.3-3c0-.5-.5-.8-.9-.8" style="fill: #7f8560;"/>
    <path d="M216.8,400.6c-2,10.2-11.9,16.8-22,14.8-10.2-2-16.8-11.9-14.8-22,2-10.2,11.9-16.8,22-14.8,10.2,2,16.8,11.9,14.8,22" style="fill: #fdc853;"/>
    <path d="M196.7,406.4s-1.6-.2-5.8-.2c-4.2,0-7.3,2.3-7.3,2.3l1.3,2.9,8.4,5.5,10.6-.4,4.2-2.2s1.7-6-11.3-7.9" style="fill: #7f8560;"/>
    <path d="M201.9,398c-1,.2-1.4.8-1.9,1.8-1,2.3-1.3,4.9-2.3,7.2-.4.9-1,2.3-2,2.7-1.7.5-3.1-1.1-3.2-2.7,0-.9.5-1.8.4-2.6,0-.8-.8-1.1-1.4-1.6-1.2-.9-2.1-1.9-2.3-3.4-.1-1.2,0-2.6.7-3.6.7-1,1.8-1.1,2.2.3.3,1.1-.4,3,1.3,3.2,1.3.2,1.3-1.2,1.5-2.1.5-2.3,1-4.8,1.7-7,.5-1.6,1.1-3.1,1.9-4.5.5-.8.9-2.1,1.8-2.6,2.7-1.7,3.2,2.3,2.9,4.1-.2,1.9-1,3.6-1.3,5.4-.3,1.8,1.8,1.6,2.6.7.9-1,1.2-2.5,1.7-3.8.5-1.3,2.8-5.9,4.2-3,.9,1.8-.8,4.1-1.6,5.6-.8,1.6-1.3,3.4-2.6,4.6-1,.9-2.5,1.2-3.8,1.2-.2,0-.4,0-.5,0" style="fill: #7f8560;"/>
    <path d="M202.6,375.5c-11.9-2.3-23.4,5.4-25.7,17.3-2.3,11.9,5.4,23.4,17.3,25.7,11.9,2.3,23.4-5.4,25.7-17.3,2.3-11.9-5.4-23.4-17.3-25.7M194.8,415.4c-10.2-2-16.8-11.9-14.8-22s11.9-16.8,22-14.8c10.2,2,16.8,11.9,14.8,22-2,10.2-11.9,16.8-22,14.8" style="fill: #f5eddb;"/>
    <path d="M182.9,383.8l-89.8,9.5c-3.6.4-6.9-2.2-7.3-5.9l-3.9-36.3c-.4-3.6,2.2-6.9,5.9-7.3l89.8-9.5c3.6-.4,6.9,2.2,7.3,5.9l3.9,36.3c.4,3.6-2.2,6.9-5.9,7.3Z" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M124.9,389.9l-32.2,3.4c-3.4.4-6.5-2.1-6.9-5.6l-3.9-37c-.4-3.4,2.1-6.5,5.6-6.9l32.2-3.4,5.2,49.4Z" style="fill: #f5eddb;"/>
    <text transform="translate(127.4 355) rotate(-6.1)" style="fill: #f5eddb; font-family: RalewayRoman-ExtraBold, &apos;RalewayRoman ExtraBold&apos;; font-size: 12px; font-weight: 700;"><tspan x="0" y="0" style="letter-spacing: .1em;">T</tspan><tspan x="7.2" y="0" style="letter-spacing: .1em;">R</tspan><tspan x="14.9" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="22.8" y="0" style="letter-spacing: .1em;">VE</tspan><tspan x="37.8" y="0">L</tspan></text>
    <text transform="translate(132.1 373) rotate(-6.1)" style="fill: #f5eddb; font-family: RalewayRoman-SemiBold, &apos;RalewayRoman SemiBold&apos;; font-size: 10px; font-weight: 600;"><tspan x="0" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="7.1" y="0" style="letter-spacing: .1em;">RR</tspan><tspan x="19.9" y="0" style="letter-spacing: 0em;">I</tspan><tspan x="23.2" y="0" style="letter-spacing: 0em;">V</tspan><tspan x="29.3" y="0" style="letter-spacing: 0em;">A</tspan><tspan x="36.4" y="0" style="letter-spacing: 0em;">L</tspan></text>
    <line x1="124.9" y1="360.7" x2="182.9" y2="354.4" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10;"/>
    <line x1="126.9" y1="378.7" x2="185.1" y2="372.7" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10;"/>
    <polygon points="134.4 382.4 137 382.1 135.1 383.9 136.1 386.3 133.8 385 131.8 386.8 132.4 384.2 130.1 382.8 132.7 382.5 133.3 379.9 134.4 382.4" style="fill: #f5eddb;"/>
    <polygon points="180.3 377.5 183 377.2 181 379 182.1 381.4 179.8 380.1 177.8 381.9 178.3 379.2 176 377.9 178.7 377.6 179.2 375 180.3 377.5" style="fill: #f5eddb;"/>
    <path d="M104.7,381.1l-.5.2c-.7,0-1.4-.5-1.5-1.2l-3.4-26.1c-.1-1.1.7-2.2,1.9-2.3,1.1-.1,2.2.7,2.3,1.9l2.4,26.1c0,.7-.5,1.4-1.2,1.5" style="fill: #7f8560;"/>
    <path d="M88.4,372.9v-.8c-.1-.5.2-.5.7-.9l11.2-8.2,4.2-.4,12.7,5.6c.5.3.9.3,1,.8v.4c.1.8-.2,1.2-.8,1.3l-12.4-3.9-4.2.4-11.4,6.5c-.5,0-.9-.3-.9-.7" style="fill: #7f8560;"/>
    <path d="M96.3,384v-.4c0-.3.1-.3.4-.5l6.2-4.5,2.3-.2,7,3.1c.3.2.5.2.5.4v.2c0,.4-.1.7-.4.7l-6.8-1.3-2.3.2-6.4,2.7c-.3,0-.5-.2-.5-.4" style="fill: #7f8560;"/>
    <path d="M46.4,264c11.5,0,11.5,8,23,8s11.5-8,23-8,11.5,8,23,8,11.5-8,23-8,11.5,8,23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M46.4,273c11.5,0,11.5,8,23,8s11.5-8,23-8,11.5,8,23,8,11.5-8,23-8,11.5,8,23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M46.4,283c11.5,0,11.5,8,23,8s11.5-8,23-8,11.5,8,23,8,11.5-8,23-8,11.5,8,23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M46.4,292c11.5,0,11.5,8,23,8s11.5-8,23-8,11.5,8,23,8,11.5-8,23-8,11.5,8,23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
    <path d="M46.4,301c11.5,0,11.5,8,23,8s11.5-8,23-8,11.5,8,23,8,11.5-8,23-8,11.5,8,23,8" style="fill: none; stroke: #f5eddb; stroke-miterlimit: 10; stroke-width: 2px;"/>
  </g>
  <polygon points="18.6 28.7 35.6 28.7 52.6 28.7 69.6 28.7 86.6 28.7 103.6 28.7 119.1 28.7 119.1 31 120.2 31 117.4 0 14.7 0 12.9 28.7 18.6 28.7" style="fill: #fdc853;"/>
  <g>
    <path d="M88.2,528H13.2c5.2,8.1,22.8,30.9,56.3,30.9s46.6-22.7,50.3-30.9h-31.6Z" style="fill: #df7a50;"/>
    <path d="M59.5,336.6l-46.1,44.2s-30.2-48.6,0-92.3l46.1,48.1Z" style="fill: #765a54;"/>
  </g>
  <foreignObject x="16" y="100.8" width="100" height="200" id="right-group">
  </foreignObject>
</svg>
    `;



    svgBolBretonRight = `
    <svg
        style="height: 700px; margin-left: 20px; margin-right: 75px;"
        id="svg-right"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 120.2 562.2"
    >
  <!-- Generator: Adobe Illustrator 30.6.0, SVG Export Plug-In . SVG Version: 2.1.4 Build 109)  -->
  <defs>
    <clipPath id="clippath-bbr">
      <rect x="13.4" y="28.2" width="106.8" height="504" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-1-bbr">
      <path d="M41.4,243.8c0,15.1,13,27.4,29,27.4s29-12.3,29-27.4-13-27.4-29-27.4-29,12.3-29,27.4" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-2-bbr">
      <path d="M33.3,245.3c-.9,6.9,1,14.2,5.9,19.5,4.6,5.1,11,7.2,17.7,8.4,1.5.3,3.1.5,4.6.5,3.2.1,6.5-.2,9.6-1,1.2-.3,2.3-.9,3.4-1.3.7-.2,1.4-.4,2.1-.7.6-.3,1.1-.8,1.7-1-3.2,1-6.8,1.3-10.1.7-3.2-.6-6.1-1.8-8.7-3.6-5.3-3.7-8.9-9.5-9.8-15.7-.4-2.5.2-5.3-.4-7.7-.6-2.4-2.6-4.7-4.8-5.9-1.3-.7-2.6-1.1-3.7-1.1-4.2,0-6.9,4.3-7.4,8.7" style="fill: none;"/>
    </clipPath>
  </defs>
  <rect x="13.4" y="28.2" width="106.8" height="504" style="fill: #fefbe7;"/>
  <g style="clip-path: url(#clippath-bbr);">
    <path d="M140.9,37.5c.6.6,1.3,1.2,2.1,1.8.4-1.6.8-3.1,1.2-4.7-.9-.9-1.5-2.1-1.4-3.8.5-7.6,1.3-15.1,2.4-22.6-23.9-1.3-47.9-1.7-71.8-.1-18.8,1.2-54.3-.8-68.3,11-5.8,4.9-5.7,14.4,2.1,17,11.3,3.6,20.5-9.3,30.1-2.2,3.4,2.5,6.6,5.9,11.2,5.7,4.8-.2,9-6.8,13.3-6.2,5.2.8,3.8,8.6,12.2,4.9,2.5-1.1,4.4-2.8,6.7-4.1,2.3-1.3,5.4-2,7.9-1,1.6.7,2.8,2.1,4.6,2.4,2.6.5,4.7-1.6,7.1-2.6,6.8-2.8,8.7,3,13.8,4.4,4.3,1.2,7.5-2.6,11.4-4.8,1-.5,2.1-1,3.2-1.2,4.9-.8,9.1,2.8,12.3,5.9Z" style="fill: #0856a3;"/>
    <rect x="13.4" y="291.1" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="316.5" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="341.8" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="367.2" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="392.6" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="418" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="443.4" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="468.8" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="494.2" width="106.7" height="12.7" style="fill: #0856a3;"/>
    <rect x="13.4" y="519.6" width="106.7" height="12.7" style="fill: #0856a3;"/>
  </g>
  <g>
    <rect x="13.3" width="106.8" height="28.2" style="fill: #0856a3;"/>
    <path d="M13.3,532.3h106.8s-18.8,29.9-53.4,29.9-53.4-29.9-53.4-29.9" style="fill: #0856a3;"/>
    <path d="M13,291.1l47.5,46.3-47.1,43.9s-29.8-45-.4-90.2" style="fill: #0856a3;"/>
  </g>
  <g>
    <path d="M69.7,272.9c3.4-36.9-1.5-75.1-10.5-111.1" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10;"/>
    <path d="M58.3,159.5c1.5,0,4.3,5.7,4.8,6.5,1.3,2.4,2.2,4.9,2.9,7.4.5,1.8,2.4,15-1.1,14.8-3.9-.2-7.4-11.5-7.8-13.7-.6-2.6-.8-5.2-.6-7.7.2-2.1-.3-4.6.9-6.6.2-.3.4-.6.8-.7,0,0,.1,0,.2,0" style="fill: #a2cb7c;"/>
    <path d="M72.4,170.7c.4-.6.8-1.1,1.3-1.6,3.5-3.7,10.1-3.7,10.1,2.5,0,2-.9,3.9-1.8,5.6-3.1,5.8-7.1,11.1-10.1,16.9-1.5,2.9-3,5.6-3.7,8.7-.7,3-1.9,7.7-1.1,10.7-1.6-5.7-1-11.9-.8-17.7.2-6.8,1.5-13.5,3.7-20,.6-1.8,1.4-3.7,2.5-5.3" style="fill: #a2cb7c;"/>
    <path d="M45.4,184.3c1.8,1.5,3.6,2.9,5.4,4.3,3.6,3,6.8,6.5,9.6,10.2,1.4,1.9,2.6,3.8,3.7,5.8.9,1.6,2.5,4.2,2.6,6-.2-8.8-3-17.5-8-24.9-3.7-5.5-9.8-14-17.5-14.3-1.2,0-2.5.4-3.1,1.4-.9,1.4-.1,3.3.9,4.7,1.8,2.5,4.1,4.7,6.5,6.7" style="fill: #a2cb7c;"/>
    <path d="M91.2,188.4c-3.1,3.7-6.4,7-9.3,10.9-2.9,4-5.3,8.4-7.1,12.9-2.6,6.2-5.2,13.9-4.5,20.7-1.7-17-.9-37.9,13.1-50.4,2.2-1.9,5.5-3.6,7.9-2,1.7,1.1,2,3.4,1.4,5.2-.3,1-.9,1.8-1.6,2.7" style="fill: #d65656;"/>
    <path d="M42.1,197.5c6.6,4.1,13.1,8.5,18.5,14,2.2,2.2,4,4.8,6.1,7,2.1,2.3,3.3,5.4,3.6,8.4-.3-3.9.3-7.6-1.1-11.5-1.3-3.7-3.7-7.2-6-10.5-4.9-7-11.9-12.8-20-16.3-1.3-.5-2.7-1-4-.6-2.1.7-2.6,3.4-1.7,5.2.9,1.9,2.9,3.1,4.7,4.2" style="fill: #0856a3;"/>
    <path d="M83.3,205.5c1.2-2,2.5-4,4.4-5.3,2-1.3,4.7-1.8,6.8-.6,2.3,1.3,2.9,4.4,2.2,6.8-.7,2.5-2.5,4.5-4.1,6.5-10.8,13.4-18.3,29.1-21.8,45.6.8-3.8.2-8.4.6-12.4.4-4.8.8-9.5,1.7-14.2,1.9-9.3,5.4-18.2,10.2-26.5" style="fill: #a2cb7c;"/>
    <path d="M62.4,219.3c-4.8-6-11.2-10.8-18.5-13.7-1.5-.6-3.1-1.1-4.7-1.1-1.6,0-3.3.7-4.1,2-.8,1.3-.7,3,0,4.4.7,1.4,1.9,2.5,3.1,3.5,8.4,7.2,19,10.7,25.8,19.5,1.5,2,2.9,4.1,4,6.3.6,1,1.2,2.1,1.6,3.2.4,1.2.6,2.3,1.4,3.4-.9-1.2,0-6.1-.2-7.7-.1-2.1-.4-3.9-1-5.9-1.3-4.1-3.2-8-5.7-11.5-.6-.8-1.2-1.6-1.8-2.4" style="fill: #a2cb7c;"/>
    <path d="M86.3,226.1c1.8-2,3.7-3.9,6.2-5.1,2.5-1.1,5.6-1.3,7.9,0,3,1.9,3.7,6,2.5,9.3-1.2,3.2-4,5.7-6.7,8-5.6,4.6-11.5,8.8-16.6,13.8-5.1,5.1-9.3,11.3-10.3,18.2,1.1-7.7,1.4-14.4,4-21.9,2.8-8.1,7.2-15.8,13-22.4" style="fill: #a2cb7c;"/>
    <path d="M69.8,267.2c.1-2.3.6-4.7.3-7-.3-2.5-.8-5-1.4-7.4-1.3-4.8-3.4-9.4-6.2-13.5-4.3-6.4-10.5-11.7-17.9-14.7-2-.8-4.1-1.5-6.3-1.3s-4.4,1.3-5.2,3.2c-1,2.3.3,4.9,2.3,6.5,2,1.6,4.5,2.4,6.9,3.4,13.5,5.5,24,17.3,27.5,30.8" style="fill: #a2cb7c;"/>
    <path d="M29.8,262.6c0,.5.2.9.5,1.3.9,1.1,2.5,1.3,3.9,1.7,2.8.8,5,2.8,6.9,4.9,1.9,2.1,3.7,4.4,6.1,6,6.6,4.5,19.5,1.8,27.1,1.3,6.7-.5,12.8-1,17.3-6.5,1-1.3,1.9-2.8,3.2-3.8,1.6-1.2,3.6-1.6,5.4-2.4,1.8-.8,3.6-2.3,3.5-4.1,0-1.8-1.8-3.2-3.6-3.6-2.3-.5-5.1,0-7.5.2-7.6.5-15.3,1-22.9.8-7.6-.2-15.5,1-22.9.2-5.2-.6-11.3-2.7-15.7,1.2-.8.8-1.4,1.9-1.3,3" style="fill: #a2cb7c;"/>
    <path d="M99.3,243.8c0,15.1-13,27.4-29,27.4s-29-12.3-29-27.4,13-27.4,29-27.4,29,12.3,29,27.4" style="fill: #d18814;"/>
  </g>
  <g style="clip-path: url(#clippath-1-bbr);">
    <path d="M81.4,259.7c-2.1,2.8-5.8,4.3-9.4,4.5-3.6.2-7.2-.9-10.4-2.5-3-1.5-5.9-3.6-8.4-5.8-2-1.8-2.7-4.7-3-7.2-.4-3.5-.7-6.9.6-10.2,1.4-3.4,3.8-6.5,6.8-8.8,8.3-6.4,22.8-7.6,29.4,1.6,2.1,3,3,6.7,2.6,10.3-.4,3.8-2.5,6.6-5.7,8.9-3.6,2.6-8.4,3.7-12.8,2.6-4.4-1.1-8.1-4.6-8.8-8.8-.7-4.2,1.9-8.9,6.1-10.3,1.6-.5,3.3-.6,4.9,0,4.1,1.7,3.3,8.6-1.3,8.9" style="fill: none; stroke: #dea53a; stroke-miterlimit: 10; stroke-width: 2px;"/>
  </g>
  <g>
    <path d="M65.2,202.7c-.4,1.2-2.1,2-3.3,2.7-1.7,1.2-3.3,2.2-5.4,3.1-2.9,1.3-6.9,2.7-10.4,2.5,1.3,1.7,3.3,6.1,6.5,5.9,2.7-.1,6.7-2.6,8.9-3.8,2.8-1.5,6.3-4,6.2-6.9,0-1.4-1.4-2.2-2.7-3.6" style="fill: #241f1a;"/>
    <path d="M72.7,203.6c.4,1.2,2.1,2,3.3,2.7,1.7,1.2,3.3,2.2,5.4,3.1,2.9,1.3,6.9,2.7,10.4,2.5-1.3,1.7-3.3,6.1-6.5,5.9-2.7-.1-6.7-2.6-8.9-3.8-2.8-1.5-6.3-4-6.2-6.9,0-1.4,1.4-2.2,2.7-3.6" style="fill: #241f1a;"/>
    <path d="M57.9,214c-.3-.9,0-1.7-.2-2.6-.1-1-.7-2-1-2.9-.7-2.1-1-5.8,1.1-7.2,1.5-1,2.8-.4,4.4,0,1.1.4,2.4.9,3.7,1,1.5,0,2.9-.6,4.4-.5,2.4.1,3.9.7,6.1-.5,1.1-.6,2.3-1.2,3.5-1.1,2.9.3,3.2,4.2,3,6.2,0,1-.4,2.1-1.1,2.9-.5.6-.5.6-.5,1.3,0,.7,0,1.4-.2,2-.7,3.1-3.5,5.5-6.7,6.4-5.4,1.6-14.5.8-16.6-5.2" style="fill: #fff;"/>
    <path d="M56.2,224.3c.3,1,.9,1.9,1.8,2.5.9.6,2.2.7,3.1,0,1-.7,1.2-2,1.1-3.1,0-1.5-.4-3.1.9-4.3.2-.2.5-.4.5-.7,0-.3-.3-.5-.6-.7-.5-.3-1.2-.5-1.7-.7-.6-.3-1.1-.7-1.8-.6-.7,0-1.3.6-1.8,1.1-.5.5-1,1-1.4,1.5-.8,1.3-.7,3.5-.2,4.9" style="fill: #fff;"/>
    <path d="M82.5,223.9c-.3,1-.9,1.9-1.8,2.5-.9.6-2.2.7-3.1,0-1-.7-1.2-2-1.1-3.1,0-1.5.4-3.1-.9-4.3-.2-.2-.5-.4-.5-.7,0-.3.3-.5.6-.7.5-.3,1.2-.5,1.7-.7.6-.3,1.1-.7,1.8-.6.7,0,1.3.6,1.8,1.1.5.5,1,1,1.4,1.5.8,1.3.7,3.5.2,4.9" style="fill: #fff;"/>
    <path d="M68.5,215.9s2.1-.1,1.9,1.3c-.2,1.4-1.7,1.4-1.7,1.4,0,0-1.4.2-1.9-1.2-.6-1.4,1.7-1.5,1.7-1.5" style="fill: #d65656;"/>
    <path d="M67,218.9s1.5.8,2.9,0" style="fill: none; stroke: #d65656; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="68.5" y1="218.3" x2="68.5" y2="219.2" style="fill: none; stroke: #d65656; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M61.4,203.6s-.9-2-2.7-2.4c0,0-1.8,1.4-.9,3.1,0,0,.4.7-.4,1.3-.8.6-.7,1.6-.7,1.6,0,0,.8,1.3,2.2.4,0,0,.8-.6.4-1.5,0,0,.1-2.2,2.2-2.6" style="fill: #d65656;"/>
    <path d="M77.4,203.4s.9-2,2.7-2.4c0,0,1.8,1.4.9,3.1,0,0-.4.7.4,1.3.8.6.7,1.6.7,1.6,0,0-.8,1.3-2.2.4,0,0-.8-.6-.4-1.5,0,0-.1-2.2-2.2-2.6" style="fill: #d65656;"/>
    <path d="M61.8,213.3c-.5-1.2.6-1.9,1.7-2.1.5,0,1.1,0,1.5.3.5.5.6,1.2.6,1.9,0,1.9-3.4,1-3.8-.2" style="fill: #241f1a;"/>
    <path d="M75.7,213.5c.5-1.2-.6-1.9-1.7-2.1-.5,0-1.1,0-1.5.3-.5.5-.6,1.2-.6,1.9,0,1.9,3.4,1,3.8-.2" style="fill: #241f1a;"/>
    <path d="M65.1,203c1.1.6,1.8,1.3,3.1,1.5,1.2.2,2.5.3,3.7.3,1.1,0,2.3,0,2.9-1,1.1-1.8-2.7-1.5-3.8-1.5-2,0-3.9.5-6,.7" style="fill: #1e1e1c;"/>
    <path d="M65.1,203c-.6-3.3-1.2-6.6-2.2-9.8-.2-.7-.7-1.3-1-2-.5-1.1-1-2.2-1.6-3.4,3.2-3.5,7.3-4.6,12.3-3.4.5.1,1.6,4.8,1.8,5.4.6,2,1,4,1.2,6,.2,2.3-.3,4.7-.5,7.1-3.4,1.3-6.7,1.4-10,0" style="fill: #fff;"/>
    <path d="M72.6,184.5c-2,2.2-4.9,3.7-10.1,3.4" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10;"/>
    <path d="M71.5,216.6s7.5-2.3,11.3.6" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M71.8,217.7s7.9-1.9,9.5,4.3" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M65.7,216.3s-7-1.6-11.4,3.2" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M65.4,217.9s-5.7-1.3-8.3,5.3" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M55.2,255.6c0,0,.1-.2.2-.3.7-.9,2.1-1.5,3.3-1.1,1.1.4,1.6,1.6,2,2.6,1,3,1.9,6,2.6,9,.3,1.3.5,2.5.3,3.8,0,.4-.2.9-.6,1.2-.4.3-.9.3-1.3.3-.6,0-1.3,0-1.9-.2-.7-.3-1.1-.9-1.5-1.5-1.2-1.8-2.1-3.3-2.7-5.3-.6-1.9-.9-3.8-.9-5.7,0-1,0-2,.6-2.9" style="fill: #fff;"/>
    <path d="M56.2,257.2c-.2.4,0,.9.3,1.2.4.4,1,.5,1.5.3.5-.2.9-.7.9-1.2,0-.2,0-.4-.1-.5-.1-.2-.4-.3-.6-.3-.7-.1-1.6-.3-1.9.5" style="fill: #d65656;"/>
    <path d="M55,256.7c0-.1,0-.3.2-.4.5-.3.7.5.6.9,0,0,0,.1,0,.1,0,0,0,0-.1,0-.2,0-.4,0-.6-.3,0-.1-.1-.3-.1-.4" style="fill: #d65656;"/>
    <path d="M56.1,255.6c0-.2,0-.6.2-.7.2-.1.5,0,.7.2.1.2.2.5.2.7,0,.2,0,.4-.2.4-.3.1-.8-.5-.9-.7" style="fill: #d65656;"/>
    <path d="M58.2,255.1c.1-.1.4-.2.6-.2.2,0,.2.3.2.5,0,.3-.4,1.1-.9,1-.5-.2-.1-1.1.1-1.3" style="fill: #d65656;"/>
    <path d="M59.5,256.4c0,0,.1,0,.2,0,.4.1.3.6,0,.8-.1,0-.3,0-.4.1,0,0-.1,0-.2,0,0,0,0-.1,0-.2,0-.2.1-.6.4-.7" style="fill: #d65656;"/>
    <path d="M85.2,256.4c0,0-.1-.2-.2-.3-.7-.9-2.1-1.5-3.3-1.1-1.1.4-1.6,1.6-2,2.6-1,3-1.9,6-2.6,9-.3,1.3-.5,2.5-.3,3.8,0,.4.2.9.6,1.2.4.3.9.3,1.3.3.6,0,1.3,0,1.9-.2.7-.3,1.1-.9,1.5-1.5,1.2-1.8,2.1-3.3,2.7-5.3.6-1.9.9-3.8.9-5.7,0-1,0-2-.6-2.9" style="fill: #fff;"/>
    <path d="M84.2,258c.2.4,0,.9-.3,1.2-.4.4-1,.5-1.5.3-.5-.2-.9-.7-.9-1.2,0-.2,0-.4.1-.5.1-.2.4-.3.6-.3.7-.1,1.6-.3,1.9.5" style="fill: #d65656;"/>
    <path d="M85.3,257.6c0-.1,0-.3-.2-.4-.5-.3-.7.5-.6.9,0,0,0,.1,0,.1,0,0,0,0,.1,0,.2,0,.4,0,.6-.3,0-.1.1-.3.1-.4" style="fill: #d65656;"/>
    <path d="M84.3,256.4c0-.2,0-.6-.2-.7-.2-.1-.5,0-.7.2-.1.2-.2.5-.2.7,0,.2,0,.4.2.4.3.1.8-.5.9-.7" style="fill: #d65656;"/>
    <path d="M82.2,255.9c-.1-.1-.4-.2-.6-.2-.2,0-.2.3-.2.5,0,.3.4,1.1.9,1,.5-.2.1-1.1-.1-1.3" style="fill: #d65656;"/>
    <path d="M80.8,257.2c0,0-.1,0-.2,0-.4.1-.3.6,0,.8.1,0,.3,0,.4.1,0,0,.1,0,.2,0,0,0,0-.1,0-.2,0-.2-.1-.6-.4-.7" style="fill: #d65656;"/>
    <path d="M61.4,273.8c-1.5,0-3.1-.3-4.6-.5-6.7-1.3-13.1-3.4-17.7-8.4-4.9-5.3-6.8-12.6-5.9-19.5.7-5.6,4.9-11.1,11.2-7.6,2.2,1.2,4.2,3.6,4.8,5.9.6,2.4,0,5.2.4,7.7.9,6.2,4.4,12,9.8,15.7,2.6,1.8,5.6,3.1,8.7,3.6,3.3.6,7,.3,10.1-.7-.6.2-1.1.7-1.7,1-.7.3-1.4.5-2.1.7-1.2.4-2.2.9-3.4,1.3-3.1.8-6.4,1.1-9.6,1" style="fill: #fff;"/>
  </g>
  <g style="clip-path: url(#clippath-2-bbr);">
    <path d="M34.9,258c0-.9,0-1.8,0-2.7,1.3,1.8,2.9,3.4,4.7,4.7-.4-1.5-.6-3.1-.6-4.7,1.3,1.3,2.3,2.9,2.8,4.7.3-1.5.4-3.1.2-4.6,1.5,1.3,2.6,3.1,2.8,5.1.5-2.3.6-4.7.5-7,.9,1.8,2.1,3.5,3.6,4.8,0-1.4,0-2.8,0-4.1.4.6.9,1.2,1.3,1.9-.3-.5,1.1-2.9,1.2-3.5.4-1.5.6-3,.7-4.5.2-4.1-.9-8.3-3.9-11.2-3-2.9-8.1-4-11.8-1.8-3.8,2.2-5.4,6.5-5.7,10.5-.2,2.2,0,4.4.6,6.5.7,2.7,2.2,4.7,3.8,7,0-.3,0-.6,0-1" style="fill: #241f1a;"/>
  </g>
  <foreignObject x="17" y="60.8" width="100" height="200" id="right-group">
  </foreignObject>
</svg>
    `;

    svgBolBretonLeft = `
    <svg
        style="height: 700px; margin-left: 75px; margin-right: 20px;"
        id="svg-left"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        version="1.1"
        viewBox="0 0 113.3 560"
        onmouseover="displayAddNewLine('left')"
    >
  <!-- Generator: Adobe Illustrator 30.6.0, SVG Export Plug-In . SVG Version: 2.1.4 Build 109)  -->
  <defs>
    <clipPath id="clippath-bbl">
      <rect x="0" y="28.1" width="100.6" height="502" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-1-bbl">
      <path d="M19.7,243.7c0,15.1,12.2,27.3,27.3,27.3s27.3-12.2,27.3-27.3-12.2-27.3-27.3-27.3-27.3,12.2-27.3,27.3" style="fill: none;"/>
    </clipPath>
    <clipPath id="clippath-2-bbl">
      <path d="M71.4,237.6c-2.1,1.2-4,3.6-4.5,5.9-.6,2.4,0,5.2-.4,7.7-.9,6.2-4.2,12-9.2,15.6-2.4,1.8-5.2,3-8.2,3.6-3.1.6-6.6.3-9.5-.7.5.2,1.1.7,1.6,1,.6.3,1.3.5,1.9.7,1.1.4,2.1.9,3.2,1.3,2.9.8,6,1.1,9.1,1,1.5,0,2.9-.2,4.3-.5,6.4-1.3,12.3-3.3,16.7-8.4,4.6-5.3,6.4-12.5,5.5-19.4-.5-4.4-3.1-8.7-7-8.7-1.1,0-2.3.3-3.5,1" style="fill: none;"/>
    </clipPath>
  </defs>
  <rect x="0" y="28.1" width="100.6" height="502" style="fill: #fefbe7;"/>
  <rect x="0" y="289.9" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="315.2" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="340.5" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="365.8" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="391.1" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="416.4" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="441.6" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="466.9" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="492.2" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <rect x="0" y="517.5" width="100.6" height="12.6" style="fill: #0856a3;"/>
  <g style="clip-path: url(#clippath-bbl);">
    <path d="M111.9,18.7c-5.7-3.6-13.3-4.4-20.5-5.2C56.3,10,20.7,6.7-14.8,7.1c0,1.9,0,3.8,0,5.7,0,6.4-.2,12.7-.3,19.1,0,0,0,0,0,0,6.4-2.7,8.2,2.9,13,4.2,4,1.1,7.1-2.5,10.8-4.5,1-.5,2-.9,3-1.1,4.7-.8,8.6,2.7,11.6,5.6,3,2.9,7.9,6,12.1,4.1,3.2-1.4,4-5,6.8-6.9,4.4-2.9,11-.6,15.7,2,4.7,2.6,10.6,5.6,15.6,3.5,4-1.7,5.6-5.9,9.7-7.4,3.2-1.2,7.1-.3,10.2,1.1,3.1,1.4,5.9,3.3,9.3,4.2,15.1,4,19.7-11.4,9.2-18Z" style="fill: #0856a3;"/>
  </g>
  <g>
    <rect width="100.6" height="28.1" style="fill: #0856a3;"/>
    <path d="M100.6,530.1H0s17.7,29.8,50.3,29.8,50.3-29.8,50.3-29.8" style="fill: #0856a3;"/>
    <path d="M101,290.6l-44.7,46.2,44.4,43.7s28-44.8.4-89.8" style="fill: #0856a3;"/>
  </g>
  <g>
    <path d="M47.6,272.6c-3.2-36.7,1.4-74.8,9.9-110.6" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10;"/>
    <path d="M45.1,170.9c-.4-.6-.8-1.1-1.2-1.6-3.3-3.7-9.5-3.7-9.5,2.5,0,2,.8,3.9,1.7,5.6,2.9,5.8,6.7,11.1,9.5,16.9,1.4,2.8,2.9,5.6,3.5,8.7.6,3,1.8,7.7,1,10.7,1.5-5.7.9-11.8.8-17.6-.2-6.8-1.4-13.5-3.5-19.9-.6-1.8-1.3-3.7-2.3-5.3" style="fill: #a2cb7c;"/>
    <path d="M70.5,184.4c-1.7,1.5-3.4,2.9-5.1,4.3-3.4,3-6.4,6.5-9,10.2-1.3,1.8-2.5,3.8-3.5,5.8-.8,1.6-2.4,4.2-2.4,6,.2-8.7,2.9-17.4,7.6-24.8,3.5-5.5,9.2-13.9,16.5-14.3,1.1,0,2.3.4,2.9,1.4.9,1.4,0,3.3-.8,4.7-1.7,2.5-3.8,4.6-6.1,6.7" style="fill: #a2cb7c;"/>
    <path d="M27.3,188.5c2.9,3.7,6.1,6.9,8.7,10.9,2.7,4,5,8.3,6.7,12.8,2.4,6.2,4.9,13.9,4.2,20.6,1.6-16.9.9-37.7-12.4-50.2-2-1.9-5.2-3.6-7.5-2-1.6,1.1-1.9,3.4-1.3,5.2.3,1,.8,1.8,1.5,2.7" style="fill: #d65656;"/>
    <path d="M73.7,197.5c-6.2,4.1-12.3,8.5-17.4,13.9-2.1,2.2-3.7,4.8-5.7,7-2,2.3-3.1,5.4-3.4,8.4.3-3.9-.2-7.6,1-11.4,1.2-3.7,3.5-7.2,5.7-10.4,4.7-7,11.2-12.8,18.9-16.2,1.2-.5,2.6-1,3.8-.6,1.9.7,2.5,3.4,1.6,5.2-.9,1.8-2.7,3-4.4,4.2" style="fill: #0856a3;"/>
    <path d="M34.8,205.5c-1.1-2-2.3-4-4.2-5.3-1.8-1.3-4.5-1.8-6.4-.6-2.2,1.3-2.7,4.4-2.1,6.8.7,2.4,2.3,4.5,3.9,6.5,10.2,13.3,17.3,29,20.5,45.5-.8-3.8-.2-8.4-.6-12.3-.4-4.8-.7-9.5-1.6-14.2-1.8-9.2-5.1-18.2-9.6-26.4" style="fill: #a2cb7c;"/>
    <path d="M54.4,219.3c4.5-6,10.6-10.8,17.5-13.7,1.4-.6,2.9-1.1,4.4-1.1,1.5,0,3.1.7,3.9,2,.8,1.3.6,3,0,4.4-.7,1.4-1.8,2.5-2.9,3.5-8,7.2-17.9,10.6-24.3,19.4-1.4,2-2.7,4.1-3.8,6.2-.5,1-1.2,2.1-1.5,3.2-.4,1.2-.5,2.3-1.3,3.4.8-1.2,0-6,.2-7.6.1-2.1.4-3.9.9-5.9,1.2-4.1,3-7.9,5.3-11.5.5-.8,1.1-1.6,1.7-2.4" style="fill: #a2cb7c;"/>
    <path d="M31.9,226.1c-1.7-2-3.5-3.9-5.8-5.1-2.3-1.1-5.3-1.3-7.4,0-2.9,1.9-3.5,6-2.4,9.2,1.2,3.2,3.7,5.7,6.3,8,5.2,4.6,10.9,8.7,15.7,13.8,4.8,5,8.7,11.2,9.7,18.1-1-7.6-1.4-14.3-3.8-21.8-2.6-8.1-6.8-15.7-12.3-22.3" style="fill: #a2cb7c;"/>
    <path d="M47.5,267c-.1-2.3-.6-4.7-.3-7,.3-2.5.7-5,1.3-7.4,1.2-4.8,3.2-9.3,5.8-13.5,4.1-6.4,9.9-11.6,16.9-14.6,1.9-.8,3.9-1.5,5.9-1.3s4.1,1.3,4.9,3.2c.9,2.3-.3,4.9-2.1,6.5-1.8,1.6-4.2,2.4-6.5,3.4-12.7,5.5-22.6,17.2-26,30.7" style="fill: #a2cb7c;"/>
    <path d="M85.2,262.4c0,.5-.2.9-.5,1.3-.8,1.1-2.4,1.3-3.7,1.7-2.6.8-4.7,2.8-6.5,4.9-1.8,2.1-3.5,4.3-5.7,5.9-6.2,4.5-18.4,1.8-25.5,1.3-6.3-.5-12.1-1-16.3-6.5-1-1.3-1.8-2.8-3-3.8-1.5-1.2-3.4-1.6-5.1-2.4-1.7-.8-3.4-2.3-3.3-4.1,0-1.8,1.7-3.2,3.4-3.6,2.1-.5,4.8,0,7,.2,7.2.5,14.4,1,21.6.8,7.1-.2,14.6,1,21.6.2,4.9-.6,10.7-2.7,14.8,1.2.8.8,1.3,1.9,1.2,3" style="fill: #a2cb7c;"/>
    <path d="M19.7,243.7c0,15.1,12.2,27.3,27.3,27.3s27.3-12.2,27.3-27.3-12.2-27.3-27.3-27.3-27.3,12.2-27.3,27.3" style="fill: #d18814;"/>
  </g>
  <g style="clip-path: url(#clippath-1-bbl);">
    <path d="M36.6,259.5c2,2.8,5.4,4.3,8.9,4.5,3.4.2,6.8-.9,9.8-2.5,2.8-1.5,5.5-3.6,7.9-5.7,1.9-1.8,2.6-4.7,2.9-7.2.4-3.5.7-6.9-.6-10.2-1.3-3.4-3.6-6.5-6.4-8.8-7.8-6.3-21.5-7.6-27.7,1.6-2,3-2.8,6.7-2.5,10.3.4,3.8,2.4,6.6,5.4,8.9,3.4,2.6,8,3.7,12.1,2.6,4.1-1.1,7.6-4.6,8.3-8.8.7-4.2-1.8-8.8-5.8-10.3-1.5-.5-3.2-.6-4.6,0-3.8,1.7-3.1,8.5,1.3,8.9" style="fill: none; stroke: #dea53a; stroke-miterlimit: 10; stroke-width: 2px;"/>
  </g>
  <g>
    <path d="M58.7,214c.3-.9,0-1.7.2-2.6.1-1,.7-2,1-2.9.7-2.1.9-5.8-1.1-7.2-1.4-1-2.7-.4-4.1,0-1.1.4-2.3.9-3.4,1-1.4,0-2.7-.6-4.1-.5-2.3.1-3.7.7-5.8-.5-1-.6-2.1-1.2-3.3-1.1-2.7.3-3,4.1-2.8,6.2,0,1,.4,2.1,1,2.9.5.6.5.6.4,1.3,0,.7,0,1.4.2,2,.7,3.1,3.3,5.4,6.3,6.4,5.1,1.6,13.7.8,15.6-5.1" style="fill: #fff;"/>
    <path d="M60.3,224.3c-.3,1-.8,1.9-1.7,2.5-.9.6-2.1.7-2.9,0-.9-.7-1.1-2-1.1-3.1,0-1.5.4-3.1-.9-4.3-.2-.2-.5-.4-.5-.7,0-.3.3-.5.5-.7.5-.3,1.1-.5,1.6-.7.6-.3,1-.7,1.7-.6.7,0,1.2.6,1.7,1.1.5.5,1,1,1.3,1.5.8,1.3.6,3.5.2,4.9" style="fill: #fff;"/>
    <path d="M35.6,223.9c.3,1,.8,1.9,1.7,2.5.9.6,2.1.7,2.9,0,.9-.7,1.1-2,1.1-3.1,0-1.5-.4-3.1.9-4.3.2-.2.5-.4.5-.7,0-.3-.3-.5-.5-.7-.5-.3-1.1-.5-1.6-.7-.6-.3-1-.7-1.7-.6-.7,0-1.2.6-1.7,1.1-.5.5-1,1-1.3,1.5-.8,1.3-.6,3.5-.2,4.9" style="fill: #fff;"/>
    <path d="M48.8,215.9s-2-.1-1.8,1.3c.2,1.4,1.6,1.4,1.6,1.4,0,0,1.3.2,1.8-1.2.5-1.4-1.6-1.5-1.6-1.5" style="fill: #d65656;"/>
    <path d="M50.1,218.9s-1.4.7-2.8,0" style="fill: none; stroke: #d65656; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <line x1="48.7" y1="218.3" x2="48.7" y2="219.2" style="fill: none; stroke: #d65656; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M55.4,203.6s.9-2,2.6-2.3c0,0,1.7,1.4.9,3.1,0,0-.4.7.4,1.3.7.6.6,1.6.6,1.6,0,0-.7,1.3-2,.4,0,0-.7-.6-.3-1.5,0,0,0-2.2-2.1-2.6" style="fill: #d65656;"/>
    <path d="M40.3,203.5s-.9-2-2.6-2.3c0,0-1.7,1.4-.9,3.1,0,0,.4.7-.4,1.3-.7.6-.6,1.6-.6,1.6,0,0,.7,1.3,2,.4,0,0,.7-.6.3-1.5,0,0,0-2.2,2.1-2.6" style="fill: #d65656;"/>
    <path d="M55,213.3c.4-1.2-.5-1.9-1.6-2.1-.5,0-1.1,0-1.4.3-.5.5-.6,1.2-.6,1.9,0,1.9,3.2,1,3.6-.2" style="fill: #241f1a;"/>
    <path d="M41.9,213.5c-.4-1.2.5-1.9,1.6-2.1.5,0,1.1,0,1.4.3.5.5.6,1.2.6,1.9,0,1.9-3.2,1-3.6-.2" style="fill: #241f1a;"/>
    <path d="M45.9,216.6s-7-2.3-10.6.6" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M45.6,217.8s-7.5-1.9-8.9,4.3" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M51.4,216.3s6.6-1.6,10.7,3.2" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M51.7,217.9s5.4-1.3,7.8,5.3" style="fill: none; stroke: #1e1e1c; stroke-miterlimit: 10; stroke-width: .2px;"/>
    <path d="M61.3,255.5c0,0-.1-.2-.2-.3-.7-.9-2-1.5-3.1-1.1-1.1.4-1.5,1.6-1.8,2.6-.9,3-1.7,5.9-2.4,9-.3,1.3-.4,2.5-.3,3.8,0,.4.1.9.5,1.2.3.3.8.3,1.2.3.6,0,1.2,0,1.8-.2.7-.3,1.1-.9,1.4-1.5,1.1-1.8,2-3.3,2.6-5.2.5-1.8.8-3.8.9-5.7,0-1,0-2-.6-2.9" style="fill: #fff;"/>
    <path d="M60.4,257.1c.2.4,0,.9-.3,1.2-.4.4-.9.5-1.4.3-.5-.2-.8-.7-.8-1.2,0-.2,0-.4.1-.5.1-.2.4-.3.6-.3.6-.1,1.5-.3,1.8.5" style="fill: #d65656;"/>
    <path d="M61.4,256.6c0-.1,0-.3-.2-.4-.5-.3-.6.5-.6.9,0,0,0,.1,0,.1,0,0,0,0,.1,0,.2,0,.4,0,.5-.3,0-.1.1-.3.1-.4" style="fill: #d65656;"/>
    <path d="M60.4,255.5c0-.2,0-.5-.2-.7-.2-.1-.5,0-.6.2-.1.2-.2.5-.2.7,0,.2,0,.4.1.4.3.1.8-.5.9-.7" style="fill: #d65656;"/>
    <path d="M58.5,255c-.1-.1-.3-.2-.5-.2-.2,0-.2.3-.2.5,0,.3.4,1.1.8,1,.5-.2.1-1.1,0-1.3" style="fill: #d65656;"/>
    <path d="M57.2,256.2c0,0-.1,0-.2,0-.4.1-.3.6,0,.8.1,0,.3,0,.4.1,0,0,.1,0,.2,0,0,0,0-.1,0-.2,0-.2,0-.6-.4-.7" style="fill: #d65656;"/>
    <path d="M33,256.3c0,0,.1-.2.2-.3.7-.9,2-1.5,3.1-1.1,1.1.4,1.5,1.6,1.8,2.6.9,3,1.7,5.9,2.4,9,.3,1.3.4,2.5.3,3.8,0,.4-.1.9-.5,1.2-.3.3-.8.3-1.2.3-.6,0-1.2,0-1.8-.2-.7-.3-1.1-.9-1.4-1.5-1.1-1.8-2-3.3-2.6-5.2-.5-1.8-.8-3.8-.9-5.7,0-1,0-2,.6-2.9" style="fill: #fff;"/>
    <path d="M34,257.9c-.2.4,0,.9.3,1.2.4.4.9.5,1.4.3.5-.2.8-.7.8-1.2,0-.2,0-.4-.1-.5-.1-.2-.4-.3-.6-.3-.6-.1-1.5-.3-1.8.5" style="fill: #d65656;"/>
    <path d="M32.9,257.4c0-.1,0-.3.2-.4.5-.3.6.5.6.9,0,0,0,.1,0,.1,0,0,0,0-.1,0-.2,0-.4,0-.5-.3,0-.1-.1-.3-.1-.4" style="fill: #d65656;"/>
    <path d="M33.9,256.3c0-.2,0-.5.2-.7.2-.1.5,0,.6.2.1.2.2.5.2.7,0,.2,0,.4-.1.4-.3.1-.8-.5-.9-.7" style="fill: #d65656;"/>
    <path d="M35.9,255.8c.1-.1.3-.2.5-.2.2,0,.2.3.2.5,0,.3-.4,1.1-.8,1-.5-.2-.1-1.1,0-1.3" style="fill: #d65656;"/>
    <path d="M37.1,257.1c0,0,.1,0,.2,0,.4.1.3.6,0,.8-.1,0-.3,0-.4.1,0,0-.1,0-.2,0,0,0,0-.1,0-.2,0-.2,0-.6.4-.7" style="fill: #d65656;"/>
    <path d="M55.4,273.6c1.5,0,2.9-.2,4.3-.5,6.4-1.3,12.3-3.3,16.7-8.4,4.6-5.3,6.4-12.5,5.5-19.4-.7-5.5-4.6-11-10.5-7.6-2.1,1.2-4,3.6-4.5,5.9-.6,2.4,0,5.2-.4,7.7-.9,6.2-4.2,12-9.2,15.6-2.4,1.8-5.2,3-8.2,3.6-3.1.6-6.6.3-9.5-.7.5.2,1.1.7,1.6,1,.6.3,1.3.5,1.9.7,1.1.4,2.1.9,3.2,1.3,2.9.8,6,1.1,9.1,1" style="fill: #fff;"/>
  </g>
  <g style="clip-path: url(#clippath-2-bbl);">
    <path d="M80.4,257.9v-2.7c-1.1,1.8-2.6,3.3-4.4,4.6.4-1.5.6-3.1.6-4.7-1.3,1.3-2.2,2.9-2.6,4.6-.3-1.5-.4-3.1-.2-4.6-1.5,1.3-2.4,3.1-2.6,5.1-.4-2.3-.6-4.7-.5-7-.8,1.8-2,3.4-3.4,4.8,0-1.4,0-2.7,0-4.1-.4.6-.8,1.2-1.2,1.9.3-.5-1-2.8-1.1-3.5-.4-1.4-.6-2.9-.7-4.4-.2-4,.9-8.3,3.7-11.2,2.8-2.9,7.6-3.9,11.1-1.8,3.5,2.2,5.1,6.5,5.4,10.5.2,2.2,0,4.4-.5,6.5-.7,2.7-2.1,4.7-3.6,6.9,0-.3,0-.6,0-1" style="fill: #241f1a;"/>
  </g>
  <g>
    <path d="M31,205.1c0,1.6,7.6,2.8,16.9,2.8s16.9-1.3,16.9-2.8-7.6-2.8-16.9-2.8-16.9,1.3-16.9,2.8" style="fill: #010101;"/>
    <path d="M60.1,203.1s-1.5-9.6-12.8-10c-11.3-.4-11.9,10.1-11.9,10.1,0,0,11.9,3.3,24.7,0" style="fill: #010101;"/>
    <path d="M36.5,201.3s-3.5-2.5-6.1,1.3c-2.6,3.8-5.2,6.7-5.3,17.5,0,10.9.7,15.4.7,15.4l2.4-1.6s-2.3-9.8.1-20c0,0,3.6-14.3,8.1-11.2,4.5,3.1,0-1.5,0-1.5" style="fill: #010101;"/>
    <path d="M60.1,203.1s-12.1,4.8-24.7,0c0,0,.2-2.1.6-2.6,0,0,8.7,3.5,23.3,0,0,0,.6,1.2.8,2.6" style="fill: #fff;"/>
    <path d="M34.6,205.6s-3.1,6.2-7.9,7.8c-4.8,1.6-10.1,12.1-9.3,15l2.4-.4s1.4-8.4,7.9-12.4c6.5-4,9.5-9.2,9.5-9.2l-2.6-.8Z" style="fill: #010101;"/>
    <path d="M58.3,161.2c-1.4,0-4.1,6.4-4.5,7.4-1.2,2.7-2.1,5.5-2.7,8.4-.4,2.1-2.3,16.9,1.1,16.7,3.7-.2,6.9-13,7.4-15.4.5-2.9.7-5.8.5-8.7-.2-2.4.3-5.2-.9-7.4-.2-.3-.4-.7-.7-.8,0,0-.1,0-.2,0" style="fill: #a2cb7c;"/>
  </g>
  <foreignObject x="0" y="60.8" width="100" height="200" id="left-group">
  </foreignObject>
</svg>
    `;

// State Management
class TattooState {
    constructor() {
        this.inputColor = CONSTANTS.DEFAULT_BG_COLOR;
        this.leftFontColor = CONSTANTS.DEFAULT_FONT_COLOR;
        this.leftFontNameColor = 'noir';
        this.rightFontColor = CONSTANTS.DEFAULT_FONT_COLOR;
        this.rightFontNameColor = 'noir';
        this.bgColor = CONSTANTS.DEFAULT_BG_COLOR;
        this.elementWhereToAddHeartLeft = null;
        this.elementWhereToAddHeartRight = null;
        this.leftFont = 'Bakerie';
        this.rightFont = 'Bakerie';
        this.leftHeartColor = "black";
        this.leftHeartColorName = "noir";
        this.rightHeartColor = "black";
        this.rightHeartColorName = "noir";
        this.isLeftColorHeartSameFont = true;
        this.isRightColorHeartSameFont = true;
        this.crossColor = "black"
    }
}

const state = new TattooState();

// Input Manager Class
class InputManager {
    static updateInputListeners() {
        const allInputs = document.querySelectorAll('input[type="text"]');
        allInputs.forEach((input) => {
            input.removeEventListener('click', InputManager.handleInputClick);
            input.addEventListener('click', InputManager.handleInputClick);
        });
    }

    static handleInputClick(e) {
        if (e.target.id.includes('right')) {
            state.elementWhereToAddHeartRight = e.target;
        } else {
            state.elementWhereToAddHeartLeft = e.target;
        }
    }

    static addInput(groupId) {
        const group = document.getElementById(groupId);
        const inputsWrapper = group.querySelector('div > div');
        const existingInputs = inputsWrapper.querySelectorAll('.input-container');

        if (existingInputs.length >= CONSTANTS.MAX_INPUTS) return;

        const selectedFont = group.getAttribute('data-font-family') || CONSTANTS.FONTS.BAKERIE;
        const colorForInput = groupId === 'left-group' ? state.leftFontColor : state.rightFontColor;

        let colorText = ""
        if (groupId == "left-group") {
            colorText = state.leftFontColor;
        } else {
            colorText = state.rightFontColor;
        }

        const newInput = document.createElement('div');
        newInput.className = 'input-container';
        newInput.innerHTML = `
        
        <div
            class="input-text-div-editcontent div-input-content-${groupId}"
            style="color:${colorText}!important"
            id="right-firstLine"
            contenteditable="true"
            data-is-modified="false"
            onbeforeinput="ceLimitBeforeInput(event, this, 9)"
            oninput="adjustFontSize(this)"
            onchange="adjustFontSize(this)"
            onfocus="handlePlaceholder(this, '${groupId}')"
            onblur="restorePlaceholder(this, '${groupId}')"
        >LIGNE</div>
        <span class="delete-button" style="color:${state.crossColor}!important" onclick="deleteInput(this)">×</span>
      `;

        inputsWrapper.appendChild(newInput);
        InputManager.updateInputListeners();
        InputManager.updateAddLineButton(groupId);
    }

    static deleteInput(deleteButton) {
        const inputContainer = deleteButton.parentElement;
        const group = inputContainer.closest('foreignObject').id;
        inputContainer.remove();
        InputManager.updateAddLineButton(group);
        InputManager.updateInputListeners();
        updateResumeTattoo();
    }

    static updateAddLineButton(groupId) {
        const group = document.getElementById(groupId);
        const inputsContainer = group.querySelector('div');
        const addButton = document.getElementById(`add-line-${groupId}`);
        const existingInputs = inputsContainer.querySelectorAll('.input-container');
        addButton.style.display = existingInputs.length < CONSTANTS.MAX_INPUTS ? 'block' : 'none';
    }
}


// Heart Manager Class
class HeartManager {
    static addHeart(groupId) {
        let divInputs = document.querySelectorAll('.div-input-content-' + groupId);


        let divSelected;

        divInputs.forEach((divInput) => {
            if (divInput.dataset.isselected === 'true') {
                divSelected = divInput;
                return false;  // Stop loop when found
            }
        });

        if (!divSelected) {
            divSelected = divInputs[0]; // Default to first if none selected
        }

        let colorHeart = "";

        if (groupId == "left-group") {
            colorHeart = state.leftHeartColor;
        } else {
            colorHeart = state.rightHeartColor;
        }

        console.log("Couleur du coeur : " + colorHeart)

        const heartContent = `<span contenteditable="false" style="font-family: 'Noto Sans JP', sans-serif; font-size:1.1rem; color:${colorHeart}!important" class="heart-${groupId}">♡</span>`

        const existingText = divSelected;

        divSelected.dataset.isModified = "true";

        // Count normal characters
        let totalCharLength = getElementLength(existingText);

        divSelected.querySelectorAll('br').forEach(br => br.remove());

        if (totalCharLength <= 6) {
            divSelected.innerHTML += heartContent;
        }


        updateResumeTattoo();
    }

    static changeHeartColor(e, groupId, color, nameColor) {
        if (groupId === 'left-group') {
            state.leftHeartColor = color;
            state.leftHeartColorName = nameColor;
            const colorName = state.leftHeartColorName || '';
            document.getElementById('name-color-heart-left-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);

            state.isLeftColorHeartSameFont = e.parentElement.firstElementChild === e;

        } else {
            state.rightHeartColor = color;
            state.rightHeartColorName = nameColor;
            const colorName = state.rightHeartColorName || '';
            document.getElementById('name-color-heart-right-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);

            state.isRightColorHeartSameFont = e.parentElement.firstElementChild === e;
        }


        let spanHeart = document.querySelectorAll('.heart-' + groupId)


        spanHeart.forEach((heart) => {
            heart.style.color = color;
        })


        // Reset all color elements
        const colorElements = document.querySelectorAll('.heart-color-container-' + groupId);
        colorElements.forEach((element) => (element.style.boxShadow = 'none'));

        e.style.boxShadow = 'inset 0 0 0 2px black';
    }
}

function restoreInputValues(containerId, values) {
    let font;
    if (containerId === 'left-group') {
        font = state.leftFont;
        colorFont = state.leftFontColor;
    }
    if (containerId === 'right-group') {
        font = state.rightFont;
        colorFont = state.rightFontColor;
    }

    const container = document.getElementById(containerId);
    const inputs = container.querySelectorAll('.input-text-div-editcontent');

    inputs.forEach((input, index) => {
        if (values[index] !== undefined) {
            // Remettre la valeur et les attributs
            input.value = values[index];
            input.style.fontFamily = font;
            input.style.color = colorFont;
            input.dataset.isModified = 'true';
        } else {
            // Si pas de valeur pour cet input -> supprimer via deleteInput()
            const deleteBtn = input.parentElement.querySelector('.delete-button');
            if (deleteBtn) {
                deleteInput(deleteBtn);
            }
        }
    });
}

// SVG Manager Class
class SVGManager {
    static changeColorSVG(color, productType, secondaryColor, isColorDark) {
        //TODO : change motif if productType is not "unie".
        const svgLeft = document.getElementById('svg-left');
        const svgRight = document.getElementById('svg-right');
        const tattooTitle = document.getElementById('tattoo-title');
        const svgLeftParent = document.getElementById('tattoo-left-container');
        const svgRightParent = document.getElementById('tattoo-right-container');

        // data inputs left
        const leftContainer = document.getElementById('left-group');
        const leftInputs = leftContainer.querySelectorAll('input');
        const leftValues = Array.from(leftInputs)
            .filter((input) => input.dataset.isModified === 'true') // <-- on garde que ceux modifiés
            .map((input) => input.value);

        // data inputs right
        const rightContainer = document.getElementById('right-group');
        const rightInputs = rightContainer.querySelectorAll('input');
        const rightValues = Array.from(rightInputs)
            .filter((input) => input.dataset.isModified === 'true') // <-- idem
            .map((input) => input.value);



        let foreignObjectLeft = document.getElementById('left-group').innerHTML;
        let foreignObjectRight = document.getElementById('right-group').innerHTML;







        svgLeft.remove();
        svgRight.remove();

        // Bol Breton utilise la police Felipa (toggle .tattoo-felipa plus bas).
        // Suivi via ce flag plutôt que via le slug, car la branche qui injecte le
        // Bol Breton peut changer de slug.
        let isBolBreton = false;

        if (productType === 'tatouage-test-test-test') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgBolBretonLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgBolBretonRight);
            isBolBreton = true;
            state.bgColor = color;
        } else if (productType === 'tatouage-bol-breton') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgBolBretonLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgBolBretonRight);
            isBolBreton = true;
            state.bgColor = color;
        } else if (productType === 'tatouage-en-transit') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgEnTransitLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgEnTransitRight);
            state.bgColor = color;
        } else if (productType === 'tatouage-copie-double') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgCopieDoubleLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgCopieDoubleRight);
            state.bgColor = color;
        } else if (productType === 'tatouage-nuage') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgNuageLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgNuageRight);
            document.querySelectorAll('.st3').forEach((el) => {
                el.style.setProperty('fill', secondaryColor, 'important');
            });

            document.querySelectorAll('.st5').forEach((el) => {
                el.style.setProperty('fill', color, 'important');
            });


            state.bgColor = color;
        } else if  (productType === 'tatouage-completement-timbre') {
            svgLeftParent.insertAdjacentHTML('beforeend', svgComplementTimbreLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgCompletementTimbreRight);
            state.bgColor = color;
        } else {
            svgLeftParent.insertAdjacentHTML('beforeend', svgUnieLeft);
            svgRightParent.insertAdjacentHTML('afterbegin', svgUnieRight);
            const svgLeft = document.getElementById('svg-left');
            const svgRight = document.getElementById('svg-right');
            SVGManager.updateSVGElements(svgLeft, ['bord-cote', 'Talon', 'fond', 'orteils'], color);
            SVGManager.updateSVGElements(
                svgRight,
                ['bord-cote-right', 'Talon-right', 'fond-right', 'orteils-right'],
                color
            );
            state.bgColor = color;

            // Mettre à jour la couleur de fond de tous les inputs
            const allInputs = document.querySelectorAll('#left-group input[type="text"], #right-group input[type="text"]');
            allInputs.forEach((input) => {
                input.style.backgroundColor = color;
            });
        }

        document.getElementById('left-group').innerHTML = foreignObjectLeft;
        document.getElementById('right-group').innerHTML = foreignObjectRight;

        // Police Felipa uniquement pour le Bol Breton (classe stylée dans tattoo.css)
        svgLeftParent.classList.toggle('tattoo-felipa', isBolBreton);
        svgRightParent.classList.toggle('tattoo-felipa', isBolBreton);

        updateTotalPrice();



        let allDeleteButtons = document.querySelectorAll('.delete-button');
        let allAddLineButtons = document.querySelectorAll('.add-line-button');

        console.log(allDeleteButtons);
        console.log(allAddLineButtons);

        console.log(isColorDark)

        if (isColorDark) {
            console.log('On met en blanc')
            allDeleteButtons.forEach(button => {
                button.style.color = 'white';
            });

            allAddLineButtons.forEach(button => {
                button.style.color = 'white';
                button.style.textDecoration = 'underline';
            });

            state.crossColor = "white"
        } else {
            console.log('On met en noir')
            allDeleteButtons.forEach(button => {
                button.style.color = 'black';
            });

            allAddLineButtons.forEach(button => {
                button.style.color = 'black';
                button.style.textDecoration = 'underline';
            });
            state.crossColor = "black"
        }


    }

    static updateSVGElements(svg, elementIds, color) {
        const svgChildren = svg.firstElementChild.childNodes;
        svgChildren.forEach((child) => {
            if (elementIds.includes(child.id)) {
                child.style.fill = color;
            }
        });
    }

    static scrollToTitle(tattooTitle) {
        const offset = tattooTitle.offsetTop - 175;
        window.scrollTo({
            top: offset,
            behavior: 'smooth',
        });
    }
}

function handlePlaceholder(input, groupId) {
    if (input.dataset.isModified === 'false') {
        input.innerText = '';
        // Remettre le focus sur mobile
        input.focus();

        // Placer le curseur à la fin
        const range = document.createRange();
        const sel = window.getSelection();
        range.selectNodeContents(input);
        range.collapse(false); // à la fin
        sel.removeAllRanges();
        sel.addRange(range);
    }

    document.querySelectorAll('.div-input-content-' + groupId).forEach((element) => (element.dataset.isselected = 'false'));

    input.dataset.isselected = 'true';

    console.log(document.querySelectorAll('.div-input-content-' + groupId));


}

function restorePlaceholder(input) {
    if (input.innerText.trim() === '') {
        input.dataset.isModified = 'false';
    } else {
        input.dataset.isModified = 'true';
    }

    updateResumeTattoo();
}


function checkInputLength(input) {
    const heartsCount = (input.value.match(/♡/g) || []).length;
    const textLength = input.value.length - heartsCount; // Longueur sans les cœurs
    const effectiveLength = textLength + heartsCount * CONSTANTS.HEART_LENGTH;

    if (effectiveLength > CONSTANTS.MAX_CHARS) {
        // Si on dépasse, on tronque la valeur
        const excess = effectiveLength - CONSTANTS.MAX_CHARS;
        input.value = input.value.slice(0, -excess);
    }
}

function adjustGroupFontSize(groupId) {
    const maxFontSize = 0.8;
    const minFontSize = 0.5;
    const step = 0.05;

    const group = document.getElementById(groupId);
    const inputs = group.querySelectorAll('.div-input-content');

    inputs.forEach((input) => {
        checkInputLength(input);
        input.style.fontSize = `${maxFontSize}rem`;
    });

    let fontSize = maxFontSize;
    while (Array.from(inputs).some((input) => input.scrollWidth > input.clientWidth) && fontSize > minFontSize) {
        fontSize -= step;
        inputs.forEach((input) => (input.style.fontSize = `${fontSize}rem`));
    }
}

function displayAddNewLine(groupId) {
    const element = document.getElementById(`add-line-${groupId}`);
    const group = document.getElementById('svg-' + groupId);
    const inputs = group.getElementsByClassName('input-text-left-group');
    element.style.display = inputs.length < CONSTANTS.MAX_INPUTS ? 'block' : 'none';
}

// Initialize
document.addEventListener('DOMContentLoaded', async () => {
    InputManager.updateInputListeners();

    try {
        const cartData = await fetch('/cart.js').then((response) => response.json());
        cartData.items.forEach((item) => {
            const badgeElement = document.getElementById(`variant-quantity-${item.id}`);
            if (badgeElement) {
                badgeElement.textContent = item.quantity > 0 ? item.quantity : '';
            }
        });
    } catch (error) {
        console.error('Erreur lors de la récupération du panier :', error);
    }
});


// Fonctions pour la modale
let josetteModalTrigger = null;

function handleJosetteModalKeydown(event) {
    if (event.key === 'Escape') closeJosetteModal();
}

function openJosetteModal(trigger) {
    const modal = document.getElementById('josette-modal');
    if (!modal) return;

    josetteModalTrigger = trigger || null;
    modal.style.display = 'flex';
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden'; // bloque le scroll
    document.addEventListener('keydown', handleJosetteModalKeydown);

    const closeButton = modal.querySelector('.close-button');
    if (closeButton) closeButton.focus();
}

function closeJosetteModal() {
    const modal = document.getElementById('josette-modal');
    if (!modal) return;

    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = ''; // rend le scroll au thème
    document.removeEventListener('keydown', handleJosetteModalKeydown);

    // Rend le focus au bouton « Choisir ma josette » qui a ouvert la modale.
    if (josetteModalTrigger) {
        josetteModalTrigger.focus();
        josetteModalTrigger = null;
    }
}

// Fermeture au clic sur le voile (et pas sur le panneau lui-même).
document.addEventListener('DOMContentLoaded', function () {
    const modal = document.getElementById('josette-modal');
    if (!modal) return;

    modal.addEventListener('click', function (event) {
        if (event.target === modal) closeJosetteModal();
    });
});

function updateTotalPrice() {
    const resumeTattoo = document.getElementById('resume-tattoo-desktop');
    const resumeTattooMobile = document.getElementById('resume-tattoo-mobile');
    const resumeProduct = document.getElementById('resume-product-desktop');
    const resumeProductMobile = document.getElementById('resume-product-mobile');
    const totalPrice = document.getElementById('resume-total-price-desktop');
    const totalPriceMobile = document.getElementById('resume-total-price-mobile');

    if (resumeTattoo.dataset.isModified === 'true' && resumeProduct.dataset.isModified === 'true') {
        totalPrice.innerHTML =
            'Total : ' + (Number(resumeTattoo.dataset.tattooPrice) + Number(resumeProduct.dataset.productPrice)) + '€';
        console.log(resumeProduct.dataset.productPrice);
    } else if (resumeTattoo.dataset.isModified === 'true') {
        totalPrice.innerHTML = 'Total : ' + resumeTattoo.dataset.tattooPrice + '€';
    } else if (resumeProduct.dataset.isModified === 'true') {
        totalPrice.innerHTML = 'Total : ' + resumeProduct.dataset.productPrice + '€';
    } else {
        totalPrice.innerHTML = 'Total : 0€';
    }

    if (resumeTattooMobile.dataset.isModified === 'true' && resumeProductMobile.dataset.isModified === 'true') {
        totalPriceMobile.innerHTML =
            'Total : ' +
            (Number(resumeTattooMobile.dataset.tattooPrice) + Number(resumeProductMobile.dataset.productPrice)) +
            '€';
    } else if (resumeTattooMobile.dataset.isModified === 'true') {
        totalPriceMobile.innerHTML = 'Total : ' + resumeTattooMobile.dataset.tattooPrice + '€';
    } else if (resumeProductMobile.dataset.isModified === 'true') {
        totalPriceMobile.innerHTML = 'Total : ' + resumeProductMobile.dataset.productPrice + '€';
    } else {
        totalPriceMobile.innerHTML = 'Total : 0€';
    }
}

function updateResumeProductName(productName) {
    newText = productName + ' - 14€';
    document.getElementById('resume-product-desktop').innerHTML = newText;
    document.getElementById('resume-product-desktop').setAttribute('data-is-modified', true);
    document.getElementById('resume-product-desktop').dataset.productPrice = 14;
    document.getElementById('resume-product-mobile').innerHTML = newText;
    document.getElementById('resume-product-mobile').setAttribute('data-is-modified', true);
    document.getElementById('resume-product-mobile').dataset.productPrice = 14;
    updateTotalPrice();
}

function updateResumeTattoo() {
    const inputLeft = document.querySelectorAll('.div-input-content-left-group')
    const inputRight = document.querySelectorAll('.div-input-content-right-group')
    const resumeTattoo = document.getElementById('resume-tattoo-desktop');
    const resumeTattooMobile = document.getElementById('resume-tattoo-mobile');
    let isLeftIsTattoo = false;
    let isRightIsTattoo = false;


    inputLeft.forEach((input) => {
        if (input.dataset.isModified === 'true') {
            isLeftIsTattoo = true;
        }
    });

    inputRight.forEach((input) => {
        if (input.dataset.isModified === 'true') {
            isRightIsTattoo = true;
        }
    });

    if (isLeftIsTattoo && isRightIsTattoo) {
        resumeTattoo.innerHTML = 'Tattoo gauche + tattoo droit = 15€';
        resumeTattooMobile.innerHTML = 'Tattoo gauche + tattoo droit = 15€';
        resumeTattoo.setAttribute('data-is-modified', true);
        resumeTattooMobile.setAttribute('data-is-modified', true);
        resumeTattoo.dataset.tattooPrice = 15;
        resumeTattooMobile.dataset.tattooPrice = 15;
        updateTotalPrice();
    } else if (isLeftIsTattoo) {
        resumeTattoo.innerHTML = 'Tattoo gauche = 8€';
        resumeTattooMobile.innerHTML = 'Tattoo gauche = 8€';
        resumeTattoo.setAttribute('data-is-modified', true);
        resumeTattooMobile.setAttribute('data-is-modified', true);
        resumeTattoo.dataset.tattooPrice = 8;
        resumeTattooMobile.dataset.tattooPrice = 8;
        updateTotalPrice();
    } else if (isRightIsTattoo) {
        resumeTattoo.innerHTML = 'Tattoo droit = 8€';
        resumeTattooMobile.innerHTML = 'Tattoo droit = 8€';
        resumeTattoo.setAttribute('data-is-modified', true);
        resumeTattooMobile.setAttribute('data-is-modified', true);
        resumeTattoo.dataset.tattooPrice = 8;
        resumeTattooMobile.dataset.tattooPrice = 8;
        updateTotalPrice();
    } else {
        resumeTattoo.innerHTML = 'Aucun tattoo sélectionné';
        resumeTattooMobile.innerHTML = 'Aucun tattoo sélectionné';
        resumeTattoo.setAttribute('data-is-modified', false);
        resumeTattooMobile.setAttribute('data-is-modified', false);
        resumeTattoo.dataset.tattooPrice = 0;
        resumeTattooMobile.dataset.tattooPrice = 0;
        updateTotalPrice();
    }

}

function addVariantIdOnAddToCartButtonDataset(variantID) {
    addToCartButtonMobile = document.getElementById('add_to_cart_tattoo_mobile');
    addToCartButtonMobile.dataset.variantId = variantID;
    addToCartButtonDesktop = document.getElementById('add_to_cart_tattoo_desktop');
    addToCartButtonDesktop.dataset.variantId = variantID;
}

function getModifiedInputsMerged(groupClass, propertyName, color, font) {
    const inputs = document.querySelectorAll(`.${groupClass}`);
    const lines = [];

    inputs.forEach((input) => {
        if (input.dataset.isModified === 'true' && input.value.trim() !== '') {
            lines.push(input.value.trim());
        }
    });

    if (lines.length === 0) return {}; // aucun texte modifié

    // Ajouter la couleur et la police uniquement si des lignes existent
    if (color) lines.push(`Couleur : ${color}`);
    if (font) lines.push(`Police : ${font}`);

    // Fusionner toutes les lignes avec un retour à la ligne
    return {[propertyName]: lines.join('\r\n')};
}

// Fonction pour transformer 1,2,3... en First, Second, Third, Fourth...
function ordinal(n) {
    const ordinals = ['1er', '2eme', '3eme', '4eme', '5eme', '6eme', '7eme'];
    return ordinals[n - 1] || n + 'th';
}

function generateIdForTattoo() {
    const date = new Date().toISOString().slice(0, 10).replace(/-/g, '');
    const random = Math.random().toString(36).substring(2, 8).toUpperCase();
    return `TAT-${date}-${random}`;
}

/* function AddTattooToCartMobile() {

    

    addToCartButton = document.getElementById('add_to_cart_tattoo_mobile');
    // Récupérer les inputs modifiés
    const leftProperties = getModifiedInputsMerged(
        'input-text-left-group',
        'Tatouage gauche',
        state.leftFontNameColor,
        state.leftFont
    );
    const rightProperties = getModifiedInputsMerged(
        'input-text-right-group',
        'Tatouage droit',
        state.leftFontNameColor,
        state.leftFont
    );

    newIdForTattoo = generateIdForTattoo();

    const goodProperties = {
        tattooId: newIdForTattoo,
        ...leftProperties,
        ...rightProperties,
    };

    // Supprimer la couleur et la police si aucun texte pour le pied gauche
    if (Object.keys(leftProperties).length === 0) {
        delete goodProperties['G-Couleur'];
        delete goodProperties['G-Police'];
    }

    // Supprimer la couleur et la police si aucun texte pour le pied droit
    if (Object.keys(rightProperties).length === 0) {
        delete goodProperties['D-Couleur'];
        delete goodProperties['D-Police'];
    }

    if (Object.keys(rightProperties).length === 0 || Object.keys(leftProperties).length === 0) {
        oneOrTwoFootTattoo = 1;
    } else {
        oneOrTwoFootTattoo = 2;
    }

    // Produit à ajouter (met le bon variant_id ici)
    const variantId = addToCartButton.dataset.variantId;

    // Appel AJAX vers Shopify
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: goodProperties,
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            console.log('Produit ajouté :', data);
            addProductTattooInCart(oneOrTwoFootTattoo);
            // Optionnel : rediriger vers panier
            // window.location.href = '/cart.js';
        })
        .catch((err) => console.error('Erreur ajout panier :', err));
}

function AddTattooToCartDesktop() {
    addToCartButton = document.getElementById('add_to_cart_tattoo_desktop');
    // Récupérer les inputs modifiés
    const leftProperties = getModifiedInputsMerged(
        'input-text-left-group',
        'Tatouage gauche',
        state.leftFontNameColor,
        state.leftFont
    );
    const rightProperties = getModifiedInputsMerged(
        'input-text-right-group',
        'Tatouage droit',
        state.leftFontNameColor,
        state.leftFont
    );

    newIdForTattoo = generateIdForTattoo();

    const goodProperties = {
        tattooId: newIdForTattoo,
        ...leftProperties,
        ...rightProperties,
    };

    // Supprimer la couleur et la police si aucun texte pour le pied gauche
    if (Object.keys(leftProperties).length === 0) {
        delete goodProperties['G-Couleur'];
        delete goodProperties['G-Police'];
    }

    // Supprimer la couleur et la police si aucun texte pour le pied droit
    if (Object.keys(rightProperties).length === 0) {
        delete goodProperties['D-Couleur'];
        delete goodProperties['D-Police'];
    }

    if (Object.keys(rightProperties).length === 0 || Object.keys(leftProperties).length === 0) {
        oneOrTwoFootTattoo = 1;
    } else {
        oneOrTwoFootTattoo = 2;
    }

    // Produit à ajouter (met le bon variant_id ici)
    const variantId = addToCartButton.dataset.variantId;

    // Appel AJAX vers Shopify
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            id: variantId,
            quantity: 1,
            properties: goodProperties,
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            console.log('Produit ajouté :', data);
            addProductTattooInCart(oneOrTwoFootTattoo);
            // Optionnel : rediriger vers panier
            // window.location.href = '/cart.js';
        })
        .catch((err) => console.error('Erreur ajout panier :', err));
} */


function addToCart(buttonId) {
    console.log("Panier : " + buttonId)

    const addToCartButton = document.getElementById(buttonId);
    const variantId = addToCartButton.dataset.variantId;

    if (!variantId) {
        showModal("Vous n'avez pas sélectionné votre josette à tatouer")

        return;
    }


    
    

    leftTattooBrut = document.querySelectorAll('.div-input-content-left-group');
    rightTattooBrut = document.querySelectorAll('.div-input-content-right-group');

    console.log(leftTattooBrut);

    leftTattoo = [];
    rightTattoo = [];

    isTattooExceedLimit = false;
    let hasUnauthorizedEmojiFlag = false;
    let problematicInput = null;


    leftTattooBrut.forEach((input) => {
        if (input.dataset.isModified === 'true') {

            if (getElementLength(input) > 9) {
                isTattooExceedLimit = true
            }

            if (hasUnauthorizedEmoji(input)) {
                hasUnauthorizedEmojiFlag = true;
                problematicInput = input;
            }


            leftTattoo.push(input);
        }
    });

    rightTattooBrut.forEach((input) => {
        if (input.dataset.isModified === 'true') {

            if (getElementLength(input) > 9) {
                isTattooExceedLimit = true
            }

            if (hasUnauthorizedEmoji(input)) {
                hasUnauthorizedEmojiFlag = true;
                problematicInput = input;
            }


            rightTattoo.push(input);
        }
    });

    if (isTattooExceedLimit === true) {
        showModal("Attention, vous dépassez le nombre de caractère pour cette ligne : " + input.innerText + " !")

        return;
    }

    if (hasUnauthorizedEmojiFlag === true) {
        showModal("Attention, seul le cœur ♡ est autorisé comme emoji !");
    return;
}

    let oneOrTwoFoot = 0

    if (leftTattoo.length === 0 || rightTattoo.length === 0) {
        oneOrTwoFoot = 1;
    } else {
        oneOrTwoFoot = 2;
    }

    console.log(leftTattoo);
    console.log(rightTattoo);

    if (leftTattoo.length === 0 && rightTattoo.length === 0) {

        showModal("Attention, vous n\'avez pas écrit de texte !")

        return;
    }

    // Ajouter et animer le GIF
        const gifElement = document.createElement('img');
        gifElement.src = 'https://cdn.shopify.com/s/files/1/0842/4951/0153/files/add-cart.gif?v=1760610042';
        gifElement.classList.add('add-cart-animation');

        // Positionner le GIF au-dessus du variant
        addToCartButton.style.position = 'relative';
        gifElement.style.top = '-75px'; // Ajuster selon votre besoin
        gifElement.style.left = '50%';
        gifElement.style.transform = 'translateX(-50%)';
        gifElement.style.width = '25px!important'; 
        gifElement.style.height = '25px!important'; 

        addToCartButton.appendChild(gifElement);

        // Retirer le GIF après l'animation
        setTimeout(() => {
            gifElement.remove();
        }, 3000);


    console.log(oneOrTwoFoot + " pieds")

    // Convertir les divs modifiées en texte avec retours à la ligne
    const leftTattooText = leftTattoo
        .map(input => input.textContent.trim())
        .filter(text => text !== '')
        .join('\n');

    const rightTattooText = rightTattoo
        .map(input => input.textContent.trim())
        .filter(text => text !== '')
        .join('\n');

    console.log(leftTattooText)
    console.log(rightTattooText)


    // Déterminer la présence d’un cœur ♡ dans les divs
    const leftHeartPresent = leftTattoo.some(div => div.innerText.includes('♡'));
    const rightHeartPresent = rightTattoo.some(div => div.innerText.includes('♡'));

// Texte formaté pour chaque pied
    const leftTattooDetails = leftTattooText
        ? `Texte : ${leftTattooText}
Couleur : ${state.leftFontNameColor}
Police : ${state.leftFont}
${leftHeartPresent ? `Couleur cœur : ${state.leftHeartColorName}` : ''}`.trim()
        : null;

    const rightTattooDetails = rightTattooText
        ? `Texte : ${rightTattooText}
Couleur : ${state.rightFontNameColor}
Police : ${state.rightFont}
${rightHeartPresent ? `Couleur cœur : ${state.rightHeartColorName}` : ''}`.trim()
        : null;

// Crée l’objet properties
    const properties = {};

    let newIdForTattoo = generateIdForTattoo();
    properties["TatouageId"] = newIdForTattoo;

    if (leftTattooDetails) {
        properties["TatouageGauche"] = leftTattooDetails;
    }

    if (rightTattooDetails) {
        properties["TatouageDroit"] = rightTattooDetails;
    }


    
    //ID boutique de test
    //let oneFeet = 56091443822857;
    //let twoFoot = 56091443855625;

    //ID boutique de prod
    let oneFeet = 53140652654921;
    let twoFoot = 53140652687689;


    let tattooVariantId = 0;

    if (oneOrTwoFoot === 1) {
        tattooVariantId = oneFeet;
    } else {
        tattooVariantId = twoFoot;
    }


    let tattooVariantIdProperties = {};
    tattooVariantIdProperties['TatouageId'] = newIdForTattoo;

    console.log(properties);
    console.log(tattooVariantIdProperties);

    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            items: [
                {
                    id: variantId,
                    quantity: 1,
                    properties: properties
                },
                {
                    id: tattooVariantId,
                    quantity: 1,
                    properties: tattooVariantIdProperties
                }
            ]
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            console.log('🎉 Produits ajoutés :', data);

            // Mettre à jour le nombre d'articles dans le panier
                    fetch('/cart.js')
                        .then(response => response.json())
                        .then(cartData => {
                            updateCartCount(cartData.item_count);

                            const badgeElement = document.getElementById(`variant-quantity-${variantId}`);
                            if (badgeElement) {
                                const currentQuantity = parseInt(badgeElement.textContent) || 0;
                                badgeElement.textContent = currentQuantity + 1;
                            }
                        });



            
            /* Rafraîchit le tiroir panier et l'ouvre. CartDrawer.onCartRefresh
               (assets/cart-drawer.js) refait un GET de la section cart-drawer,
               remplace son HTML et met le compteur à jour.

               On ne passe pas par PUB_SUB_EVENTS.cartUpdate : son gestionnaire
               lit parsedState.sections, absent de la réponse d'un /cart/add.js
               nu comme celui ci-dessus. */
            document.dispatchEvent(
                new CustomEvent('cart:refresh', { detail: { open: true } })
            );

            displayErrorSuccessMessage('success', 'Tatouage ajouté au panier')
        
            setTimeout(() => {
                deleteErrorSuccessMessage('success');
                }, 5000);

            })
        .catch((err) => console.error('❌ Erreur ajout panier :', err));

}

function displayErrorSuccessMessage(type, message) {
    const messageDivs = document.querySelectorAll('.cart-' + type + '-message');

    messageDivs.forEach(div => {
        div.textContent = message;
    });
}

function deleteErrorSuccessMessage(type) {
     const messageDivs = document.querySelectorAll('.cart-' + type + '-message');

    messageDivs.forEach(div => {
        div.textContent = '';
    });
}


function addProductTattooInCart(oneOrTwoFoot) {
    oneFeet = 56091443822857;
    twoFoot = 56091443855625;

    if (oneOrTwoFoot === 1) {
        variantId = oneFeet;
    } else {
        variantId = twoFoot;
    }

    // Appel AJAX vers Shopify
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            id: variantId,
            quantity: 1,
        }),
    })
        .then((res) => res.json())
        .then((data) => {
            console.log('Produit ajouté :', data);
            // Optionnel : rediriger vers panier
            // window.location.href = '/cart.js';
        })
        .catch((err) => console.error('Erreur ajout panier :', err));
}

document.addEventListener('DOMContentLoaded', function () {
    //AFFICHER LES HISTOIRES DES CLIENTS (PAS DE RANDOM SUR CETTE VERSION)

    /*const productts = document.querySelectorAll('.collection-one-product');
        const insertHTML = `<div style="width: 23%; margin-right: 1%; margin-left: 1%;">
                                <img src="{{ 'histoire-client-1.jpg' | asset_url }}" alt="" style="width: 100%; object-fit: contain; aspect-ratio: 1 / 1;">
                        </div>`;

    for (let i = 9; i < productts.length; i += 10) {
      const div = document.createElement('div');
      div.innerHTML = insertHTML;
      productts[i].parentNode.insertBefore(div.firstChild, productts[i].nextSibling);
    }*/

    // -----------------
    //AU HOVER SUR UN PRODUIT, AFFICHER LA DEUXIÈME IMAGE

    // Les URLs viennent de tattoo.liquid : Liquid n'est pas interprété ici.
    const josetteModal = document.getElementById('josette-modal');
    const images = josetteModal
        ? [josetteModal.dataset.photo1, josetteModal.dataset.photo2].filter(Boolean)
        : [];

    const products = document.querySelectorAll('.collection-one-product img');

    if (images.length > 0) {
        products.forEach((product) => {
            const randomImage = images[Math.floor(Math.random() * images.length)];
            product.style.backgroundImage = `url('${randomImage}')`;
        });
    }

    const containers = document.querySelectorAll('.display-images-josettes-multi');

    containers.forEach(function (container) {
        const images = container.querySelectorAll('img');
        const image1 = images[0];
        const image2 = images[1];

        container.addEventListener('mouseenter', function () {
            image1.style.display = 'none';
            image2.style.display = 'block';
        });

        container.addEventListener('mouseleave', function () {
            image1.style.display = 'block';
            image2.style.display = 'none';
        });
    });

    // ---------------
});

//Ajouter les variantes directement au panier

function updateCartCount(newCount) {
    // Sélectionner tous les éléments avec la classe .cart-count-bubble
    const cartCountBubbles = document.querySelectorAll('.cart-count-bubble');
    const cartIcons = document.querySelectorAll('.header__icon--cart');

    // Si aucune bulle n'existe et que la quantité est supérieure à 0, ajoutez-en une
    if (cartCountBubbles.length === 0 && newCount > 0) {
        cartIcons.forEach((cartIcon) => {
            cartIcon.insertAdjacentHTML(
                'beforeend',
                '<div class="cart-count-bubble" style="display:flex"><span aria-hidden="true">' + newCount + '</span></div>'
            );
        });
    } else {
        // Boucler à travers chaque bulle de compteur existante pour la mettre à jour
        cartCountBubbles.forEach((cartCountBubble) => {
            if (newCount > 0) {
                cartCountBubble.style.display = 'flex'; // S'assurer que le compteur est visible
                cartCountBubble.innerHTML = `<span aria-hidden="true">${newCount}</span>`;
            } else {
                cartCountBubble.style.display = 'none'; // Masquer si le panier est vide
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    // Vérifie le panier via une API Shopify
    fetch('/cart.js')
        .then((response) => response.json())
        .then((data) => {
            data.items.forEach((item) => {
                const badgeElement = document.getElementById(`variant-quantity-${item.id}`);
                if (badgeElement) {
                    badgeElement.textContent = item.quantity > 0 ? item.quantity : ''; // Met à jour la quantité
                }
            });
        })
        .catch((error) => console.error('Erreur lors de la récupération du panier :', error));
});


// Font Manager Class
class FontManager {
    static changeFontFamily(groupId, fontFamily) {
        const group = document.getElementById(groupId);
        const inputs = Array.from(group.getElementsByClassName('div-input-content-' + groupId));
        inputs.forEach((input) => (input.style.fontFamily = fontFamily));

        const firstPart = fontFamily.split(',')[0].trim(); // "Borel"
        if (groupId === 'left-group') {
            state.leftFont = firstPart;
        } else {
            state.rightFont = firstPart;
        }
    }

    static changeInputColor(e, groupId, color, nameColor) {
        if (groupId === 'left-group') {
            state.leftFontColor = color;
            state.leftFontNameColor = nameColor;
            const colorName = state.leftFontNameColor || '';
            document.getElementById('name-color-text-left-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);

            if (state.isLeftColorHeartSameFont) {
                document.getElementById('name-color-heart-left-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);
            }
        } else {
            state.rightFontColor = color;
            state.rightFontNameColor = nameColor;
            const colorName = state.rightFontNameColor || '';
            document.getElementById('name-color-text-right-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);

            if (state.isRightColorHeartSameFont) {
                document.getElementById('name-color-heart-right-group').innerText = colorName.charAt(0).toUpperCase() + colorName.slice(1);
            }
        }

        const inputs = document.querySelectorAll('.div-input-content-' + groupId);

        inputs.forEach((heart) => {
            heart.style.color = color + "!important";
        })

        // Reset all color elements
        const colorElements = e.parentNode.querySelectorAll('div');
        colorElements.forEach((element) => (element.style.boxShadow = 'none'));

        // Highlight selected color
        e.style.boxShadow = 'inset 0 0 0 2px black';

        // Apply color to inputs
        inputs.forEach((input) => (input.style.color = color));
        state.inputColor = color;

        changeHeartDisplayColorSameText(groupId, color, nameColor);
    }
}


class ContentManager {
    static contentLimitBeforeInput(e, el, max) {
        const divLength = getElementLength(el);

        if (divLength >= max && e.inputType !== 'deleteContentBackward' && e.inputType !== 'deleteContentForward') {
            e.preventDefault();
        }
        if (e.inputType === 'insertLineBreak' || e.inputType === 'insertParagraph') {
            e.preventDefault();
        }
    }

    static handlePaste(e, el, max) {
        e.preventDefault();

        // Récupère le texte brut du presse-papier
        const paste = (e.clipboardData || window.clipboardData).getData('text');

        // Nettoie et coupe selon la limite
        const divLength = getElementLength(el);
        const spaceLeft = max - divLength;
        const textToInsert = paste.substring(0, spaceLeft);

        // Insère le texte manuellement (sans style)
        const selection = window.getSelection();
        if (!selection.rangeCount) return;
        selection.deleteFromDocument();
        selection.getRangeAt(0).insertNode(document.createTextNode(textToInsert));

        // Forcer la normalisation du contenu
        el.normalize();

        // Réappliquer la taille de police correcte (celle commune à tes divs)
        const refDiv = document.querySelector('.input-text-div-editcontent');
        if (refDiv) {
            el.style.fontSize = refDiv.style.fontSize;
            el.style.fontFamily = refDiv.style.fontFamily;
        }

        // Lancer le recalcul si le texte colle dépasse la div
        adjustFontSize(el);
    }
}


// function adjustFontSize(el) {
//     let fontSize = 13;
//     el.style.fontSize = fontSize + "px";

//     // Réduire la taille tant que le texte dépasse la largeur
//     while (el.scrollWidth > el.clientWidth && fontSize > 5) {
//         fontSize--;
//         el.style.fontSize = fontSize + "px";
//     }

//     // Récupérer la taille finale appliquée
//     const finalFontSize = el.style.fontSize;

//     // Appliquer cette même taille à toutes les divs similaires
//     const allInputs = document.querySelectorAll('.input-text-div-editcontent');
//     allInputs.forEach(div => {
//         div.style.fontSize = finalFontSize;
//     });
// }

function adjustFontSize(el) {
    const DEFAULT_SIZE = 16;
    const MIN_SIZE = 5;

    const allInputs = document.querySelectorAll('.input-text-div-editcontent');

    // Récupérer la plus petite taille actuellement appliquée
    let currentGlobalSize = DEFAULT_SIZE;
    allInputs.forEach(div => {
        const size = parseFloat(getComputedStyle(div).fontSize);
        if (size < currentGlobalSize) currentGlobalSize = size;
    });

    // Appliquer la taille actuelle à l'élément pour partir d'une base cohérente
    el.style.fontSize = currentGlobalSize + "px";

    // --- RÉDUCTION SI DÉPASSE ---
    let fontSize = currentGlobalSize;
    while (el.scrollWidth > el.clientWidth && fontSize > MIN_SIZE) {
        fontSize--;
        el.style.fontSize = fontSize + "px";
    }

    // --- MARQUAGE DES DÉPASSEMENTS ---
    el.dataset.isLong = el.scrollWidth > el.clientWidth ? "true" : "false";

    // --- SI LA TAILLE A ÉTÉ RÉDUITE, PROPAGER ---
    if (fontSize < currentGlobalSize) {
        allInputs.forEach(div => {
            div.style.fontSize = fontSize + "px";
            div.dataset.isLong = div.scrollWidth > div.clientWidth ? "true" : "false";
        });
        return; // on sort ici, inutile de remonter
    }

    // --- VÉRIFICATION SI AUCUNE DIV NE DÉPASSE ---
    const hasOverflow = Array.from(allInputs).some(div => div.scrollWidth > div.clientWidth);

    // --- SI PLUS AUCUNE DIV NE DÉPASSE, ON AGRANDIT PROGRESSIVEMENT ---
    if (!hasOverflow && currentGlobalSize < DEFAULT_SIZE) {
        let newSize = currentGlobalSize;
        // On augmente jusqu’à ce que ça dépasse à nouveau ou qu’on atteigne la taille par défaut
        while (newSize < DEFAULT_SIZE) {
            newSize++;
            let overflowDetected = false;
            allInputs.forEach(div => {
                div.style.fontSize = newSize + "px";
                if (div.scrollWidth > div.clientWidth) overflowDetected = true;
            });
            if (overflowDetected) {
                newSize--; // revenir à la dernière taille valide
                break;
            }
        }

        // Appliquer la taille maximale valide à tout le monde
        allInputs.forEach(div => {
            div.style.fontSize = newSize + "px";
            div.dataset.isLong = "false";
        });
    }
}



function getElementLength(element) {
    content = element.innerText;


    const heartCount = (content.match(/♡/g) || []).length;
    const textLength = content.length - heartCount;
    const totalLength = textLength + (heartCount * CONSTANTS.HEART_LENGTH);

    return totalLength;
    // return {
    //     hearts: heartCount,
    //     text: textLength,
    //     total: totalLength
    // };
}

function hasUnauthorizedEmoji(element) {
    const content = element.innerText;
    
    // NB: ne PAS utiliser \p{Emoji} : cette propriété inclut les chiffres 0-9,
    // '#' et '*' (bases des emojis keycap 0️⃣, #️⃣...), ce qui bloquait la saisie
    // de chiffres. \p{Extended_Pictographic} ne matche que les vrais pictogrammes.
    const emojiRegex = /[\p{Extended_Pictographic}]/gu;
    
    const matches = content.match(emojiRegex) || [];
    
    // Filtrer pour garder uniquement ceux qui ne sont pas le cœur autorisé
    const unauthorizedEmojis = matches.filter(char => char !== '♡');
    
    return unauthorizedEmojis.length > 0;
}

function changeHeartDisplayColorSameText(groupId, color, nameColor) {
    const elementToChangeColor = document.getElementById('heart-color-same-text-' + groupId);
    if (elementToChangeColor) {
        elementToChangeColor.style.backgroundColor = color;

        const newOnClick = `changeHeartColor(this, '${groupId}', '${color}', '${nameColor}')`;
        elementToChangeColor.setAttribute('onclick', newOnClick);
    }
}

// Expose necessary functions to global scope for HTML event handlers
window.handlePlaceholder = handlePlaceholder;
window.restorePlaceholder = restorePlaceholder;
window.adjustGroupFontSize = adjustGroupFontSize;
window.displayAddNewLine = displayAddNewLine;
window.addInput = InputManager.addInput;
window.deleteInput = InputManager.deleteInput;
window.changeFontFamily = FontManager.changeFontFamily;
window.changeInputColor = FontManager.changeInputColor;
window.addHeart = HeartManager.addHeart;
window.changeHeartColor = HeartManager.changeHeartColor;
window.changeColorSVG = SVGManager.changeColorSVG;
window.ceLimitBeforeInput = ContentManager.contentLimitBeforeInput;
window.handlePaste = ContentManager.handlePaste;
window.ceNormalizeAfterInput = ContentManager.contentNormalizeAfterInput;

// Détecte Safari (macOS et iOS)
  const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

  if(isSafari) {
    document.getElementById('main-tattoo-container').style.display = 'none';
    const warning = document.createElement('div');
    warning.style.color = 'black';
    warning.style.marginTop = '50px';
    warning.style.marginBottom = '50px';
    warning.style.width = '100%';
    warning.style.textAlign = "center";
    warning.style.textDecoration = "underline";
    warning.style.fontWeight = 'bold';
    warning.innerText = "Votre navigateur Safari ne prend pas correctement en charge cette visualisation. Veuillez tester sur Chrome, Firefox ou Edge.";
    document.body.appendChild(warning);
  }
